// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    en: {
        translation: {
            home: 'Home',
            aboutUs: 'About Us',
            sriLankanav: 'Sri Lanka',
            gallerynav: 'Gallery',
            bookATour: 'Book a Tour',
            thingsToDo: 'Things to Do',
            contactUs: 'Contact Us',
        },
        contactus: {
            heroTitle: 'Contact Us',
            heroSubtitle: 'Aamy Tours Sri Lanka - Your Gateway to Unforgettable Sri Lankan Adventures',

            feelFree: 'Feel Free To Contact Us',
            planDream: 'Plan Your Dream Sri Lankan Adventure',
            reachOutDesc: 'Reach out to Aamy Tours Sri Lanka for personalized tour packages, expert guidance, and unforgettable travel experiences across Sri Lanka.',

            callCenter: 'Call Center',
            phone: '+94 77 048 3364',
            emailTitle: 'Email',
            email: 'aamytourssl@gmail.com',
            locationTitle: 'Our Location',
            location: '81/31h H.K Edmond Mawatha, Milidduwa, Galle, Sri Lanka.',
            socialTitle: 'Social Network',

            getInTouch: 'Get In Touch',
            getInTouchDesc: 'Discover Sri Lanka with Aamy Tours Sri Lanka — we’re here 24/7 to make your journey unforgettable.',

            nameLabel: 'Name',
            namePlaceholder: 'Your full name',
            emailLabel: 'Email',
            emailPlaceholder: 'you@example.com',
            phoneLabel: 'Contact Number',
            phonePlaceholder: '+94 7X XXX XXXX',
            messageLabel: 'Message',
            messagePlaceholder: 'Tell us about your dream trip...',

            sendButton: 'Send Message',
            sendingButton: 'Sending...',
            successMsg: 'Your inquiry has been sent via WhatsApp!',
            errorMsg: 'Failed to open WhatsApp. Please try again.',

            findUsTitle: 'Find Us in Galle',
        },
        // Add this inside the resources object in i18n.js
        thingstodo: {
            heroTitle: 'Things to Do in Sri Lanka',
            heroSubtitle: 'Adventure, Culture & Wellness',

            sectionTitle: 'Things to Do in Sri Lanka',

            // Activity titles (used in cards)
            ayurveda: 'Ayurveda - Ancient Science of Life',
            diving: 'Diving in Sri Lanka',
            elephantRide: 'Elephant Back Ride',
            fishing: 'Fishing in Sri Lanka',
            ballooning: 'Ballooning in Sri Lanka',
            jeepSafari: 'Jeep Safari',
            whiteWaterRafting: 'White Water Rafting',
            riverSafari: 'River Safari',
            snorkeling: 'Snorkeling in Sri Lanka',
            teaTasting: 'Tea Tasting Tour',
            templeVisit: 'Temple Visit',
            wildlifeSafari: 'Wildlife Safari',

            viewMore: 'View More',
        },
        // Add inside en, ru, ar objects in resources
        gallery: {
            heroTitle: 'Gallery',
            heroSubtitle: 'Moments Captured, Memories Cherished — our gallery showcases the adventures, smiles, and breathtaking views that make every journey in Sri Lanka unforgettable',

            tabPlaces: 'Places',
            tabEvents: 'Events',

            // Image labels (used in alt text and overlay)
            nuwaraEliya: 'Nuwara Eliya',
            sigiriya: 'Sigiriya',
            anuradhapura: 'Anuradhapura',
            rambodaFalls: 'Ramboda Falls',
            ella: 'Ella',
            yala: 'Yala National Park',
            kandy: 'Kandy',
            bodhiViharaya: 'Bodhi Viharaya',
            knuckles: 'Knuckles Mountain Range',
            udawalawe: 'Udawalawe National Park',
            bentota: 'Bentota Boat Safari',
            colombo: 'Colombo',
            galle: 'Galle Fort',
            mirissa: 'Mirissa Beach',
            jaffna: 'Jaffna',
            ambuluwawaTower: 'Ambuluwawa Tower',
            turtle: 'Turtle Hatchery',
            polonnaruwa: 'Polonnaruwa Ancient City',
            polgampala: 'Polgampala Water Pool',
            beach: 'Sri Lankan Beaches',
        },
        // Inside en, ru, ar → resources
        events: {
            heroTitle: 'Events',
            heroSubtitle: 'Celebrate the Spirit of Sri Lanka Through Its Festivals — from sacred Buddhist ceremonies to colorful cultural parades, every event is a chance to experience the heartbeat of the island.',

            tabPlaces: 'Places',
            tabEvents: 'Events',

            // Event names
            kandyPerahera: 'Kandy Esala Perahera (The Festival of the Tooth)',
            vesak: 'Vesak Festival',
            sinhalaNewYear: 'Sinhala and Tamil New Year',
            christmas: 'Christmas',
            thaiPongal: 'Thai Pongal',
            deepavali: 'Deepavali',
            holi: 'Holi',
            poson: 'Poson Festival',
        },
        // Inside en, ru, ar → resources
        srilanka: {
            heroTitle: 'Discover Sri Lanka',
            heroSubtitle: 'Pearl of the Indian Ocean',

            sectionPlaces: 'Attractive Places in Sri Lanka',
            sectionFamous: 'Famous Things in Sri Lanka',
            viewMore: 'View More',

            // Intro paragraphs
            intro1: 'Sri Lanka, known as the "Emerald Isle", is a tropical gem celebrated for its stunning landscapes, ancient heritage, and heartfelt hospitality.',
            intro2: 'With a legacy of over two millennia, Sri Lanka is home to UNESCO-listed sites like Sigiriya’s rock fortress and the sacred city of Anuradhapura. Its cultural richness blends Buddhist, Hindu, and colonial influences, seen in its vibrant festivals and intricate architecture.',
            intro3: 'The island’s diverse terrain captivates — from rolling tea plantations in Ella to the turquoise waters of Trincomalee. National parks like Wilpattu harbor leopards, crocodiles, and rare bird species, delighting nature lovers.',
            intro4: 'For thrill-seekers, Sri Lanka offers white-water rafting, surfing in Arugam Bay, and trekking through lush jungles. Its cuisine, infused with aromatic spices, fresh fish, and jackfruit, tells a story of tradition and flavor.',
            intro5: 'From sacred pilgrimages to serene beach escapes, Sri Lanka promises an enchanting experience steeped in beauty and culture.',

            // Place names & descriptions
            sigiriya: 'Sigiriya Rock Fortress',
            sigiriyaDesc: 'UNESCO site with ancient gardens, frescoes, and breathtaking summit views.',

            templeOfTooth: 'Temple of the Tooth',
            templeOfToothDesc: 'Sacred Buddhist site housing a relic of Buddha’s tooth.',

            ella: 'Ella',
            ellaDesc: 'Hill town surrounded by tea estates, famous for Nine Arch Bridge.',

            yala: 'Yala National Park',
            yalaDesc: 'Renowned for elephants, leopards, and wildlife safaris.',

            galleFort: 'Galle Fort',
            galleFortDesc: 'Colonial fort with cobblestone streets and Dutch architecture.',

            nuwaraEliya: 'Nuwara Eliya',
            nuwaraEliyaDesc: 'Known as "Little England" with cool climate and tea plantations.',

            adamsPeak: 'Adam’s Peak',
            adamsPeakDesc: 'Sacred mountain with a unique footprint, a pilgrimage site.',

            hortonPlains: 'Horton Plains',
            hortonPlainsDesc: 'Rolling hills, waterfalls, and World’s End viewpoint.',

            bentota: 'Bentota Beach',
            bentotaDesc: 'Pristine coast with golden sands and water sports.',

            jaffna: 'Jaffna',
            jaffnaDesc: 'Rich in Tamil culture, history, and cuisine.',

            anuradhapura: 'Anuradhapura',
            anuradhapuraDesc: 'Ancient city with sacred Buddhist sites and ruins.',

            polonnaruwa: 'Polonnaruwa',
            polonnaruwaDesc: 'UNESCO site with well-preserved temples and statues.',

            unawatuna: 'Unawatuna Beach',
            unawatunaDesc: 'Vibrant beach with snorkeling and nightlife.',

            colombo: 'Colombo',
            colomboDesc: 'Bustling capital with modern and colonial architecture.',

            udawalawe: 'Udawalawe National Park',
            udawalaweDesc: 'Famous for large elephant herds and stunning landscapes.',

            dambulla: 'Dambulla Cave Temple',
            dambullaDesc: 'UNESCO site with ancient Buddhist murals and statues.',

            // Famous Things
            ceylonTea: 'Ceylon Tea',
            ceylonTeaDesc: 'World-famous for its flavor, especially from Nuwara Eliya and Uva.',

            spices: 'Spices',
            spicesDesc: 'Cinnamon, cardamom, cloves — Sri Lankan cinnamon is the best.',

            gems: 'Gems',
            gemsDesc: 'Sapphires, rubies, moonstones — island of rare gems.',

            ayurveda: 'Ayurveda',
            ayurvedaDesc: 'Wellness treatments with massages and herbal therapies.',

            handicrafts: 'Handicrafts',
            handicraftsDesc: 'Masks, batik, wood carvings, lacquerware.',

            elephants: 'Elephants',
            elephantsDesc: 'Cultural symbol, featured in grand festival processions.',

            food: 'Traditional Food',
            foodDesc: 'Rice and curry, hoppers, kottu roti, wattalappam.',

            festivals: 'Festivals',
            festivalsDesc: 'Esala Perahera, Vesak, Sinhala-Tamil New Year.',

            coconut: 'Coconut Products',
            coconutDesc: 'Oil, milk, coir fiber for ropes and mats.',

            sarees: 'Kandyan Saree',
            sareesDesc: 'Elegant traditional attire for ceremonies.',

            dances: 'Traditional Dances',
            dancesDesc: 'Kandyan, devil, and low-country dances.',

            stiltFishing: 'Stilt Fishing',
            stiltFishingDesc: 'Iconic southern coast fishing technique.',

            moonstones: 'Moonstones',
            moonstonesDesc: 'Semi-precious gems, famous Meetiyagoda mines.',

            cricket: 'Cricket',
            cricketDesc: 'National passion — 1996 World Cup winners.',

            herbs: 'Ayurvedic Herbs',
            herbsDesc: 'Gotu kola, cinnamon, neem for remedies.',

            masks: 'Masks',
            masksDesc: 'Ambalangoda masks used in ritual performances.',
        },


        ayurveda: {
            title: "Ayurveda - The Ancient Science of Life",

            introParagraph1: "The word “Ayurveda” has existed for more than three thousand years. In Sanskrit, the word means “science of life.” The technique is based on the Ayurvedic healing view of disease rather than its consequences, which usually fights European medicine. It postulates the following principles:",

            corePrinciplesTitle: "Core Principles",
            principle1: "The body should be free of energy and maintain balance for normal metabolic and cardiac activity.",
            principle2: "The body should have normal muscle contraction with regular hormonal activity.",
            principle3: "The body needs a healthy immune system to function properly.",

            sriLankaDoctors: "According to recent data, in Sri Lanka, there are more than 6,000 graduates trained in Ayurveda. They undergo seven years of study and two years of practice in public hospitals. Ayurveda programs include:",

            benefit1: "Removing stress, fatigue, and anxiety",
            benefit2: "Oxygen saturation",
            benefit3: "Stimulation of muscular systems and elimination of toxins",
            benefit4: "Restoring the balance of the nervous system",
            benefit5: "Restoring blood flow to internal organs",
            benefit6: "Producing endorphins",

            mainImageAlt: "Ayurveda Wellness",

            faceTreatmentAlt: "Ayurveda Face Treatment",
            faceTreatmentCaption: "Ayurveda Face Treatment",

            massageTreatmentAlt: "Ayurveda Massage Treatment",
            massageTreatmentCaption: "Ayurveda Massage Treatment",

            treatmentDescription: "Standard treatments include body massages and scalp massages using special oils, herbal sauna treatments, and baths infused with herbs. The most popular technique is the “Shirodhara procedure,” where warm herbal oil is rhythmically dripped on the forehead. This helps restore balance to the nervous system and achieve relaxation.",

            tipsTitle: "Tips for Ayurvedic Treatment",
            tip1: "Forget about problems. Relax and clear your mind for the best results.",
            tip2: "Choose the correct location. Select a setting that aligns with your comfort and preferences for optimal healing.",
            tip3: "Select the correct program. Discuss your concerns with the doctor and try different therapies to find what suits you best.",
            tip4: "Take a warm bath before treatment to relax your muscles and prepare your body.",
            tip5: "Eat a light meal before the procedure. Avoid heavy meals to allow proper blood flow during the massage.",
            tip6: "Relaxation after procedures is essential. Proper relaxation enhances the effectiveness of Ayurvedic treatments."
        },
        // Inside resources → en, ru, ar
        ballooning: {
            title: "Ballooning in Sri Lanka",

            introParagraph1: "Hot air ballooning in Sri Lanka offers an unforgettable experience of floating gently above the stunning landscapes of the island. Starting at sunrise, balloon rides provide breathtaking aerial views of rolling hills, lush forests, ancient ruins, and serene villages.",
            introParagraph2: "The most popular ballooning destination in Sri Lanka is Dambulla, located in the heart of the cultural triangle. Balloon rides here often take you over the iconic Sigiriya Rock Fortress, offering a perspective like no other. Flights typically last 60-90 minutes, giving you ample time to soak in the beauty of Sri Lanka from above.",

            mainImageAlt: "Hot Air Ballooning in Sri Lanka",
            mainImageCaption: "Hot Air Ballooning in Sri Lanka",

            highlightsTitle: "Why Try Hot Air Ballooning in Sri Lanka?",
            highlightsIntro: "Hot air ballooning combines adventure with tranquility, allowing you to experience Sri Lanka’s beauty in a unique way. Some of the highlights of ballooning include:",

            highlight1: "Uninterrupted panoramic views of the island’s stunning landscapes.",
            highlight2: "Flying over iconic landmarks like Sigiriya Rock and nearby lakes.",
            highlight3: "A serene and peaceful ride above lush greenery and charming villages.",
            highlight4: "Witnessing a spectacular sunrise from the sky.",
            highlight5: "Perfect for photography enthusiasts looking to capture scenic beauty from above.",

            sunriseImageAlt: "Enjoy breathtaking views of the sunrise while floating gently in a hot air balloon.",
            sunriseImageCaption: "Enjoy breathtaking views of the sunrise while floating gently in a hot air balloon.",

            landscapeImageAlt: "Witness stunning landscapes of Sri Lanka from above, including rolling hills and lush forests.",
            landscapeImageCaption: "Witness stunning landscapes of Sri Lanka from above, including rolling hills and lush forests.",

            tipsTitle: "Tips for a Memorable Balloon Ride",
            tip1: "Book your ride early, as ballooning is weather-dependent and slots fill up quickly.",
            tip2: "Wear comfortable clothing and carry a light jacket, as early mornings can be cool.",
            tip3: "Carry a camera or smartphone to capture the stunning views.",
            tip4: "Listen carefully to the safety instructions provided by your pilot.",
            tip5: "Arrive on time to watch the preparation and inflation of the balloon, which is a fascinating process."
        },
        diving: {
            title: "Diving in Sri Lanka",

            introParagraph1: "A wide coral reef surrounds the coast of Sri Lanka at depths of 2 to 40 meters. The warm waters of the Indian Ocean, between 27°C and 30°C, and the high transparency of the water, from 15 to 35 meters, provide excellent conditions for diving and snorkeling. While diving in Sri Lanka, you can explore endless untouched coral reefs, old wrecks, and mesmerizing underwater caves.",
            introParagraph2: "The northeast of the island offers a variety of more than 130 species of colorful corals, which are home to marine life such as sea turtles, clownfish, lionfish, and seahorses. Visit shipwrecks near underwater rocks and reefs for an unforgettable experience. Floating in the clear waters, you'll find yourself immersed in the fascinating past of Ceylon.",

            mainImageAlt: "Diving in Sri Lanka",
            mainImageCaption: "Diving in Sri Lanka",

            facilitiesTitle: "Facilities and Best Dive Spots",
            facilitiesParagraph1: "Island dive centers are equipped with the latest diving equipment from renowned manufacturers. Certified instructors with PADI and CMAS qualifications ensure safe and enjoyable dives. Dive centers are located along the southwest coast of the island, operating between mid-October and the end of April. The northeast coast, including Nilaveli and Trincomalee, is ideal for diving from March to October.",
            facilitiesParagraph2: "The coral reefs near Kalpitiya in the west and the shipwreck diving sites in Hikkaduwa are among the most popular attractions for divers.",

            coralImageAlt: "Explore vibrant coral reefs that are home to diverse marine life.",
            coralImageCaption: "Explore vibrant coral reefs that are home to diverse marine life.",

            shipwreckImageAlt: "Discover historic shipwrecks that offer a glimpse into Sri Lanka's maritime past.",
            shipwreckImageCaption: "Discover historic shipwrecks that offer a glimpse into Sri Lanka's maritime past.",

            tipsTitle: "Tips for Divers",
            tip1: "Choose the best season for diving based on the location: southwest coast (October to April) or northeast coast (March to October).",
            tip2: "Ensure your dive center is certified and equipped with modern gear for a safe experience.",
            tip3: "Listen to your instructor's advice, especially if you are a beginner.",
            tip4: "Respect marine life by not touching corals or disturbing the underwater environment.",
            tip5: "Carry a waterproof camera to capture the mesmerizing beauty of Sri Lanka's underwater world."
        },
        elephantRide: {
            title: "Elephant Back Ride",

            introParagraph1: "Elephant trekking is a fascinating, exciting activity and a unique experience in Sri Lanka. If you are staying near the cultural triangle in areas like Habarana, Sigiriya, or Dambulla, you can participate in an elephant safari. These rides start at around $30 for an hour of unforgettable adventure.",
            introParagraph2: "Before the ride, elephants are saddled with a multi-basket designed for 4 to 6 people. These gentle giants take you through scenic jungle paths, cross areas flooded with water, and navigate through lush vegetation. Elephants usually walk slowly, allowing you to fully appreciate the beauty of the surrounding nature, even though they can reach speeds of up to 40 km/h.",

            mainImageAlt: "Elephant Back Ride",
            mainImageCaption: "Elephant Back Ride",

            highlightsTitle: "Highlights of an Elephant Ride",
            highlightsIntro: "Riding an elephant in Sri Lanka provides a unique way to connect with nature and explore the countryside. Some highlights of the experience include:",
            highlight1: "Walking through dense jungles filled with exotic vegetation and wildlife.",
            highlight2: "Crossing rivers and flooded areas, offering stunning views of the natural landscape.",
            highlight3: "Learning about the close relationship between elephants and Sri Lankan culture.",
            highlight4: "Relaxing on a comfortable saddle while the elephant gently carries you through various terrains.",

            jungleImageAlt: "Explore dense jungles and scenic paths while riding on an elephant.",
            jungleImageCaption: "Explore dense jungles and scenic paths while riding on an elephant.",

            waterImageAlt: "Cross rivers and enjoy the tranquil beauty of the water and vegetation.",
            waterImageCaption: "Cross rivers and enjoy the tranquil beauty of the water and vegetation.",

            tipsTitle: "Tips for a Safe and Enjoyable Elephant Ride",
            tip1: "Wear comfortable clothing and footwear suitable for outdoor activities.",
            tip2: "Follow the instructions of your guide for a safe and enjoyable ride.",
            tip3: "Ensure that the elephants are well-treated and the ride provider follows ethical practices.",
            tip4: "Bring a camera to capture the breathtaking scenery and moments.",
            tip5: "Respect the elephants and avoid actions that might stress or harm them."
        },
        fishing: {
            title: "Fishing in Sri Lanka",

            introParagraph1: "Sri Lanka, with its vast coastline and abundance of freshwater lakes and rivers, offers an unparalleled fishing experience. Whether you're a professional angler or a hobbyist, Sri Lanka has something to offer. From deep-sea fishing expeditions to the traditional stilt fishing practiced by local fishermen, you'll have an unforgettable adventure.",
            introParagraph2: "Popular fishing destinations include the southern coast around Galle and Mirissa, the Negombo lagoon, and the calm waters of Trincomalee. Depending on your preference, you can try different fishing techniques such as trolling, bottom fishing, or fly fishing.",

            mainImageAlt: "Fishing in Sri Lanka",
            mainImageCaption: "Fishing in Sri Lanka",

            experiencesTitle: "Fishing Experiences in Sri Lanka",
            experiencesIntro: "Fishing in Sri Lanka is not just about catching fish; it is an opportunity to immerse yourself in the culture and traditions of the island. Some unique fishing experiences include:",

            expStiltTitle: "Stilt Fishing",
            expStiltDesc: "A traditional method where fishermen perch on stilts to catch fish near the shore, a practice unique to Sri Lanka.",

            expDeepSeaTitle: "Deep-Sea Fishing",
            expDeepSeaDesc: "Venture into the Indian Ocean to catch marlins, tunas, barracudas, and other large fish species.",

            expLagoonTitle: "Lagoon and River Fishing",

            expLagoonDesc: "Relax while fishing in serene lagoons and rivers teeming with fish like tilapia and catfish.",

            expNightTitle: "Night Fishing",
            expNightDesc: "Experience the thrill of fishing under the stars, a common practice in coastal villages.",

            stiltImageAlt: "Stilt fishing, a traditional method and iconic part of Sri Lanka's fishing heritage.",
            stiltImageCaption: "Stilt fishing is a traditional method and an iconic image of Sri Lanka's fishing heritage.",

            deepSeaImageAlt: "Deep-sea fishing offers an adventurous experience, targeting large fish species in the Indian Ocean.",
            deepSeaImageCaption: "Deep-sea fishing offers an adventurous experience, targeting large fish species in the Indian Ocean.",

            tipsTitle: "Tips for an Enjoyable Fishing Trip",
            tip1: "Choose the right season for your fishing expedition; October to April is ideal for the southern coast, while March to October suits the eastern coast.",
            tip2: "Bring sunscreen, a hat, and protective clothing to stay comfortable during your trip.",
            tip3: "Book a fishing guide or charter to make the most of your experience and learn from the experts.",
            tip4: "Respect the local environment by avoiding littering and adhering to sustainable fishing practices.",
            tip5: "Stay hydrated and carry snacks for longer fishing trips."
        },
        jeepSafari: {
            title: "Jeep Safari in Sri Lanka",

            introParagraph1: "Sri Lanka's national parks offer a thrilling jeep safari experience, allowing you to explore the island's rich biodiversity and witness wildlife in their natural habitats. Yala National Park, Wilpattu National Park, and Udawalawe National Park are among the most popular destinations for jeep safaris.",
            introParagraph2: "These safaris provide a chance to see elephants, leopards, sloth bears, water buffalo, crocodiles, and a wide variety of bird species. Guided by experienced naturalists and trackers, jeep safaris are perfect for wildlife enthusiasts and photographers alike.",

            mainImageAlt: "Jeep Safari in Sri Lanka",
            mainImageCaption: "Jeep Safari in Sri Lanka",

            whyChooseTitle: "Why Choose a Jeep Safari?",
            whyChooseIntro: "Jeep safaris are one of the best ways to explore the diverse wildlife of Sri Lanka. Here are some highlights:",

            highlight1: "Close encounters with iconic species like elephants and leopards.",
            highlight2: "Access to remote and scenic areas within national parks.",
            highlight3: "Opportunities for wildlife photography in a natural setting.",
            highlight4: "Guidance from knowledgeable naturalists and park rangers.",
            highlight5: "An adventure suitable for all age groups, combining excitement with education.",

            wildlifeImageAlt: "Witness iconic wildlife like leopards, elephants, and crocodiles during your safari.",
            wildlifeImageCaption: "Witness iconic wildlife like leopards, elephants, and crocodiles during your safari.",

            landscapeImageAlt: "Explore the stunning landscapes of Sri Lanka's national parks, from dense forests to open plains.",
            landscapeImageCaption: "Explore the stunning landscapes of Sri Lanka's national parks, from dense forests to open plains.",

            tipsTitle: "Tips for an Enjoyable Jeep Safari",
            tip1: "Wear comfortable, neutral-colored clothing to blend in with the environment.",
            tip2: "Carry sunscreen, a hat, and insect repellent for protection.",
            tip3: "Bring binoculars and a camera to enhance your experience and capture wildlife.",
            tip4: "Follow the guide's instructions to ensure safety and respect for the animals.",
            tip5: "Book your safari early, especially during peak seasons, to secure a spot."
        },
        riverSafari: {
            title: "River Safari in Sri Lanka",

            introParagraph1: "A river safari in Sri Lanka offers a unique way to explore the island's rich biodiversity and scenic beauty. Glide along tranquil waterways surrounded by lush mangroves, spot exotic wildlife, and enjoy picturesque sunsets that will leave you mesmerized.",
            introParagraph2: "Popular river safari destinations include the Madu Ganga (Madu River) and Bentota River. These safaris provide a chance to witness various bird species, monitor lizards, crocodiles, and even monkeys in their natural habitats. The serene environment is perfect for nature lovers and photographers.",

            mainImageAlt: "River Safari in Sri Lanka",
            mainImageCaption: "River Safari in Sri Lanka",

            whyChooseTitle: "Why Choose a River Safari?",
            whyChooseIntro: "A river safari is a relaxing and immersive experience that combines nature, wildlife, and cultural exploration. Here are some highlights:",

            highlight1: "Explore lush mangroves teeming with life.",
            highlight2: "Spot exotic birds, crocodiles, and other wildlife.",
            highlight3: "Visit small islands and local villages along the river.",
            highlight4: "Enjoy the tranquility and picturesque beauty of Sri Lanka's waterways.",
            highlight5: "Perfect for families, couples, and solo travelers seeking a peaceful escape.",

            mangrovesImageAlt: "Discover the lush mangroves that line Sri Lanka's scenic waterways.",
            mangrovesImageCaption: "Discover the lush mangroves that line Sri Lanka's scenic waterways.",

            wildlifeImageAlt: "Spot exotic wildlife like crocodiles, monitor lizards, and colorful birds during your safari.",
            wildlifeImageCaption: "Spot exotic wildlife like crocodiles, monitor lizards, and colorful birds during your safari.",

            tipsTitle: "Tips for an Enjoyable River Safari",
            tip1: "Wear comfortable clothing and bring a hat and sunscreen for protection.",
            tip2: "Carry binoculars to spot distant wildlife and birds.",
            tip3: "Bring a camera or smartphone to capture the stunning scenery and wildlife.",
            tip4: "Follow the instructions of your guide for a safe and enjoyable experience.",
            tip5: "Respect the natural environment by avoiding littering and disturbing wildlife."
        },
        snorkeling: {
            title: "Snorkeling in Sri Lanka",

            introParagraph1: "Snorkeling in Sri Lanka offers an unforgettable underwater experience, where you can explore vibrant coral reefs and diverse marine life. With its crystal-clear natural waters and abundant aquatic ecosystems, Sri Lanka is a paradise for snorkelers of all skill levels.",
            introParagraph2: "Some of the most popular snorkeling spots include Hikkaduwa, known for its colorful coral gardens and turtles, Pigeon Island in Trincomalee, famous for its pristine reefs, and Mirissa, where you might even spot a whale or two during the snorkeling season.",

            mainImageAlt: "Snorkeling in Sri Lanka",
            mainImageCaption: "Snorkeling in Sri Lanka",

            whyChooseTitle: "Why Choose Snorkeling in Sri Lanka?",
            whyChooseIntro: "Snorkeling in Sri Lanka is a magical experience, combining adventure and natural beauty. Here are some highlights:",

            highlight1: "Explore vibrant coral reefs teeming with life.",
            highlight2: "Swim alongside colorful tropical fish, turtles, and even reef sharks.",
            highlight3: "Discover pristine underwater landscapes in clear, warm waters.",
            highlight4: "Suitable for both beginners and experienced snorkelers.",
            highlight5: "Accessible from some of the best beach destinations in Sri Lanka.",

            coralImageAlt: "Discover stunning coral reefs and their vibrant ecosystems.",
            coralImageCaption: "Discover stunning coral reefs and their vibrant ecosystems.",

            marineLifeImageAlt: "Encounter diverse marine life, including turtles, tropical fish, and more.",
            marineLifeImageCaption: "Encounter diverse marine life, including turtles, tropical fish, and more.",

            tipsTitle: "Tips for a Memorable Snorkeling Experience",
            tip1: "Wear a comfortable mask and snorkel to ensure a clear view underwater.",
            tip2: "Apply reef-safe sunscreen to protect both your skin and marine life.",
            tip3: "Swim gently to avoid disturbing coral reefs and aquatic creatures.",
            tip4: "Stay hydrated and take breaks between sessions.",
            tip5: "Join a guided tour for the best snorkeling spots and safety tips."
        },
        teaTasting: {
            title: "Tea Tasting Tour in Sri Lanka",

            introParagraph1: "Sri Lanka, often referred to as the 'Pearl of the Indian Ocean,' is famous for its world-class tea production. Embark on a tea tasting tour and explore the lush tea plantations in regions like Nuwara Eliya, Ella, and Kandy. Learn about the art of tea cultivation, the meticulous process of tea production, and savor the rich flavors of authentic Ceylon tea.",
            introParagraph2: "Whether you're a tea enthusiast or simply curious, a tea tasting tour offers a unique opportunity to delve into Sri Lanka’s tea heritage and experience the serene beauty of its highlands.",

            mainImageAlt: "Tea Tasting Tour in Sri Lanka",
            mainImageCaption: "Tea Tasting Tour in Sri Lanka",

            whyChooseTitle: "Why Choose a Tea Tasting Tour?",
            whyChooseIntro: "A tea tasting tour in Sri Lanka is not just about tasting tea—it's an immersive cultural experience. Here are some highlights:",

            highlight1: "Visit picturesque tea plantations nestled in the cool highlands.",
            highlight2: "Learn about the history and significance of Ceylon tea.",
            highlight3: "Participate in tea plucking and observe the production process in tea factories.",
            highlight4: "Savor different varieties of tea, from black to green to flavored blends.",
            highlight5: "Enjoy the breathtaking scenery of misty mountains and cascading waterfalls.",

            plantationImageAlt: "Explore lush tea plantations and learn about tea cultivation.",
            plantationImageCaption: "Explore lush tea plantations and learn about tea cultivation.",

            preparationImageAlt: "Discover the art of tea preparation and savor authentic Ceylon tea.",
            preparationImageCaption: "Discover the art of tea preparation and savor authentic Ceylon tea.",

            tipsTitle: "Tips for an Enjoyable Tea Tasting Tour",
            tip1: "Wear comfortable clothing and footwear for walking through plantations.",
            tip2: "Bring a light jacket, as highland regions can be cool and misty.",
            tip3: "Try different varieties of tea and take some favorites home as souvenirs.",
            tip4: "Ask questions during the tour to learn more about the tea-making process.",
            tip5: "Combine your tea tour with visits to nearby attractions like waterfalls and viewpoints."
        }, templeVisit: {
            title: "Temple Visit in Sri Lanka",

            introParagraph1: "Sri Lanka, known as the Land of Buddha, is home to ancient temples that reflect its rich spiritual and cultural heritage. Embark on a journey to explore iconic temples such as the Temple of the Tooth in Kandy, the Dambulla Cave Temple, and Ruwanwelisaya in Anuradhapura.",
            introParagraph2: "These sacred sites, adorned with intricate carvings, murals, and statues, offer a glimpse into the island's spiritual traditions and architectural brilliance. A temple visit is not only a cultural experience but also an opportunity to find peace and tranquility.",

            mainImageAlt: "Temple Visit in Sri Lanka",
            mainImageCaption: "Temple Visit in Sri Lanka",

            whyVisitTitle: "Why Visit Temples in Sri Lanka?",
            whyVisitIntro: "Visiting temples in Sri Lanka offers a unique opportunity to connect with the island’s history, culture, and spirituality. Here are some highlights:",

            highlight1: "Admire the intricate architecture and centuries-old statues.",
            highlight2: "Learn about Buddhist traditions and rituals from knowledgeable guides.",
            highlight3: "Explore UNESCO World Heritage Sites like the Golden Temple of Dambulla.",
            highlight4: "Experience the serenity and spiritual ambiance of sacred spaces.",
            highlight5: "Witness vibrant festivals like Esala Perahera at the Temple of the Tooth.",

            interiorImageAlt: "Marvel at the stunning interiors adorned with intricate carvings and murals.",
            interiorImageCaption: "Marvel at the stunning interiors adorned with intricate carvings and murals.",

            sacredImageAlt: "Visit sacred temples like Ruwanwelisaya and immerse yourself in spiritual traditions.",
            sacredImageCaption: "Visit sacred temples like Ruwanwelisaya and immerse yourself in spiritual traditions.",

            tipsTitle: "Tips for Visiting Temples in Sri Lanka",
            tip1: "Dress modestly, covering your shoulders and knees, as a sign of respect.",
            tip2: "Remove your shoes before entering temple premises.",
            tip3: "Refrain from touching statues or sacred objects.",
            tip4: "Bring a small donation for the temple if you wish to contribute.",
            tip5: "Respect the silence and spiritual atmosphere during your visit."
        },
        whiteWaterRafting: {
            title: "White Water Rafting in Sri Lanka",

            introParagraph1: "White water rafting in Sri Lanka is an exhilarating experience, especially in Kitulgala, the adventure capital of the island. The Kelani River, with its roaring rapids and scenic surroundings, offers a perfect setting for both beginners and experienced rafters.",
            introParagraph2: "Rafting expeditions typically cover a 5-kilometer stretch with rapids ranging from Grade 2 to Grade 4. Participants can enjoy the thrill of navigating challenging currents while taking in the lush greenery and breathtaking views of the riverbanks.",

            mainImageAlt: "White Water Rafting in Sri Lanka",
            mainImageCaption: "White Water Rafting in Sri Lanka",

            whyChooseTitle: "Why Choose White Water Rafting in Sri Lanka?",
            whyChooseIntro: "White water rafting in Sri Lanka offers a unique combination of adventure and natural beauty. Here are some highlights of the experience:",

            highlight1: "Navigate through thrilling rapids under the guidance of experienced instructors.",
            highlight2: "Enjoy stunning views of the surrounding rainforest and mountainous terrain.",
            highlight3: "Combine rafting with other activities like trekking, birdwatching, and canyoning in Kitulgala.",
            highlight4: "Perfect for groups, families, or solo travelers looking for an adrenaline rush.",

            actionImageAlt: "Feel the adrenaline rush as you conquer challenging rapids on the Kelani River.",
            actionImageCaption: "Feel the adrenaline rush as you conquer challenging rapids on the Kelani River.",

            scenicImageAlt: "Enjoy the serene beauty of the lush surroundings during your rafting adventure.",
            scenicImageCaption: "Enjoy the serene beauty of the lush surroundings during your rafting adventure.",

            tipsTitle: "Tips for a Safe and Exciting Rafting Trip",
            tip1: "Wear a life jacket and helmet provided by your rafting guide for safety.",
            tip2: "Listen carefully to the safety instructions before starting your trip.",
            tip3: "Wear comfortable, quick-drying clothing and secure footwear like water shoes.",
            tip4: "Carry a change of clothes and a towel for after the trip.",
            tip5: "Book your rafting trip with a reputable operator to ensure a safe and enjoyable experience."
        },
        wildlifeSafari: {
            title: "Wildlife Safari in Sri Lanka",

            introParagraph1: "Sri Lanka, known for its rich biodiversity, offers incredible wildlife safaris in national parks like Yala, Wilpattu, Minneriya, and Udawalawe. These safaris provide a chance to witness elephants, leopards, sloth bears, and a variety of bird species in their natural habitats.",
            introParagraph2: "Explore diverse landscapes ranging from dense forests to open grasslands, and capture unforgettable moments of wildlife in action. With expert guides and well-maintained safari jeeps, a wildlife safari in Sri Lanka is a must for nature enthusiasts and adventure seekers.",

            mainImageAlt: "Wildlife Safari in Sri Lanka",
            mainImageCaption: "Wildlife Safari in Sri Lanka",

            whyChooseTitle: "Why Choose a Wildlife Safari?",
            whyChooseIntro: "A wildlife safari in Sri Lanka offers a unique opportunity to connect with nature and explore the island's remarkable biodiversity. Highlights include:",

            highlight1: "Witnessing iconic species like elephants, leopards, and crocodiles.",
            highlight2: "Exploring lush forests, wetlands, and open plains teeming with wildlife.",
            highlight3: "Capturing stunning wildlife photography in natural settings.",
            highlight4: "Experiencing the thrill of spotting elusive animals like the Sri Lankan leopard.",
            highlight5: "Learning about conservation efforts from experienced guides and naturalists.",

            elephantsImageAlt: "Witness majestic elephants roaming freely in Sri Lanka's national parks.",
            elephantsImageCaption: "Witness majestic elephants roaming freely in Sri Lanka's national parks.",

            leopardImageAlt: "Spot the elusive Sri Lankan leopard, a highlight of any wildlife safari.",
            leopardImageCaption: "Spot the elusive Sri Lankan leopard, a highlight of any wildlife safari.",

            tipsTitle: "Tips for an Exciting Wildlife Safari",
            tip1: "Wear neutral-colored clothing to blend into the environment.",
            tip2: "Carry sunscreen, a hat, and insect repellent for protection.",
            tip3: "Bring binoculars and a camera to spot and capture wildlife.",
            tip4: "Follow your guide's instructions for a safe and enjoyable experience.",
            tip5: "Book early, especially during peak seasons, to secure a spot in popular parks."
        },
        about: {
            hero: {
                discover: "DISCOVER",
                aamyTours: "AAMY TOURS",
                tagline1: "From ancient citadels to emerald tea hills and thrilling wildlife safaris — Sri Lanka pulses with life. This island is not just a destination — it’s a soul-stirring adventure.",
                tagline2: "Warm golden shores, misty highlands, and endless wonders await. With Aamy Tours Sri Lanka, every moment transforms into a cherished memory."
            },
            slider: {
                sigiriya: "Sigiriya Rock Fortress",
                yala: "Yala National Park",
                tea: "Tea Country",
                beaches: "Pristine Beaches",
                temples: "Sacred Temples"
            },
            about: {
                title: "About Aamy Tours Sri Lanka",
                signature: "Signature Sri Lanka Journeys"
            },
            tours: {
                days4: "4 Days",
                classic: "CLASSIC ODYSSEY",
                days5: "5 Days",
                safari: "SAFARI TOURS",
                days6: "6 Days",
                retreat: "Mindful Retreat",
                desc1: "With Aamy Tours Sri Lanka, journey across every corner of this breathtaking island — from bustling cities to misty highlands and pristine southern shores.",
                desc2: "Experience the best of Sri Lanka — from the sacred heart of Kandy to vibrant Colombo and the serene beauty of the Southern Coast.",
                desc3: "Whether you crave adventure, culture, wildlife, or serenity, Aamy Tours Sri Lanka crafts unforgettable journeys — any season of the year."
            },
            whoWeAre: {
                title: "Who We Are",
                description: "Welcome to Aamy Tours Sri Lanka — your trusted guide to every province of this magical island. With <strong>over 14 years of experience</strong>, our passionate local team crafts immersive journeys that go beyond tourism — revealing the island’s soul, rich heritage, and breathtaking natural splendor.",
                imageAlt: "Aamy Tours Team",
                item1: { title: "Island-Wide Adventures", text: "We operate across all provinces — from the North to the deep South, delivering authentic, local experiences everywhere." },
                item2: { title: "Tailored Journeys", text: "Every itinerary is custom-crafted to your passions — adventure, culture, nature, or relaxation." },
                item3: { title: "Expert Local Guides", text: "Our licensed guides, backed by 14+ years of expertise, reveal hidden gems, ancient stories, and the true heartbeat of Sri Lanka." },
                item4: { title: "Round-the-Clock Support", text: "With Aamy Tours, you’re always cared for — our team is available 24/7 throughout your journey." }
            },
            offers: {
                title: "What We Offer",
                cultural: { title: "Cultural Immersion", text: "Dive into traditions, festivals, and local life.", alt: "Cultural Immersion" },
                adventure: { title: "Adventure Expeditions", text: "Trekking, safaris, surfing, and outdoor thrills.", alt: "Adventure" },
                luxury: { title: "Luxury & Comfort", text: "Premium stays, private transfers, and VIP service.", alt: "Luxury" },
                wellness: { title: "Wellness & Rejuvenation", text: "Yoga, Ayurveda, and peace in tranquil settings.", alt: "Wellness" }
            },
            guides: {
                title: "Our Guides",
                text: "Our licensed, passionate guides are the soul of every journey. They don’t just show you Sri Lanka — they bring it to life with stories, traditions, and insider secrets.",
                imageAlt: "Aamy Tours Guide"
            },
            expert: {
                name: "Azeem Mohammed",
                role: "(Lead Tour Expert)",
                bio: "With <strong>over 14 years of licensed expertise</strong>, Azeem Mohammed is passionate about unveiling Sri Lanka’s hidden treasures. From golden beaches to misty hilltops, wildlife adventures to ancient wonders — he crafts every journey into an unforgettable experience, the Aamy Tours way.",
                imageAlt: "Azeem Mohammed"
            },
            vehicles: {
                title: "Our Premium Fleet",
                text: "At Aamy Tours Sri Lanka, your safety and comfort are paramount. With <strong>over 14 years of experience</strong>, we use modern, air-conditioned, and impeccably maintained vehicles for a seamless journey across the island.",
                bookButton: "Book Your Journey",
                car: { title: "Car", text: "Ideal for couples or solo travelers (up to 3). Sleek, fuel-efficient, and perfect for intimate journeys." },
                van: { title: "Van", text: "Perfect for families or small groups (up to 6). Spacious, cozy, and ideal for long drives." },
                minibus: { title: "Minibus", text: "Great for larger groups (8–12). Comfortable seats and plenty of luggage space." },
                luxury: { title: "Luxury", text: "Premium vehicles with leather interiors, Wi-Fi, and dedicated chauffeur for VIP comfort." }
            },
            accommodations: {
                intro: "Unwind in exclusive 3-star, 4-star, 5-star retreats and boutique havens, each selected for serenity, sophistication, and seamless comfort throughout your journey.",
                item1: "Private villas with infinity pools and holistic wellness experiences in a tranquil coastal setting.",
                item2: "Heritage-inspired luxury perched above the ocean, featuring fine dining and timeless colonial elegance.",
                item3: "Eco-chic wilderness retreat blending modern comfort with immersive nature and wildlife encounters.",
                item4: "Architectural gem harmonized with nature, offering panoramic views and sustainable luxury design."
            },
            notices: {
                title: "Important Notices",
                intro: "At Aamy Tours Sri Lanka, we go the extra mile to make your journey unforgettable. Enjoy these complimentary perks on every tour:",
                bike: { title: "Free Bike for Guests", text: "Explore the island at your own pace — we provide a complimentary bike for every guest during the tour." },
                fruits: { title: "Fruits Bag at Tour End", text: "End your adventure on a sweet note — receive a fresh, handpicked fruits bag as a farewell gift." },
                meals: { title: "Free Meals for Money Feeding", text: "Participate in local traditions — we provide free meals for guests during money feeding ceremonies." }
            },
        },
        home: {
            common: { viewAll: "View All" },
            sections: {
                recommendations: { title: "Curated Destinations", subtitle: "Not sure where to begin? Let us inspire you." },
                excursions: { title: "Our Tour Programmes", desc: "Multi-day odysseys crafted with precision — blending heritage, nature, and soul-stirring moments." },
                packages: { title: "Exclusive Packages" },
                reviews: { title: "Guest Comments", subtitle: "Authentic voices from travelers who lived the journey" },
                gallery: { title: "Our Gallery", subtitle: "A visual journey through Sri Lanka’s soul — captured in moments of wonder, joy, and timeless beauty." }
            },
            recommendations: {
                sigiriya: { label: "Sigiriya", name: "Ancient rock citadel rising dramatically from the plains." },
                udawalawa: { label: "Udawalawa", name: "Elephant herds roam freely in vast golden grasslands." },
                ella: { label: "Ella", name: "Misty hills, epic train rides, and panoramic vistas." },
                mirissa: { label: "Mirissa", name: "Golden sands, turquoise waves, and whale-watching paradise." },
                nuwaraeliya: { label: "Nuwara Eliya", name: "Rolling tea estates and crisp mountain air." },
                kandy: { label: "Kandy", name: "Sacred city of the Temple of the Tooth Relic." },
                galle: { label: "Galle", name: "Colonial fort walls meet the Indian Ocean." },
                yala: { label: "Yala", name: "Wildlife sanctuary with leopards, elephants, and diverse fauna." },
                anuradhapura: { label: "Anuradhapura", name: "Cradle of Buddhism with ancient stupas." },
                polonnaruwa: { label: "Polonnaruwa", name: "Ruins of a medieval royal capital." }
            },
            excursions: {
                oneDay: { title: "One Day – Essence of the Island", des: "A single day, a lifetime of memories — from ancient stupas to golden beaches, distilled into pure magic." },
                twoDays: { title: "Two Days – Whisper of the Wild", des: "Two days of untamed beauty: safari under starlit skies, tea-scented hills, and the heartbeat of the jungle." },
                threeDays: { title: "Three Days – Soul & Shore", des: "Three days to awaken your spirit — sacred temples at dawn, ocean waves at dusk, and culture in every breath." },
                fourDays: { title: "Four Days – Heritage & Harmony", des: "Four days of timeless wonder: climb ancient fortresses, wander colonial streets, and taste tradition in every corner." },
                fiveDays: { title: "Five Days – Journey to the Heart", des: "Five days to fall in love — from misty highlands to turquoise lagoons, every moment is poetry in motion." },
                sixDays: { title: "Six Days – The Signature Sojourn", des: "Six days of curated elegance — sacred relics, wildlife safaris, and serene sunsets, woven into one unforgettable story." }
            },
            packages: {
                one: { title: "1 Day / 0 Nights: Essence of the Island", duration: "1 Day", desc: "A single day, a lifetime of memories — ancient stupas, golden beaches, and the soul of Sri Lanka distilled into pure magic.", category: "Signature Snapshot" },
                two: { title: "2 Days / 1 Night: Whisper of the Wild", duration: "2 Days", desc: "Two days of untamed beauty — safari under starlit skies, tea-scented hills, and the heartbeat of the jungle.", category: "Wilderness Escape" },
                three: { title: "3 Days / 2 Nights: Soul & Shore", duration: "3 Days", desc: "Three days to awaken your spirit — sacred temples at dawn, ocean waves at dusk, and culture in every breath.", category: "Spiritual Coastal" },
                four: { title: "4 Days / 3 Nights: Heritage & Harmony", duration: "4 Days", desc: "Four days of timeless wonder — climb ancient fortresses, wander colonial streets, and taste tradition in every corner.", category: "Cultural Deep Dive" },
                five: { title: "5 Days / 4 Nights: Journey to the Heart", duration: "5 Days", desc: "Five days to fall in love — misty highlands, turquoise lagoons, and every moment a poem in motion.", category: "Romantic Explorer" },
                six: { title: "6 Days / 5 Nights: The Signature Sojourn", duration: "6 Days", desc: "Six days of curated elegance — sacred relics, wildlife safaris, and serene sunsets woven into one unforgettable story.", category: "Signature Classic" }
            },
            featured: {
                perahera: {
                    h2: "Witness the Spectacle", h3: "Kandy Esala Perahera", h4: "(Festival of the Sacred Tooth)",
                    paragraph: `One of Asia’s most magnificent Buddhist spectacles, held annually in Kandy to venerate the Sacred Tooth Relic. Elephants in regal finery, rhythmic drums, fire dancers, and torchbearers illuminate the night in a mesmerizing display of faith and tradition. Be part of this living heritage with <strong style="color: #166880;">Aamy Tours Sri Lanka</strong> — where culture breathes, and history dances.`,
                    button: "Discover More"
                },
                safari: {
                    h2: "Into the Wild", h3: "Safari Expeditions",
                    paragraph: `Sri Lanka stands among Asia’s premier wildlife destinations. Traverse the savannahs of <span style="color: #D5A44F; font-weight: 600;">Yala</span> and <span style="color: #D5A44F; font-weight: 600;">Udawalawa</span>, or glide through <span style="color: #D5A44F; font-weight: 600;">Wilpattu</span>’s misty wetlands. Encounter majestic elephants, elusive leopards, and rare birds in their natural realm. Venture with <strong style="color: #166880;">Aamy Tours Sri Lanka</strong> — every safari is a story written in dust and dawn.`,
                    button: "Explore Safaris"
                }
            },
            gallery: {
                title: "Our Gallery", subtitle: "A visual journey through Sri Lanka’s soul — captured in moments of wonder, joy, and timeless beauty.",
                alt1: "Sunrise over Sigiriya Rock Fortress", alt2: "Elephant safari in Yala National Park", alt3: "Tea picker in Nuwara Eliya mist",
                alt4: "Golden hour at Mirissa Beach", alt5: "Kandy Temple of the Tooth ceremony", alt6: "Ancient ruins of Polonnaruwa",
                alt7: "Whale watching off the southern coast", alt8: "Train journey through Ella’s hills", alt9: "Galle Fort at sunset",
                alt10: "Local fisherman in Negombo", alt11: "Traditional Kandyan dance performance", alt12: "Hot air balloon over Dambulla"
            },
            cta: {
                title: "Aamy Tours Sri Lanka — Crafting Timeless Journeys",
                desc: "Every trip is a masterpiece — woven with culture, adventure, and serenity. Let us design your story in the Pearl of the Indian Ocean.",
                button: "Begin Your Journey",
                alt: "Craft Your Journey"
            },
        },
        hero: {
            title: {
                line1: "Discover Paradise with",
                line2: "Aamy Tours",
                line3: "Sri Lanka"
            },
            subtitle: "Immerse yourself in emerald rainforests, golden beaches, ancient kingdoms, and thrilling wildlife encounters —",
            subtitle2: "handcrafted just for you.",

            cta: "Begin Your Journey",
            trust: "Trusted by explorers from 50+ countries • Featured in Lonely Planet & CNN Travel"
        },
        footer: {
            brand: "Aamy Tours<br />Sri Lanka",

            nav: {
                home: "Home",
                about: "About Us",
                explore: "Explore Sri Lanka",
                tours: "Tour Packages",
                gallery: "Gallery",
                events: "Special Events",
                things: "Things to Do",
                contact: "Contact Us"
            },

            contact: {
                title: "Let’s Create Memories Together",
                address: "81/31h, H.K Edmond Mawatha Milidduwa,<br />Galle, Sri Lanka",
                email: "aamytourssl@gmail.com",
                phone: "+94 77 048 3364"
            },

            newsletter: {
                title: "Join Our Journey",
                desc: "Be the first to know about exclusive offers, hidden gems & breathtaking adventures.",
                placeholder: "Your email address",
                subscribe: "Subscribe"
            },

            tagline: "\"Not all those who wander are lost...<br /><span class='text-cyan-300 font-semibold'>some are just with Aamy Tours</span>\"",

            copyright: "Crafted with passion. All Rights Reserved.",
            developedBy: "Lovingly designed & developed by"
        },
        tourpackages: {
            heroTitle: 'Our Tour Packages',
            heroSubtitle: 'Discover Sri Lanka in a single day — handcrafted adventures by <span class="text-[#D5A44F] font-bold">Aamy Tours</span>',
            heroAlt: 'Aamy Tours Sri Lanka - One Day Adventures',
            chooseAdventure: 'Choose Your Adventure',
            packagesSubtitle: '25 handpicked experiences — from wildlife safaris to cultural immersions.',
            viewDetails: 'View Details',
            itineraryTitle: 'Itinerary',
            bookViaWhatsApp: 'Book via WhatsApp',
            whatsappMessage: 'Hi Aamy Tours! I\'d like to book: *{{title}}* ({{duration}})\n\nLet me know availability and pricing!',

            packages: {
                '1': {
                    title: 'Ella Adventure Day',
                    duration: '1 Day',
                    category: 'Nature & Adventure',
                    description: 'Journey through misty hills, cascading waterfalls, and iconic bridges — a perfect blend of thrill and serenity.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Swim in crystal pools</li>
                <li><strong>Nine Arch Bridge</strong> – Iconic train photo stop</li>
                <li><strong>Tea Plantation</strong> – Walk among emerald hills</li>
                <li><strong>Train Ride</strong> – Scenic Ella to Demodara</li>
                <li><strong>Little Adam’s Peak</strong> – Panoramic sunrise/sunset views</li>
                <li><strong>Udawalawe Elephant Milk Feeding</strong> – Heartwarming wildlife moment</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Learn ancient wellness secrets</li>
            </ul>`
                },
                '2': {
                    title: 'Ella & Yala Safari',
                    duration: '1 Day',
                    category: 'Wildlife & Scenic',
                    description: 'From misty highlands to wild savannah — experience the best of nature in one unforgettable day.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Refreshing natural pool</li>
                <li><strong>Nine Arch Bridge</strong> – Architectural wonder</li>
                <li><strong>Tea Plantation</strong> – Scenic hill walks</li>
                <li><strong>Little Adam’s Peak</strong> – Stunning hilltop views</li>
                <li><strong>Yala Safari</strong> – Jeep adventure with leopards & elephants</li>
            </ul>`
                },
                '3': {
                    title: 'Kandy Cultural Day',
                    duration: '1 Day',
                    category: 'Heritage & Nature',
                    description: 'Immerse in sacred temples, lush gardens, and local traditions in the heart of Sri Lanka.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Kandy City</strong> – Vibrant cultural hub</li>
                <li><strong>Royal Botanical Garden</strong> – Tropical paradise</li>
                <li><strong>Tea Factory & Plantation</strong> – Ceylon tea experience</li>
                <li><strong>Elephant Feeding, Bathing & Riding</strong> – Ethical interaction</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Natural healing tour</li>
                <li><strong>Ambuluwawa Tower</strong> – 360° panoramic views</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Silk Factory</strong> – Traditional weaving</li>
            </ul>`
                },
                '4': {
                    title: 'Kandy Sacred Journey',
                    duration: '1 Day',
                    category: 'Spiritual & Cultural',
                    description: 'A soulful day of devotion, heritage, and natural beauty in the sacred city of Kandy.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Temple of the Tooth Relic</strong> – Sacred Buddhist site</li>
                <li><strong>Tea Factory & Plantation</strong> – Fresh tea tasting</li>
                <li><strong>Elephant Feeding, Bathing & Riding</strong> – Gentle giants</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Wellness wisdom</li>
                <li><strong>Ambuluwawa Tower</strong> – Spiral climb to heaven</li>
                <li><strong>Jewellery & Gem Factory</strong> – Local gems</li>
                <li><strong>Silk Factory</strong> – Silk artistry</li>
            </ul>`
                },
                '5': {
                    title: 'Sigiriya Heritage Day',
                    duration: '1 Day',
                    category: 'History & Adventure',
                    description: 'Climb ancient rock fortresses, explore golden caves, and taste authentic village life.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Dambulla Golden Temple</strong> – Ancient cave art</li>
                <li><strong>Village Tour</strong> – Bullock cart, catamaran, traditional lunch</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Healing plants</li>
                <li><strong>Pidurangala Rock</strong> – Best view of Sigiriya</li>
            </ul>`
                },
                '6': {
                    title: 'Galle Coastal Heritage',
                    duration: '1 Day',
                    category: 'History & Nature',
                    description: 'Walk through colonial forts, cruise mangrove rivers, and witness sea turtle conservation.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Kande Viharaya Temple</strong> – Giant Buddha statue</li>
                <li><strong>Turtle Hatchery</strong> – Baby turtles release</li>
                <li><strong>Boat Safari</strong> – Madu River mangroves</li>
                <li><strong>Moonstone Mine</strong> – Gem mining experience</li>
                <li><strong>Dutch Fort Galle</strong> – UNESCO colonial town</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Natural remedies</li>
            </ul>`
                },
                '7': {
                    title: 'Colombo City Discovery',
                    duration: '1 Day',
                    category: 'Urban & Culture',
                    description: 'Explore modern landmarks, sacred sites, and vibrant shopping in Sri Lanka’s bustling capital.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Lotus Tower</strong> – 360° city views</li>
                <li><strong>Red Mosque</strong> – Stunning Islamic architecture</li>
                <li><strong>Shopping</strong> – Local markets & malls</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Wellness stop</li>
                <li><strong>Gangaramaya Temple</strong> – Sacred urban oasis</li>
            </ul>`
                },
                '8': {
                    title: 'Yala Wild Safari',
                    duration: '1 Day',
                    category: 'Wildlife',
                    description: 'Track leopards, elephants, and rare birds in one of Asia’s top national parks.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala Jeep Safari</strong> – 3-hour wildlife adventure</li>
                <li>Spot leopards, elephants, sloth bears, and 200+ bird species</li>
            </ul>`
                },
                '9': {
                    title: 'Mirissa Whale Odyssey',
                    duration: '1 Day',
                    category: 'Marine Adventure',
                    description: 'Sail with blue whales in high-comfort boats — the world’s largest creatures up close.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Blue Whale Watching</strong> – 4-hour ocean safari</li>
                <li><strong>Mirissa Beach</strong> – Relax on golden sands</li>
                <li><strong>Stilt Fishing</strong> – Iconic photo moment</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Coastal wellness</li>
            </ul>`
                },
                '10': {
                    title: 'Udawalawe Elephant Day',
                    duration: '1 Day',
                    category: 'Wildlife & Compassion',
                    description: 'Witness baby elephants being fed and roam with wild herds in their natural habitat.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Udawalawe National Park</strong> – Jeep safari</li>
                <li><strong>Elephant Milk Feeding</strong> – Orphanage visit</li>
            </ul>`
                },
                '11': {
                    title: 'Ella & Galle Express',
                    duration: '1 Day',
                    category: 'Scenic & Heritage',
                    description: 'From mountain trains to colonial forts — a fast-paced journey of beauty and history.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Train Ride</strong> – Ella to Galle</li>
                <li><strong>Little Adam’s Peak</strong> – Sunrise hike</li>
                <li><strong>Dutch Fort Galle</strong> – Sunset walk</li>
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Wellness stop</li>
            </ul>`
                },
                '12': {
                    title: 'Yala & Galle Safari',
                    duration: '1 Day',
                    category: 'Wild & Colonial',
                    description: 'Morning wildlife safari, afternoon heritage walk — the ultimate south coast combo.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala National Park Safari</strong> – Morning jeep tour</li>
                <li><strong>Dutch Fort Galle</strong> – Afternoon colonial walk</li>
            </ul>`
                },
                '13': {
                    title: 'Kandy & Ella & Yala Express',
                    duration: '2 Days',
                    category: 'Cultural & Scenic',
                    description: 'From sacred temples to misty hills and wild safaris — a whirlwind tour of Sri Lanka’s highlights.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala National Park Safari</strong> – Morning jeep tour</li>
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Quick Hike</li>
                <li><strong>Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Temple of the Tooth Relic</strong> – Sacred visit</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Kandy (Luxury Hotel)</h3>`
                },
                '14': {
                    title: 'Kandy Cultural',
                    duration: '2 Days',
                    category: 'Cultural',
                    description: 'Immerse in sacred temples, lush gardens, and local traditions in the heart of Sri Lanka.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Kandy City</strong> – Vibrant cultural hub</li>
                <li><strong>Royal Botanical Garden</strong> – Tropical paradise</li>
                <li><strong>Tea Factory & Plantation</strong> – Ceylon tea experience</li>
                <li><strong>Elephant Feeding, Bathing & Riding</strong> – Ethical interaction</li>
                <li><strong>Ayurvedic Herbal Garden</strong> – Natural healing tour</li>
                <li><strong>Ambuluwawa Tower</strong> – 360° panoramic views</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Silk Factory</strong> – Traditional weaving</li>
                <li><strong>Nelligala</strong> – Traditional Temple</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Kandy (Luxury Hotel)</h3>`
                },
                '15': {
                    title: 'Ella/Nuwara Eliya/Kandy Cultural',
                    duration: '2 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Pink Post Office</strong> – Cultural Beauty</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Ramboda Waterfall</strong></li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Herbal Garden</strong> – Tropical paradise</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Kandy (Luxury Hotel)</h3>`
                },
                '16': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy Cultural',
                    duration: '3 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Yala National Park Safari</strong> – Morning jeep tour</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Pink Post Office</strong> – Cultural Beauty</li>
                <li><strong>Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Temple of the Tooth Relic</strong> – Sacred visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Gem & Jewelry</strong> – Ceylon gem experience</li>
                <li><strong>Wood Carving</strong> – Traditional carving</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Nuwara Eliya & Kandy (Luxury Hotel)</h3>`
                },
                '17': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya Cultural',
                    duration: '3 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Pidurangala</strong> – Scenic hike</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Golden Temple</strong> – Sacred visit</li>
                <li><strong>Sigiriya Lion Rock</strong> – Ancient fortress</li>
                <li><strong>Village Tour with Boat Ride & Traditional Lunch</strong> – Cultural experience</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Nuwara Eliya & Sigiriya (Luxury Hotel)</h3>`
                },
                '18': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa Cultural',
                    duration: '3 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Kandy & Sigiriya (Luxury Hotel)</h3>`
                },
                '19': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Polonnaruwa Cultural',
                    duration: '4 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala National Park Safari</strong> – Morning jeep tour</li>
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Royal Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Ella,Nuwara Eliya & Kandy (Luxury Hotel)</h3>`
                },
                '20': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura Cultural',
                    duration: '5 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala National Park Safari</strong> – Morning jeep tour</li>
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Royal Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4">Day 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Anuradhapura Ancient City Tour</strong> – Historic exploration</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Sigiriya,Nuwara Eliya & Kandy (Luxury Hotel)</h3>`
                },
                '21': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Colombo Cultural',
                    duration: '5 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala National Park Safari</strong> – Morning jeep tour</li>
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Royal Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4">Day 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Colombo City Tour</strong> – Urban exploration</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Nuwara Eliya,Sigiriya,Polonnaruwa & Kandy (Luxury Hotel)</h3>`
                },
                '22': {
                    title: 'Yala/Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Galle Cultural',
                    duration: '5 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Yala National Park Safari</strong> – Morning jeep tour</li>
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Royal Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4">Day 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Galle City</strong> – Colonial exploration</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Nuwara Eliya,Sigiriya,Polonnaruwa & Galle (Luxury Hotel)</h3>`
                },
                '23': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Colombo',
                    duration: '6 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Royal Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4">Day 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Anuradhapura Ancient City Tour</strong> – Historic exploration</li>
            </ul>
            <h3 class="mt-4">Day 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Colombo City Tour</strong> – Urban exploration</li>
                <li><strong>Galle City</strong> – Colonial exploration</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Ella,Nuwara Eliya,Sigiriya (Luxury Hotel)</h3>`
                },
                '24': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Colombo',
                    duration: '6 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Royal Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4">Day 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Anuradhapura Ancient City Tour</strong> – Historic exploration</li>
            </ul>
            <h3 class="mt-4">Day 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Colombo City Tour</strong> – Urban exploration</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Ella,Nuwara Eliya,Kandy,Sigiriya & Colombo (Luxury Hotel)</h3>`
                },
                '25': {
                    title: 'Ella/Nuwara Eliya/Kandy/Sigiriya/Polonnaruwa/Anuradhapura/Galle',
                    duration: '6 Days',
                    category: 'Cultural & Scenic',
                    description: 'From misty highlands to sacred temples — a soulful journey through Sri Lanka’s heartland.',
                    itinerary: `<h3>Day 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Ravana Waterfall</strong> – Quick dip</li>
                <li><strong>Nine Arch Bridge</strong> – Train crossing</li>
                <li><strong>Little Adam's Peak</strong> – Scenic hike</li>
                <li><strong>Train Ride</strong> – Luxury Train Ride</li>
            </ul>
            <h3 class="mt-4">Day 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Tea Plantation</strong> – Hilltop views</li>
                <li><strong>Hindu Temple</strong> – Cultural Visit</li>
                <li><strong>Ambuluwawa</strong> – Serene strolls</li>
                <li><strong>Royal Botanical Gardens</strong> – Tropical paradise</li>
                <li><strong>Tea Factory</strong> – Ceylon tea experience</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Nelligala</strong> – Sacred visit</li>
                <li><strong>Jewellery & Gem Factory</strong> – Sparkling craftsmanship</li>
                <li><strong>Elephant Ride</strong> – Ethical interaction</li>
                <li><strong>Golden Temple</strong> – Cultural Visit</li>
            </ul>
            <h3 class="mt-4">Day 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Sigiriya Lion Rock</strong> – UNESCO World Heritage</li>
                <li><strong>Polonnaruwa Ancient City Tour</strong> – Cultural City</li>
            </ul>
            <h3 class="mt-4">Day 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Anuradhapura Ancient City Tour</strong> – Historic exploration</li>
            </ul>
            <h3 class="mt-4">Day 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Galle City</strong> – Colonial exploration</li>
            </ul>
            <h3 class="mt-4" style="color:red;">Night stay in Ella,Nuwara Eliya,Kandy,Sigiriya & Galle (Luxury Hotel)</h3>`
                },
            },
        },
    },

    ru: {
        translation: {
            home: 'Главная',
            aboutUs: 'О нас',
            sriLankanav: 'Шри-Ланка',
            gallerynav: 'Галерея',
            bookATour: 'Забронировать тур',
            thingsToDo: 'Чем заняться',
            contactUs: 'Связаться с нами',
        },
        contactus: {
            heroTitle: 'Связаться с нами',
            heroSubtitle: 'Aamy Tours Sri Lanka — Ваш путь к незабываемым приключениям на Шри-Ланке',
            feelFree: 'Не стесняйтесь обращаться к нам',
            planDream: 'Спланируйте своё путешествие мечты по Шри-Ланке',
            reachOutDesc: 'Свяжитесь с Aamy Tours Sri Lanka за индивидуальными турами, профессиональными консультациями и незабываемыми впечатлениями по всей Шри-Ланке.',

            callCenter: 'Колл-центр',
            phone: '+94 77 048 3364',
            emailTitle: 'Электронная почта',
            email: 'aamytourssl@gmail.com',
            locationTitle: 'Наш адрес',
            location: '81/31h H.K Edmond Mawatha, Milidduwa, Galle, Шри-Ланка.',
            socialTitle: 'Соцсети',

            getInTouch: 'Связаться',
            getInTouchDesc: 'Откройте Шри-Ланку вместе с Aamy Tours — мы на связи 24/7, чтобы сделать ваше путешествие незабываемым.',

            nameLabel: 'Имя',
            namePlaceholder: 'Ваше полное имя',
            emailLabel: 'Эл. почта',
            emailPlaceholder: 'you@example.com',
            phoneLabel: 'Телефон',
            phonePlaceholder: '+94 7X XXX XXXX',
            messageLabel: 'Сообщение',
            messagePlaceholder: 'Расскажите о путешествии вашей мечты...',

            sendButton: 'Отправить сообщение',
            sendingButton: 'Отправка...',
            successMsg: 'Ваш запрос отправлен через WhatsApp!',
            errorMsg: 'Не удалось открыть WhatsApp. Попробуйте еще раз.',
            findUsTitle: 'Найдите нас в Галле',
        },
        thingstodo: {
            heroTitle: 'Чем заняться на Шри-Ланке',
            heroSubtitle: 'Приключения, культура и оздоровление',
            sectionTitle: 'Чем заняться на Шри-Ланке',
            ayurveda: 'Аюрведа — древняя наука жизни',
            diving: 'Дайвинг на Шри-Ланке',
            elephantRide: 'Катание на слонах',
            fishing: 'Рыбалка на Шри-Ланке',
            ballooning: 'Полёты на воздушном шаре',
            jeepSafari: 'Джип-сафари',
            whiteWaterRafting: 'Рафтинг',
            riverSafari: 'Речное сафари',
            snorkeling: 'Снорклинг на Шри-Ланке',
            teaTasting: 'Дегустация чая',
            templeVisit: 'Посещение храмов',
            wildlifeSafari: 'Сафари по дикой природе',
            viewMore: 'Подробнее',
        },
        gallery: {
            heroTitle: 'Галерея',
            heroSubtitle: 'Запечатлённые моменты, дорогие воспоминания — наша галерея показывает приключения, улыбки и потрясающие виды, которые делают каждое путешествие по Шри-Ланке незабываемым',
            tabPlaces: 'Места',
            tabEvents: 'Мероприятия',
            nuwaraEliya: 'Нувара-Элия',
            sigiriya: 'Сигирия',
            anuradhapura: 'Анурадхапура',
            rambodaFalls: 'Водопад Рамбода',
            ella: 'Элла',
            yala: 'Национальный парк Яла',
            kandy: 'Канди',
            bodhiViharaya: 'Бодхи Вихара',
            knuckles: 'Горы Наклз',
            udawalawe: 'Национальный парк Удавалаве',
            bentota: 'Сафари на лодке в Бентоте',
            colombo: 'Коломбо',
            galle: 'Форт Галле',
            mirissa: 'Пляж Мирисса',
            jaffna: 'Джаффна',
            ambuluwawaTower: 'Башня Амбулувава',
            turtle: 'Черепаший питомник',
            polonnaruwa: 'Древний город Полоннарува',
            polgampala: 'Водный бассейн Полгампала',
            beach: 'Пляжи Шри-Ланки',
        },
        events: {
            heroTitle: 'События',
            heroSubtitle: 'Празднуйте дух Шри-Ланки через её фестивали — от священных буддийских церемоний до ярких культурных шествий, каждое событие — это возможность почувствовать сердце острова.',
            tabPlaces: 'Места',
            tabEvents: 'События',
            kandyPerahera: 'Канди Эсала Перахера (Фестиваль Зуба Будды)',
            vesak: 'Фестиваль Весак',
            sinhalaNewYear: 'Сингальский и тамильский Новый год',
            christmas: 'Рождество',
            thaiPongal: 'Тай Понгал',
            deepavali: 'Дивали',
            holi: 'Холи',
            poson: 'Фестиваль Посон',
        },
        // Inside resources → ru → srilanka
        srilanka: {
            heroTitle: 'Откройте для себя Шри-Ланку',
            heroSubtitle: 'Жемчужина Индийского океана',

            sectionPlaces: 'Лучшие достопримечательности Шри-Ланки',
            sectionFamous: 'Знаменитые вещи Шри-Ланки',
            viewMore: 'Подробнее',

            // Intro paragraphs
            intro1: 'Шри-Ланка, известная как «Изумрудный остров», — тропическая жемчужина, славящаяся потрясающими пейзажами, древним наследием и искренним гостеприимством.',
            intro2: 'Наследие острова насчитывает более двух тысячелетий. Здесь находятся объекты ЮНЕСКО: скальная крепость Сигирия и священный город Анурадхапура. Культурное богатство сочетает буддийские, индуистские и колониальные влияния, видимые в ярких фестивалях и изысканной архитектуре.',
            intro3: 'Разнообразие ландшафтов завораживает — от волнистых чайных плантаций Эллы до бирюзовых вод Тринкомали. Национальные парки, такие как Вилпатту, служат домом для леопардов, крокодилов и редких птиц, радуя любителей природы.',
            intro4: 'Для искателей приключений Шри-Ланка предлагает рафтинг, сёрфинг в Аругам-Бее и треккинг по пышным джунглям. Кухня, наполненная ароматными специями, свежей рыбой и джекфрутом, рассказывает историю традиций и вкуса.',
            intro5: 'От священных паломничеств до спокойного отдыха на пляжах — Шри-Ланка обещает завораживающий опыт, полный красоты и культуры.',

            // Places
            sigiriya: 'Крепость Сигирия',
            sigiriyaDesc: 'Объект ЮНЕСКО с древними садами, фресками и захватывающими видами с вершины.',

            templeOfTooth: 'Храм Зуба Будды',
            templeOfToothDesc: 'Священное буддийское место, где хранится реликвия — зуб Будды.',

            ella: 'Элла',
            ellaDesc: 'Горный городок среди чайных плантаций, знаменитый мостом Девяти арок.',

            yala: 'Национальный парк Яла',
            yalaDesc: 'Известен слонами, леопардами и сафари по дикой природе.',

            galleFort: 'Форт Галле',
            galleFortDesc: 'Колониальная крепость с мощеными улочками и голландской архитектурой.',

            nuwaraEliya: 'Нувара-Элия',
            nuwaraEliyaDesc: 'Известна как «Маленькая Англия» благодаря прохладному климату и чайным плантациям.',

            adamsPeak: 'Пик Адама (Шри Пада)',
            adamsPeakDesc: 'Священная гора с уникальным отпечатком стопы — место паломничества.',

            hortonPlains: 'Национальный парк Хортон-Плейнс',
            hortonPlainsDesc: 'Холмы, водопады и обзорная точка «Конец света».',

            bentota: 'Пляж Бентота',
            bentotaDesc: 'Чистое побережье с золотым песком и водными видами спорта.',

            jaffna: 'Джаффна',
            jaffnaDesc: 'Богата тамильской культурой, историей и кухней.',

            anuradhapura: 'Анурадхапура',
            anuradhapuraDesc: 'Древний город с священными буддийскими местами и руинами.',

            polonnaruwa: 'Полоннарува',
            polonnaruwaDesc: 'Объект ЮНЕСКО с хорошо сохранившимися храмами и статуями.',

            unawatuna: 'Пляж Унаватуна',
            unawatunaDesc: 'Живописный пляж со снорклингом и ночной жизнью.',

            colombo: 'Коломбо',
            colomboDesc: 'Шумная столица с современной и колониальной архитектурой.',

            udawalawe: 'Национальный парк Удавалаве',
            udawalaweDesc: 'Известен большими стадами слонов и потрясающими пейзажами.',

            dambulla: 'Пещерный храм Дамбулла',
            dambullaDesc: 'Объект ЮНЕСКО с древними буддийскими фресками и статуями.',

            // Famous Things
            ceylonTea: 'Цейлонский чай',
            ceylonTeaDesc: 'Мировая слава за вкус, особенно из Нувара-Элии и Увы.',

            spices: 'Специи',
            spicesDesc: 'Корица, кардамон, гвоздика — шри-ланкийская корица лучшая в мире.',

            gems: 'Драгоценные камни',
            gemsDesc: 'Сапфиры, рубины, лунные камни — остров редких самоцветов.',

            ayurveda: 'Аюрведа',
            ayurvedaDesc: 'Оздоровительные процедуры с массажами и травяными терапиями.',

            handicrafts: 'Ремёсла',
            handicraftsDesc: 'Маски, батик, деревянная резьба, лаковая посуда.',

            elephants: 'Слоны',
            elephantsDesc: 'Культурный символ, участвуют в грандиозных фестивальных шествиях.',

            food: 'Традиционная еда',
            foodDesc: 'Рис с карри, хопперсы, котту роти, ватталаппам.',

            festivals: 'Фестивали',
            festivalsDesc: 'Эсала Перахера, Весак, сингальско-тамильский Новый год.',

            coconut: 'Кокосовые продукты',
            coconutDesc: 'Масло, молоко, койр для верёвок и циновок.',

            sarees: 'Сари в стиле Канди',
            sareesDesc: 'Элегантная традиционная одежда для церемоний.',

            dances: 'Традиционные танцы',
            dancesDesc: 'Кандийские, танцы дьявола и танцы низин.',

            stiltFishing: 'Рыбалка на сваях',
            stiltFishingDesc: 'Иконический способ рыбалки на южном побережье.',

            moonstones: 'Лунные камни',
            moonstonesDesc: 'Полудрагоценные камни, знаменитые копи Митиягода.',

            cricket: 'Крикет',
            cricketDesc: 'Национальная страсть — чемпионы мира 1996 года.',

            herbs: 'Аюрведические травы',
            herbsDesc: 'Готу кола, корица, ним для лекарственных средств.',

            masks: 'Маски',
            masksDesc: 'Маски из Амбалангода, используемые в ритуальных представлениях.',
        },
        ayurveda: {
            title: "Аюрведа — Древняя наука жизни",

            introParagraph1: "Слово «Аюрведа» существует более трёх тысяч лет. На санскрите оно означает «наука жизни». Метод основан на аюрведическом взгляде на болезнь, а не на её последствиях, в отличие от европейской медицины. Он постулирует следующие принципы:",

            corePrinciplesTitle: "Основные принципы",
            principle1: "Тело должно быть свободно от блокировок энергии и поддерживать баланс для нормальной метаболической и сердечной деятельности.",
            principle2: "Тело должно иметь нормальное сокращение мышц при регулярной гормональной активности.",
            principle3: "Для правильного функционирования организму нужна здоровая иммунная система.",

            sriLankaDoctors: "По последним данным, на Шри-Ланке более 6000 выпускников, обученных Аюрведе. Они проходят семь лет обучения и два года практики в государственных больницах. Программы Аюрведы включают:",

            benefit1: "Снятие стресса, усталости и тревоги",
            benefit2: "Насыщение кислородом",
            benefit3: "Стимуляция мышечных систем и выведение токсинов",
            benefit4: "Восстановление баланса нервной системы",
            benefit5: "Восстановление кровотока к внутренним органам",
            benefit6: "Выработка эндорфинов",

            mainImageAlt: "Аюрведа и оздоровление",

            faceTreatmentAlt: "Аюрведический уход за лицом",
            faceTreatmentCaption: "Аюрведический уход за лицом",

            massageTreatmentAlt: "Аюрведический массаж",
            massageTreatmentCaption: "Аюрведический массаж",

            treatmentDescription: "Стандартные процедуры включают массаж тела и головы с использованием специальных масел, травяные сауны и ванны с травами. Самая популярная техника — «Широдхара», при которой тёплое травяное масло ритмично льётся на лоб. Это помогает восстановить баланс нервной системы и достичь глубокого расслабления.",

            tipsTitle: "Советы для аюрведического лечения",
            tip1: "Забудьте о проблемах. Расслабьтесь и очистите разум для наилучшего результата.",
            tip2: "Выберите правильное место. Подберите атмосферу, которая соответствует вашему комфорту и предпочтениям.",
            tip3: "Выберите подходящую программу. Обсудите свои проблемы с врачом и попробуйте разные терапии.",
            tip4: "Примите тёплую ванну перед процедурой, чтобы расслабить мышцы.",
            tip5: "Съешьте лёгкую еду перед процедурой. Избегайте тяжёлой пищи для нормального кровотока.",
            tip6: "Отдых после процедур обязателен. Правильное расслабление усиливает эффект лечения."
        },
        ballooning: {
            title: "Полёты на воздушном шаре на Шри-Ланке",

            introParagraph1: "Полёты на воздушном шаре на Шри-Ланке — это незабываемый опыт парения над потрясающими пейзажами острова. Начинаются полёты на рассвете и дарят захватывающие виды с высоты на холмы, густые леса, древние руины и уютные деревни.",
            introParagraph2: "Самое популярное место для полётов — Дамбулла в центре культурного треугольника. Здесь вы часто пролетаете над легендарной скалой Сигирия, получая уникальный ракурс. Полёт длится 60–90 минут — достаточно, чтобы насладиться красотой Шри-Ланки с высоты птичьего полёта.",

            mainImageAlt: "Полёт на воздушном шаре на Шри-Ланке",
            mainImageCaption: "Полёт на воздушном шаре на Шри-Ланке",

            highlightsTitle: "Почему стоит попробовать полёт на шаре на Шри-Ланке?",
            highlightsIntro: "Полёт на воздушном шаре сочетает приключение и спокойствие, позволяя увидеть красоту Шри-Ланки совершенно по-новому. Главные преимущества:",

            highlight1: "Беспрепятственный панорамный обзор потрясащих ландшафтов острова.",
            highlight2: "Пролёт над знаковыми достопримечательностями — скала Сигирия, озёра.",
            highlight3: "Спокойный и умиротворяющий полёт над зелёными джунглями и деревнями.",
            highlight4: "Наблюдение за невероятным рассветом с высоты.",
            highlight5: "Идеально для фотографов — лучшие кадры с высоты.",

            sunriseImageAlt: "Наслаждайтесь захватывающим рассветом, паря в воздушном шаре.",
            sunriseImageCaption: "Наслаждайтесь захватывающим рассветом, паря в воздушном шаре.",

            landscapeImageAlt: "Любуйтесь потрясающими пейзажами Шри-Ланки с высоты — холмы, леса, озёра.",
            landscapeImageCaption: "Любуйтесь потрясающими пейзажами Шри-Ланки с высоты — холмы, леса, озёра.",

            tipsTitle: "Советы для незабываемого полёта",
            tip1: "Бронируйте заранее — полёты зависят от погоды, места быстро разбирают.",
            tip2: "Одевайтесь удобно и возьмите лёгкую куртку — ранним утром прохладно.",
            tip3: "Берите камеру или телефон — виды потрясающие.",
            tip4: "Внимательно слушайте инструктаж пилота по технике безопасности.",
            tip5: "Приезжайте вовремя — подготовка и надувание шара — это увлекательное зрелище."
        },
        diving: {
            title: "Дайвинг на Шри-Ланке",

            introParagraph1: "Широкий коралловый риф окружает побережье Шри-Ланки на глубине от 2 до 40 метров. Тёплые воды Индийского океана (27–30°C) и высокая прозрачность (15–35 м) создают идеальные условия для дайвинга и снорклинга. Здесь можно исследовать нетронутые коралловые рифы, старые затонувшие корабли и завораживающие подводные пещеры.",
            introParagraph2: "На северо-востоке острова обитает более 130 видов ярких кораллов, где живут морские черепахи, рыбы-клоуны, крылатки и морские коньки. Посещение затонувших кораблей у подводных скал — незабываемое приключение. Паря в чистейшей воде, вы погружаетесь в удивительное прошлое Цейлона.",

            mainImageAlt: "Дайвинг на Шри-Ланке",
            mainImageCaption: "Дайвинг на Шри-Ланке",

            facilitiesTitle: "Дайв-центры и лучшие споты",
            facilitiesParagraph1: "Дайв-центры острова оснащены современным оборудованием от ведущих производителей. Сертифицированные инструкторы PADI и CMAS гарантируют безопасность и удовольствие. Центры на юго-западе работают с середины октября по конец апреля, на северо-востоке (Нилавели, Тринкомали) — с марта по октябрь.",
            facilitiesParagraph2: "Коралловые рифы у Калпитии на западе и места с затонувшими кораблями в Хиккадуве — самые популярные среди дайверов.",

            coralImageAlt: "Исследуйте яркие коралловые рифы — дом для разнообразной морской жизни.",
            coralImageCaption: "Исследуйте яркие коралловые рифы — дом для разнообразной морской жизни.",

            shipwreckImageAlt: "Откройте исторические затонувшие корабли — окно в морское прошлое Шри-Ланки.",
            shipwreckImageCaption: "Откройте исторические затонувшие корабли — окно в морское прошлое Шри-Ланки.",

            tipsTitle: "Советы дайверам",
            tip1: "Выбирайте сезон: юго-запад (октябрь–апрель) или северо-восток (март–октябрь).",
            tip2: "Убедитесь, что дайв-центр сертифицирован и имеет современное оборудование.",
            tip3: "Слушайте инструктора — особенно важно для новичков.",
            tip4: "Не трогайте кораллы и не тревожьте морских обитателей.",
            tip5: "Возьмите водонепроницаемую камеру — подводный мир Шри-Ланки завораживает."
        },
        elephantRide: {
            title: "Катание на слонах",

            introParagraph1: "Катание на слонах — увлекательное и уникальное приключение на Шри-Ланке. Если вы остановились рядом с культурным треугольником (Хабарана, Сигирия, Дамбулла), вы легко можете отправиться на сафари на слоне. Стоимость — от $30 за час незабываемого приключения.",
            introParagraph2: "Перед поездкой на слона надевают специальное многоместное седло на 4–6 человек. Эти добрые великаны проведут вас по живописным джунглевым тропам, пересекут затопленные участки и проберутся сквозь густую растительность. Слоны идут медленно, позволяя в полной мере насладиться красотой природы, хотя способны развивать скорость до 40 км/ч.",

            mainImageAlt: "Катание на слоне",
            mainImageCaption: "Катание на слоне",

            highlightsTitle: "Главные моменты катания на слоне",
            highlightsIntro: "Катание на слоне — уникальный способ познакомиться с природой и сельской местностью Шри-Ланки. Основные впечатления:",
            highlight1: "Прогулка по густым джунглям с экзотической растительностью и животными.",
            highlight2: "Переход через реки и затопленные участки с потрясающими видами.",
            highlight3: "Знакомство с тесной связью слонов и культуры Шри-Ланки.",
            highlight4: "Комфортное путешествие в седле по разным ландшафтам.",

            jungleImageAlt: "Исследуйте густые джунгли и живописные тропы на спине слона.",
            jungleImageCaption: "Исследуйте густые джунгли и живописные тропы на спине слона.",

            waterImageAlt: "Пересекайте реки и наслаждайтесь спокойной красотой воды и растительности.",
            waterImageCaption: "Пересекайте реки и наслаждайтесь спокойной красотой воды и растительности.",

            tipsTitle: "Советы для безопасного и приятного катания",
            tip1: "Одежда и обувь должны быть удобными для активного отдыха.",
            tip2: "Строго следуйте инструкциям гида.",
            tip3: "Выбирайте оператора, который заботится о благополучии слонов и соблюдает этичные практики.",
            tip4: "Возьмите фотоаппарат — виды потрясающие.",
            tip5: "Уважайте слонов и не делайте ничего, что может их стрессовать или навредить."
        }, fishing: {
            title: "Рыбалка на Шри-Ланке",

            introParagraph1: "Шри-Ланка с её огромным побережьем и множеством пресноводных озёр и рек предлагает непревзойдённый рыболовный опыт. Будь вы профессионалом или любителем — здесь найдётся занятие по душе. От глубоководной морской рыбалки до традиционной рыбалки на сваях, которой занимаются местные рыбаки — приключение будет незабываемым.",
            introParagraph2: "Популярные места: южное побережье (Галле, Мирисса), лагуна Негомбо и спокойные воды Тринкомали. В зависимости от предпочтений можно попробовать троллинг, донную рыбалку или нахлыст.",

            mainImageAlt: "Рыбалка на Шри-Ланке",
            mainImageCaption: "Рыбалка на Шри-Ланке",

            experiencesTitle: "Виды рыбалки на Шри-Ланке",
            experiencesIntro: "Рыбалка на Шри-Ланке — это не только улов, но и возможность погрузиться в культуру и традиции острова. Уникальные виды рыбалки:",

            expStiltTitle: "Рыбалка на сваях",
            expStiltDesc: "Традиционный метод: рыбаки сидят на высоких сваях у берега. Это уникальное явление только для Шри-Ланки.",

            expDeepSeaTitle: "Глубоководная морская рыбалка",
            expDeepSeaDesc: "Выход в Индийский океан за марлинами, тунцами, барракудами и другими крупными трофеями.",

            expLagoonTitle: "Рыбалка в лагунах и реках",
            expLagoonDesc: "Спокойная рыбалка в тихих лагунах и реках, богатых тилапией, сомами и другими видами.",

            expNightTitle: "Ночная рыбалка",
            expNightDesc: "Непередаваемые ощущения от рыбалки под звёздами — популярная практика в прибрежных деревнях.",

            stiltImageAlt: "Рыбалка на сваях — традиционный и иконический образ рыболовного наследия Шри-Ланки.",
            stiltImageCaption: "Рыбалка на сваях — традиционный и иконический образ рыболовного наследия Шри-Ланки.",

            deepSeaImageAlt: "Глубоководная рыбалка — приключение с крупной рыбой в Индийском океане.",
            deepSeaImageCaption: "Глубоководная рыбалка — приключение с крупной рыбой в Индийском океане.",

            tipsTitle: "Советы для удачной рыбалки",
            tip1: "Выбирайте сезон: южное побережье — октябрь–апрель, восточное — март–октябрь.",
            tip2: "Возьмите солнцезащитный крем, шляпу и удобную одежду.",
            tip3: "Закажите гида или чартер — так вы получите максимум впечатлений и знаний.",
            tip4: "Уважайте природу: не мусорите и соблюдайте принципы устойчивой рыбалки.",
            tip5: "Берите воду и перекус — особенно на длительных выездах."
        },
        jeepSafari: {
            title: "Джип-сафари на Шри-Ланке",

            introParagraph1: "Национальные парки Шри-Ланки предлагают захватывающее джип-сафари, позволяющее исследовать богатое биоразнообразие острова и наблюдать за животными в их естественной среде. Самые популярные — Яла, Вилпатту и Удавалаве.",
            introParagraph2: "Во время сафари можно увидеть слонов, леопардов, медведей-губачей, буйволов, крокодилов и сотни видов птиц. Опытные натуралисты и трекеры сопровождают группы — идеально для любителей дикой природы и фотографов.",

            mainImageAlt: "Джип-сафари на Шри-Ланке",
            mainImageCaption: "Джип-сафари на Шри-Ланке",

            whyChooseTitle: "Почему стоит выбрать джип-сафари?",
            whyChooseIntro: "Джип-сафари — один из лучших способов познакомиться с дикой природой Шри-Ланки. Основные преимущества:",

            highlight1: "Близкие встречи с культовыми животными — слонами, леопардами.",
            highlight2: "Доступ к отдалённым и живописным уголкам национальных парков.",
            highlight3: "Отличные возможности для съёмки дикой природы.",
            highlight4: "Сопровождение опытных натуралистов и рейнджеров.",
            highlight5: "Приключение для всех возрастов — сочетание азарта и познавательности.",

            wildlifeImageAlt: "Наблюдайте за леопардами, слонами и крокодилами во время сафари.",
            wildlifeImageCaption: "Наблюдайте за леопардами, слонами и крокодилами во время сафари.",

            landscapeImageAlt: "Исследуйте потрясающие пейзажи национальных парков — от густых лесов до открытых равнин.",
            landscapeImageCaption: "Исследуйте потрясающие пейзажи национальных парков — от густых лесов до открытых равнин.",

            tipsTitle: "Советы для удачного джип-сафари",
            tip1: "Носите удобную одежду нейтральных тонов, чтобы не выделяться.",
            tip2: "Берите солнцезащитный крем, шляпу и репеллент от насекомых.",
            tip3: "Не забудьте бинокль и фотоаппарат — для наблюдений и съёмки.",
            tip4: "Слушайте гида — это важно для безопасности и уважения к животным.",
            tip5: "Бронируйте сафари заранее, особенно в высокий сезон."
        },
        riverSafari: {
            title: "Речное сафари на Шри-Ланке",

            introParagraph1: "Речное сафари на Шри-Ланке — уникальный способ исследовать богатое биоразнообразие и красоту острова. Плавно скользите по спокойным водам среди пышных мангровых зарослей, наблюдайте экзотических животных и наслаждайтесь потрясающими закатами.",
            introParagraph2: "Самые популярные места — река Маду Ганга и река Бентота. Здесь можно увидеть множество птиц, варанов, крокодилов и даже обезьян в их естественной среде. Спокойная атмосфера идеально подходит для любителей природы и фотографов.",

            mainImageAlt: "Речное сафари на Шри-Ланке",
            mainImageCaption: "Речное сафари на Шри-Ланке",

            whyChooseTitle: "Почему стоит выбрать речное сафари?",
            whyChooseIntro: "Речное сафари — это расслабляющее и глубокое погружение в природу, дикую жизнь и культуру. Основные преимущества:",

            highlight1: "Исследование пышных мангровых зарослей, полных жизни.",
            highlight2: "Наблюдение за экзотическими птицами, крокодилами и другими животными.",
            highlight3: "Посещение маленьких островов и деревень вдоль реки.",
            highlight4: "Наслаждение спокойствием и живописной красотой водных путей Шри-Ланки.",
            highlight5: "Идеально для семей, пар и одиночных путешественников, ищущих умиротворения.",

            mangrovesImageAlt: "Откройте для себя пышные мангровые заросли вдоль живописных водных путей Шри-Ланки.",
            mangrovesImageCaption: "Откройте для себя пышные мангровые заросли вдоль живописных водных путей Шри-Ланки.",

            wildlifeImageAlt: "Наблюдайте крокодилов, варанов и ярких птиц во время сафари.",
            wildlifeImageCaption: "Наблюдайте крокодилов, варанов и ярких птиц во время сафари.",

            tipsTitle: "Советы для приятного речного сафари",
            tip1: "Одежда должна быть удобной, возьмите шляпу и солнцезащитный крем.",
            tip2: "Берите бинокль — поможет разглядеть животных и птиц.",
            tip3: "Не забудьте фотоаппарат или телефон для съёмки потрясающих видов.",
            tip4: "Слушайте гида — это важно для безопасности и удовольствия.",
            tip5: "Уважайте природу: не мусорите и не беспокойте животных."
        },
        snorkeling: {
            title: "Снорклинг на Шри-Ланке",

            introParagraph1: "Снорклинг на Шри-Ланке — это незабываемый подводный опыт: яркие коралловые рифы и разнообразная морская жизнь. Кристально чистая вода и богатые экосистемы делают остров настоящим раем для снорклинга всех уровней.",
            introParagraph2: "Лучшие места: Хиккадува с её красочными коралловыми садами и черепахами, остров Пиджеон в Тринкомали с нетронутыми рифами и Мирисса, где в сезон можно увидеть даже китов.",

            mainImageAlt: "Снорклинг на Шри-Ланке",
            mainImageCaption: "Снорклинг на Шри-Ланке",

            whyChooseTitle: "Почему стоит выбрать снорклинг на Шри-Ланке?",
            whyChooseIntro: "Снорклинг на Шри-Ланке — это волшебное сочетание приключений и природной красоты. Основные преимущества:",

            highlight1: "Исследование ярких коралловых рифов, полных жизни.",
            highlight2: "Плавание рядом с тропическими рыбами, черепахами и рифовыми акулами.",
            highlight3: "Открытие нетронутых подводных пейзажей в тёплой прозрачной воде.",
            highlight4: "Подходит и новичкам, и опытным снорклерам.",
            highlight5: "Доступно с лучших пляжных курортов острова.",

            coralImageAlt: "Откройте потрясающие коралловые рифы и их яркие экосистемы.",
            coralImageCaption: "Откройте потрясающие коралловые рифы и их яркие экосистемы.",

            marineLifeImageAlt: "Встретьтесь с разнообразной морской жизнью — черепахами, тропическими рыбами и не только.",
            marineLifeImageCaption: "Встретьтесь с разнообразной морской жизнью — черепахами, тропическими рыбами и не только.",

            tipsTitle: "Советы для незабываемого снорклинга",
            tip1: "Используйте удобную маску и трубку — для чёткого обзора под водой.",
            tip2: "Наносите только риф-безопасный солнцезащитный крем.",
            tip3: "Плавайте спокойно — не трогайте и не тревожьте кораллы и рыб.",
            tip4: "Пейте воду и делайте перерывы между заплывами.",
            tip5: "Берите тур с гидом — лучшие споты и безопасность гарантированы."
        },
        teaTasting: {
            title: "Дегустационный тур по чаю на Шри-Ланке",

            introParagraph1: "Шри-Ланка, часто называемая «жемчужиной Индийского океана», славится своим чаем мирового уровня. Отправьтесь в дегустационный тур по чайным плантациям в Нувара-Элии, Элле и Канди. Узнайте об искусстве выращивания чая, тонкостях производства и насладитесь богатым вкусом настоящего цейлонского чая.",
            introParagraph2: "Будь вы настоящим чайным гурманом или просто любопытным путешественником — тур по чайным плантациям подарит уникальную возможность погрузиться в чайное наследие Шри-Ланки и насладиться спокойной красотой горных районов.",

            mainImageAlt: "Дегустационный тур по чаю на Шри-Ланке",
            mainImageCaption: "Дегустационный тур по чаю на Шри-Ланке",

            whyChooseTitle: "Почему стоит выбрать чайный тур?",
            whyChooseIntro: "Чайный тур на Шри-Ланке — это не просто дегустация, это полное культурное погружение. Основные впечатления:",

            highlight1: "Посещение живописных чайных плантаций в прохладных горах.",
            highlight2: "Знакомство с историей и значением цейлонского чая.",
            highlight3: "Участие в сборе чайного листа и наблюдение за процессом на фабрике.",
            highlight4: "Дегустация разных сортов — от чёрного до зелёного и ароматизированного.",
            highlight5: "Наслаждение потрясающими видами туманных гор и водопадов.",

            plantationImageAlt: "Исследуйте пышные чайные плантации и узнайте о выращивании чая.",
            plantationImageCaption: "Исследуйте пышные чайные плантации и узнайте о выращивании чая.",

            preparationImageAlt: "Познакомьтесь с искусством приготовления чая и попробуйте настоящий цейлонский чай.",
            preparationImageCaption: "Познакомьтесь с искусством приготовления чая и попробуйте настоящий цейлонский чай.",

            tipsTitle: "Советы для приятного чайного тура",
            tip1: "Одежда и обувь должны быть удобными — много ходьбы по плантациям.",
            tip2: "Возьмите лёгкую куртку — в горах прохладно и туманно.",
            tip3: "Пробуйте разные сорта и покупайте любимые в качестве сувениров.",
            tip4: "Задавайте вопросы — гиды с радостью расскажут всё о производстве.",
            tip5: "Сочетайте тур с посещением водопадов и смотровых площадок поблизости."
        },
        templeVisit: {
            title: "Посещение храмов на Шри-Ланке",

            introParagraph1: "Шри-Ланка, известная как «Земля Будды», хранит древние храмы — воплощение богатого духовного и культурного наследия. Посетите знаменитые храмы: Храм Зуба Будды в Канди, пещерный храм Дамбулла и ступу Руванвелисея в Анурадхапуре.",
            introParagraph2: "Эти священные места украшены тонкой резьбой, фресками и статуями, открывая тайны духовных традиций и архитектурного гениальности острова. Посещение храма — это не только культурное путешествие, но и возможность обрести покой и умиротворение.",

            mainImageAlt: "Посещение храмов на Шри-Ланке",
            mainImageCaption: "Посещение храмов на Шри-Ланке",

            whyVisitTitle: "Почему стоит посетить храмы Шри-Ланки?",
            whyVisitIntro: "Посещение храмов — уникальная возможность прикоснуться к истории, культуре и духовности острова. Основные впечатления:",

            highlight1: "Любоваться изящной архитектурой и древними статуями.",
            highlight2: "Узнавать о буддийских традициях и ритуалах от опытных гидов.",
            highlight3: "Посещать объекты ЮНЕСКО, такие как Золотой пещерный храм Дамбулла.",
            highlight4: "Ощущать спокойствие и духовную атмосферу священных мест.",
            highlight5: "Стать свидетелем ярких фестивалей, например, Эсала Перахера в Храме Зуба.",

            interiorImageAlt: "Восхищайтесь потрясающими интерьерами с тонкой резьбой и фресками.",
            interiorImageCaption: "Восхищайтесь потрясающими интерьерами с тонкой резьбой и фресками.",

            sacredImageAlt: "Посетите священные храмы, такие как Руванвелисея, и погрузитесь в духовные традиции.",
            sacredImageCaption: "Посетите священные храмы, такие как Руванвелисея, и погрузитесь в духовные традиции.",

            tipsTitle: "Советы при посещении храмов Шри-Ланки",
            tip1: "Одевайтесь скромно: плечи и колени должны быть закрыты.",
            tip2: "Снимайте обувь перед входом в храм.",
            tip3: "Не прикасайтесь к статуям и священным предметам.",
            tip4: "По желанию оставьте небольшое пожертвование храму.",
            tip5: "Соблюдайте тишину и уважайте духовную атмосферу."
        },
        whiteWaterRafting: {
            title: "Рафтинг по бурным рекам на Шри-Ланке",

            introParagraph1: "Рафтинг на Шри-Ланке — это настоящий взрыв адреналина, особенно в Китулгале — приключенческой столице острова. Река Келани с её бурными порогами и живописными берегами идеально подходит как для новичков, так и для опытных рафтеров.",
            introParagraph2: "Обычно маршрут составляет 5 км с порогами 2–4 категории сложности. Вы получите массу эмоций, проходя сложные участки, и одновременно насладитесь пышной зеленью и потрясающими видами вдоль реки.",

            mainImageAlt: "Рафтинг по бурным рекам на Шри-Ланке",
            mainImageCaption: "Рафтинг по бурным рекам на Шри-Ланке",

            whyChooseTitle: "Почему стоит выбрать рафтинг на Шри-Ланке?",
            whyChooseIntro: "Рафтинг на Шри-Ланке сочетает приключения и невероятную природную красоту. Основные преимущества:",

            highlight1: "Прохождение захватывающих порогов под руководством опытных инструкторов.",
            highlight2: "Наслаждение видами тропического леса и горных пейзажей.",
            highlight3: "Возможность совместить рафтинг с трекингом, наблюдением за птицами и каньонингом в Китулгале.",
            highlight4: "Идеально для компаний, семей и одиночных путешественников, ищущих адреналина.",

            actionImageAlt: "Почувствуйте выброс адреналина, покоряя сложные пороги реки Келани.",
            actionImageCaption: "Почувствуйте выброс адреналина, покоряя сложные пороги реки Келани.",

            scenicImageAlt: "Наслаждайтесь спокойной красотой пышных окрестностей во время рафтинга.",
            scenicImageCaption: "Наслаждайтесь спокойной красотой пышных окрестностей во время рафтинга.",

            tipsTitle: "Советы для безопасного и яркого рафтинга",
            tip1: "Обязательно надевайте спасательный жилет и шлем, выданные инструктором.",
            tip2: "Внимательно слушайте инструктаж по технике безопасности перед стартом.",
            tip3: "Одежда — удобная, быстро сохнущая; обувь — надёжно фиксирующаяся (водные тапочки).",
            tip4: "Берите с собой сменную одежду и полотенце на после сплава.",
            tip5: "Бронируйте тур у проверенного оператора — это гарантия безопасности и удовольствия."
        },
        wildlifeSafari: {
            title: "Сафари по дикой природе на Шри-Ланке",

            introParagraph1: "Шри-Ланка славится богатым биоразнообразием и предлагает потрясающие сафари в национальных парках Яла, Вилпатту, Миннерия и Удавалаве. Здесь можно увидеть слонов, леопардов, медведей-ленивцев и сотни видов птиц в их естественной среде.",
            introParagraph2: "Исследуйте разнообразные ландшафты — от густых джунглей до открытых саванн. С опытными гидами и надёжными джипами сафари на Шри-Ланке станет незабываемым приключением для всех любителей природы.",

            mainImageAlt: "Сафари по дикой природе на Шри-Ланке",
            mainImageCaption: "Сафари по дикой природе на Шри-Ланке",

            whyChooseTitle: "Почему стоит выбрать сафари на Шри-Ланке?",
            whyChooseIntro: "Сафари на Шри-Ланке — уникальная возможность прикоснуться к дикой природе и узнать о невероятном биоразнообразии острова. Основные впечатления:",

            highlight1: "Наблюдение за знаковыми животными: слонами, леопардами, крокодилами.",
            highlight2: "Исследование густых лесов, болот и открытых равнин, полных жизни.",
            highlight3: "Великолепная фотосъёмка животных в естественной среде.",
            highlight4: "Волнение от поиска редкого шри-ланкийского леопарда.",
            highlight5: "Узнайте о программах сохранения природы от опытных гидов.",

            elephantsImageAlt: "Наблюдайте за величественными слонами на свободе в национальных парках Шри-Ланки.",
            elephantsImageCaption: "Наблюдайте за величественными слонами на свободе в национальных парках Шри-Ланки.",

            leopardImageAlt: "Увидеть неуловимого шри-ланкийского леопарда — главная цель любого сафари.",
            leopardImageCaption: "Увидеть неуловимого шри-ланкийского леопарда — главная цель любого сафари.",

            tipsTitle: "Советы для яркого сафари",
            tip1: "Одежда нейтральных тонов — чтобы не спугнуть животных.",
            tip2: "Солнцезащитный крем, шляпа и репеллент — обязательно.",
            tip3: "Бинокль и фотоаппарат с хорошим зумом — must-have.",
            tip4: "Слушайте гида — это важно для безопасности и успеха.",
            tip5: "Бронируйте заранее, особенно в высокий сезон — места в Яле улетают мгновенно."
        },
        about: {
            hero: {
                discover: "ОТКРОЙТЕ ДЛЯ СЕБЯ",
                aamyTours: "AAMY TOURS",
                tagline1: "От древних цитаделей до изумрудных чайных холмов и захватывающих сафари — Шри-Ланка пульсирует жизнью. Этот остров — не просто направление, это приключение, трогающее душу.",
                tagline2: "Тёплые золотые берега, туманные нагорья и бесконечные чудеса ждут вас. С Aamy Tours Sri Lanka каждое мгновение превращается в драгоценное воспоминание."
            },
            slider: {
                sigiriya: "Крепость Сигирия",
                yala: "Национальный парк Яла",
                tea: "Чайные плантации",
                beaches: "Нетронутые пляжи",
                temples: "Священные храмы"
            },
            about: {
                title: "О компании Aamy Tours Sri Lanka",
                signature: "Фирменные путешествия по Шри-Ланке"
            },
            tours: {
                days4: "4 дня",
                classic: "КЛАССИЧЕСКАЯ ОДИССЕЯ",
                days5: "5 дней",
                safari: "САФАРИ-ТУРЫ",
                days6: "6 дней",
                retreat: "Осознанный ретрит",
                desc1: "С Aamy Tours Sri Lanka вы отправитесь в путешествие по каждому уголку этого потрясающего острова — от шумных городов до туманных нагорий и нетронутых южных берегов.",
                desc2: "Познайте лучшее, что есть на Шри-Ланке — от священного сердца Канди до яркого Коломбо и спокойной красоты Южного побережья.",
                desc3: "Хотите приключений, культуры, дикой природы или умиротворения — Aamy Tours Sri Lanka создаёт незабываемые путешествия в любое время года."
            },
            whoWeAre: {
                title: "Кто мы",
                description: "Добро пожаловать в Aamy Tours Sri Lanka — ваш надёжный проводник по всем провинциям этого волшебного острова. Имея <strong>более 14 лет опыта</strong>, наша страстная местная команда создаёт глубокие путешествия, выходяbfe за рамки обычного туризма — раскрывая душу острова, богатое наследие и захватывающую природную красоту.",
                imageAlt: "Команда Aamy Tours",
                item1: { title: "Путешествия по всему острову", text: "Мы работаем во всех провинциях — от Севера до самого Юга, предлагая аутентичный местный опыт везде." },
                item2: { title: "Индивидуальные маршруты", text: "Каждый маршрут создаётся под ваши увлечения — приключения, культура, природа или отдых." },
                item3: { title: "Профессиональные гиды", text: "Наши лицензированные гиды с опытом более 14 лет открывают скрытые жемчужины, древние истории и настоящее сердце Шри-Ланки." },
                item4: { title: "Круглосуточная поддержка", text: "С Aamy Tours вы всегда под присмотром — наша команда доступна 24/7 на протяжении всего путешествия." }
            },
            offers: {
                title: "Что мы предлагаем",
                cultural: { title: "Погружение в культуру", text: "Познайте традиции, фестивали и местную жизнь.", alt: "Погружение в культуру" },
                adventure: { title: "Приключенческие экспедиции", text: "Тrekking, сафари, сёрфинг и активный отдых.", alt: "Приключения" },
                luxury: { title: "Роскошь и комфорт", text: "Премиум-отели, частные трансферы и VIP-обслуживание.", alt: "Роскошь" },
                wellness: { title: "Оздоровление и релаксация", text: "Йога, Аюрведа и покой в уединённых местах.", alt: "Оздоровление" }
            },
            guides: {
                title: "Наши гиды",
                text: "Наши лицензированные и увлечённые гиды — душа каждого путешествия. Они не просто показывают Шри-Ланку — они оживляют её историями, традициями и секретами.",
                imageAlt: "Гид Aamy Tours"
            },
            expert: {
                name: "Азим Мохаммед",
                role: "(Ведущий тур-эксперт)",
                bio: "Имея <strong>более 14 лет лицензированного опыта</strong>, Азим Мохаммед страстно открывает скрытые сокровища Шри-Ланки. От золотых пляжей до туманных вершин, от сафари до древних чудес — он превращает каждое путешествие в незабываемый опыт в стиле Aamy Tours.",
                imageAlt: "Азим Мохаммед"
            },
            vehicles: {
                title: "Наш премиум автопарк",
                text: "В Aamy Tours Sri Lanka безопасность и комфорт гостей — на первом месте. Имея <strong>более 14 лет опыта</strong>, мы используем современные, кондиционированные и безупречно обслуживаемые автомобили для комфортного путешествия по всему острову.",
                bookButton: "Забронировать путешествие",
                car: { title: "Легковой автомобиль", text: "Идеально для пар или индивидуальных путешественников (до 3 чел.). Стильный, экономичный и идеален для личных поездок." },
                van: { title: "Микроавтобус", text: "Отлично подходит для семей или небольших групп (до 6 чел.). Просторный, уютный и идеален для длительных поездок." },
                minibus: { title: "Минивэн", text: "Подходит для больших групп (8–12 чел.). Удобные сиденья и много места для багажа." },
                luxury: { title: "Люкс", text: "Премиум-автомобили с кожаным салоном, Wi-Fi и личным водителем для VIP-комфорта." }
            },
            accommodations: {
                intro: "Отдохните в эксклюзивных отелях 3–5★ и бутик-отелях, каждый из которых выбран за спокойствие, изысканность и безупречный комфорт на протяжении всего путешествия.",
                item1: "Частные виллы с бассейнами-инфинити и оздоровительными программами в спокойной прибрежной обстановке.",
                item2: "Роскошь в колониальном стиле на скале над океаном с изысканной кухней и вечной элегантностью.",
                item3: "Эко-шик ретрит в дикой природе, сочетающий современный комфорт и погружение в природу и диких животных.",
                item4: "Архитектурная жемчужина в гармонии с природой, с панорамными видами и устойчивым люксовым дизайном."
            },
            notices: {
                title: "Важные уведомления",
                intro: "В Aamy Tours Sri Lanka мы делаем всё возможное, чтобы ваше путешествие стало незабываемым. Эти бесплатные бонусы включены в каждый тур:",
                bike: { title: "Бесплатный велосипед для гостей", text: "Исследуйте остров в своём темпе — мы предоставляем бесплатный велосипед каждому гостю на время тура." },
                fruits: { title: "Подарочный пакет фруктов в конце тура", text: "Завершите приключение на сладкой ноте — получите свежий набор отборных фруктов в подарок на прощание." },
                meals: { title: "Бесплатное питание во время церемоний", text: "Участвуйте в местных традициях — мы предоставляем бесплатное питание гостям во время церемоний подношения денег." }
            },
        },
        home: {
            common: { viewAll: "Смотреть все" },

            sections: {
                recommendations: { title: "Кураторские направления", subtitle: "Не знаете, с чего начать? Позвольте нам вдохновить вас." },
                excursions: { title: "Наши программы туров", desc: "Многодневные путешествия, созданные с ювелирной точностью — сочетание наследия, природы и моментов, трогающих душу." },
                packages: { title: "Эксклюзивные пакеты" },
                reviews: { title: "Отзывы гостей", subtitle: "Подлинные голоса путешественников, которые прожили это приключение" },
                gallery: { title: "Наша галерея", subtitle: "Визуальное путешествие по душе Шри-Ланки — запечатленные мгновения чуда, радости и вечной красоты." }
            },

            recommendations: {
                sigiriya: { label: "Сигирия", name: "Древняя скальная цитадель, величественно возвышающаяся над равнинами." },
                udawalawa: { label: "Удавалаве", name: "Стада слонов свободно гуляют по бескрайним золотым саваннам." },
                ella: { label: "Элла", name: "Туманные холмы, эпические железнодорожные путешествия и панорамные виды." },
                mirissa: { label: "Мирисса", name: "Золотые пески, бирюзовые волны и рай для наблюдения за китами." },
                nuwaraeliya: { label: "Нувара-Элия", name: "Бесконечные чайные плантации и свежий горный воздух." },
                kandy: { label: "Канди", name: "Священный город Храма Зуба Будды." },
                galle: { label: "Галле", name: "Колониальные крепостные стены встречаются с Индийским океаном." },
                yala: { label: "Яла", name: "Заповедник с леопардами, слонами и богатой фауной." },
                anuradhapura: { label: "Анурадхапура", name: "Колыбель буддизма с древними ступами." },
                polonnaruwa: { label: "Полоннарува", name: "Руины средневековой королевской столицы." }
            },

            excursions: {
                oneDay: { title: "Один день — Сущность острова", des: "Один день — воспоминания на всю жизнь: от древних ступ до золотых пляжей, чистая магия." },
                twoDays: { title: "Два дня — Шёпот дикой природы", des: "Два дня нетронутой красоты: сафари под звёздным небом, чайные холмы и биение джунглей." },
                threeDays: { title: "Три дня — Душа и берег", des: "Три дня, чтобы пробудить дух — священные храмы на рассвете, океанские волны на закате и культура в каждом вздохе." },
                fourDays: { title: "Четыре дня — Наследие и гармония", des: "Четыре дня вечного чуда: покорение древних крепостей, прогулки по колониальным улочкам и вкус традиций." },
                fiveDays: { title: "Пять дней — Путешествие к сердцу", des: "Пять дней, чтобы влюбиться — туманные высокогорья, бирюзовые лагуны, каждое мгновение как поэзия." },
                sixDays: { title: "Шесть дней — Фирменное путешествие", des: "Шесть дней изысканной элегантности — священные реликвии, сафари и безмятежные закаты в одной незабываемой истории." }
            },

            packages: {
                one: { title: "1 день / 0 ночей: Сущность острова", duration: "1 день", desc: "Один день — воспоминания на всю жизнь: древние ступы, золотые пляжи и душа Шри-Ланки в чистом волшебстве.", category: "Фирменный момент" },
                two: { title: "2 дня / 1 ночь: Шёпот дикой природы", duration: "2 дня", desc: "Два дня нетронутой красоты — сафари под звёздами, чайные холмы и биение джунглей.", category: "Побег в дикую природу" },
                three: { title: "3 дня / 2 ночи: Душа и берег", duration: "3 дня", desc: "Три дня для пробуждения духа — священные храмы на рассвете, океан на закате и культура в каждом вдохе.", category: "Духовно-прибрежный" },
                four: { title: "4 дня / 3 ночи: Наследие и гармония", duration: "4 дня", desc: "Четыре дня вечного чуда — древние крепости, колониальные улицы и вкус традиций.", category: "Глубокое погружение в культуру" },
                five: { title: "5 дней / 4 ночи: Путешествие к сердцу", duration: "5 дней", desc: "Пять дней, чтобы влюбиться — туманные высокогорья, бирюзовые лагуны, каждое мгновение как стихи.", category: "Романтический исследователь" },
                six: { title: "6 дней / 5 ночей: Фирменное путешествие", duration: "6 дней", desc: "Шесть дней изысканной элегантности — священные реликвии, сафари и безмятежные закаты в одной незабываемой истории.", category: "Фирменная классика" }
            },

            featured: {
                perahera: {
                    h2: "Станьте свидетелем зрелища",
                    h3: "Канди Эсала Перахера",
                    h4: "(Фестиваль Священного Зуба)",
                    paragraph: `Один из самых грандиозных буддийских праздников Азии, ежегодно проводимый в Канди в честь Священного Зуба Будды. Слоны в королевских нарядах, ритмичные барабаны, танцоры с огнём и факелоносцы освещают ночь завораживающим проявлением веры и традиций. Станьте частью этого живого наследия вместе с <strong style="color: #166880;">Aamy Tours Sri Lanka</strong> — где культура дышит, а история танцует.`,
                    button: "Узнать больше"
                },
                safari: {
                    h2: "В мир дикой природы",
                    h3: "Сафари-экспедиции",
                    paragraph: `Шри-Ланка — одно из лучших мест в Азии для наблюдения за дикой природой. Пройдите по саваннам <span style="color: #D5A44F; font-weight: 600;">Ялы</span> и <span style="color: #D5A44F; font-weight: 600;">Удавалаве</span> или скользите по туманным водно-болотным угодьям <span style="color: #D5A44F; font-weight: 600;">Вилпату</span>. Встретьте величественных слонов, неуловимых леопардов и редких птиц в их естественной среде. Отправляйтесь в путь с <strong style="color: #166880;">Aamy Tours Sri Lanka</strong> — каждое сафари это история, написанная пылью и рассветом.`,
                    button: "Исследовать сафари"
                }
            },

            gallery: {
                title: "Наша галерея",
                subtitle: "Визуальное путешествие по душе Шри-Ланки — запечатленные мгновения чуда, радости и вечной красоты.",
                alt1: "Восход солнца над скальной крепостью Сигирия",
                alt2: "Сафари со слонами в национальном парке Яла",
                alt3: "Сборщица чая в тумане Нувара-Элии",
                alt4: "Золотой час на пляже Мирисса",
                alt5: "Церемония в Храме Зуба Будды в Канди",
                alt6: "Древние руины Полоннарувы",
                alt7: "Наблюдение за китами у южного побережья",
                alt8: "Поездка на поезде через холмы Эллы",
                alt9: "Закат в форте Галле",
                alt10: "Местный рыбак в Негомбо",
                alt11: "Традиционный танец Канди",
                alt12: "Полёт на воздушном шаре над Дамбуллой"
            },

            cta: {
                title: "Aamy Tours Sri Lanka — Создаём вечные путешествия",
                desc: "Каждое путешествие — это шедевр, сотканный из культуры, приключений и спокойствия. Позвольте нам написать вашу историю в Жемчужине Индийского океана.",
                button: "Начать путешествие",
                alt: "Создайте своё путешествие"
            },
        },
        hero: {
            title: {
                line1: "Откройте рай вместе с",
                line2: "Aamy Tours",
                line3: "Шри-Ланка"
            },
            subtitle: "Погрузитесь в изумрудные тропические леса, золотые пляжи, древние королевства и захватывающие встречи с дикой природой —",
            subtitle2: "создано специально для вас.",
            cta: "Начать путешествие",
            trust: "Доверяют путешественники из более чем 50 стран • Упомянуты в Lonely Planet и CNN Travel"
        },
        footer: {
            brand: "Aamy Tours<br />Шри-Ланка",
            nav: { home: "Главная", about: "О нас", explore: "Исследовать Шри-Ланку", tours: "Туры", gallery: "Галерея", events: "Спецсобытия", things: "Чем заняться", contact: "Контакты" },
            contact: { title: "Создадим воспоминания вместе", address: "81/31h, H.K Edmond Mawatha Milidduwa,<br />Галле, Шри-Ланка", email: "aamytourssl@gmail.com", phone: "+94 77 048 3364" },
            newsletter: { title: "Присоединяйтесь к путешествию", desc: "Получайте первыми эксклюзивные предложения, секретные места и невероятные приключения.", placeholder: "Ваш email", subscribe: "Подписаться" },
            tagline: "\"Не все, кто блуждает, потеряны...<br /><span class='text-cyan-300 font-semibold'>некоторые просто с Aamy Tours</span>\"",
            copyright: "Создано с любовью. Все права защищены.",
            developedBy: "С любовью разработано"
        },
        tourpackages: {
            heroTitle: 'Наши Туры',
            heroSubtitle: 'Откройте для себя Шри-Ланку за один день — авторские приключения от <span class="text-[#D5A44F] font-bold">Aamy Tours</span>',
            heroAlt: 'Aamy Tours Шри-Ланка — Однодневные приключения',
            chooseAdventure: 'Выберите своё приключение',
            packagesSubtitle: '25 тщательно отобранных туров — от сафари с дикими животными до погружения в культуру.',
            viewDetails: 'Подробнее',
            itineraryTitle: 'Маршрут',
            bookViaWhatsApp: 'Забронировать через WhatsApp',
            whatsappMessage: 'Привет, Aamy Tours! Хочу забронировать: *{{title}}* ({{duration}})\n\nПодскажите наличие и стоимость!',

            packages: {
                '1': {
                    title: 'Приключение в Элле',
                    duration: '1 день',
                    category: 'Природа и приключения',
                    description: 'Путешествие по туманным холмам, водопадам и знаменитым мостам — идеальное сочетание адреналина и умиротворения.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> — Купание в кристальных бассейнах</li>
                <li><strong>Мост Девяти Арок</strong> — Фото с проходящим поездом</li>
                <li><strong>Чайные плантации</strong> — Прогулка по изумрудным холмам</li>
                <li><strong>Поездка на поезде</strong> — Живописный маршрут Элла — Демодара</li>
                <li><strong>Малый пик Адама</strong> — Панорамные виды на рассвете/закате</li>
                <li><strong>Кормление слонят молоком в Удавалаве</strong> — Трогательный момент с природой</li>
                <li><strong>Аюрведический травяной сад</strong> — Знакомство с древними секретами здоровья</li>
            </ul>`
                },
                '2': {
                    title: 'Элла и сафари в Яле',
                    duration: '1 день',
                    category: 'Дикая природа и пейзажи',
                    description: 'От туманных гор до дикой саванны — лучшее от природы за один незабываемый день.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> — Освежающее купание</li>
                <li><strong>Мост Девяти Арок</strong> — Архитектурное чудо</li>
                <li><strong>Чайные плантации</strong> — Прогулки по холмам</li>
                <li><strong>Малый пик Адама</strong> — Потрясающие виды</li>
                <li><strong>Сафари в Яле</strong> — Джип-тур с леопардами и слонами</li>
            </ul>`
                },
                '3': {
                    title: 'Культурный день в Канди',
                    duration: '1 день',
                    category: 'Наследие и природа',
                    description: 'Погружение в священные храмы, пышные сады и местные традиции в сердце Шри-Ланки.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Город Канди</strong> — Яркий культурный центр</li>
                <li><strong>Королевский ботанический сад</strong> — Тропический рай</li>
                <li><strong>Чайная фабрика и плантация</strong> — Знакомство с цейлонским чаем</li>
                <li><strong>Кормление, купание и катание на слонах</strong> — Этическое общение</li>
                <li><strong>Аюрведический травяной сад</strong> — Тур по целебным растениям</li>
                <li><strong>Башня Амбулувава</strong> — Панорама 360°</li>
                <li><strong>Фабрика ювелирных изделий и драгоценных камней</strong> — Блеск ремесла</li>
                <li><strong>Шёлковая фабрика</strong> — Традиционное ткачество</li>
            </ul>`
                },
                '4': {
                    title: 'Священное путешествие в Канди',
                    duration: '1 день',
                    category: 'Духовность и культура',
                    description: 'День полного погружения в святость, наследие и природную красоту священного города Канди.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Храм Зуба Будды</strong> — Священное буддийское место</li>
                <li><strong>Чайная фабрика и плантация</strong> — Дегустация свежего чая</li>
                <li><strong>Кормление, купание и катание на слонах</strong> — Нежные гиганты</li>
                <li><strong>Аюрведический травяной сад</strong> — Мудрость здоровья</li>
                <li><strong>Башня Амбулувава</strong> — Спиральное восхождение к небесам</li>
                <li><strong>Фабрика ювелирных изделий</strong> — Местные драгоценности</li>
                <li><strong>Шёлковая фабрика</strong> — Искусство шёлка</li>
            </ul>`
                },
                '5': {
                    title: 'День наследия Сигирии',
                    duration: '1 день',
                    category: 'История и приключения',
                    description: 'Подъём на древние скальные крепости, исследование золотых пещер и деревенской жизни.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Львиная скала Сигирия</strong> — Объект ЮНЕСКО</li>
                <li><strong>Золотой пещерный храм Дамбулла</strong> — Древняя настенная живопись</li>
                <li><strong>Деревенский тур</strong> — Повозка на волах, катамараны, традиционный обед</li>
                <li><strong>Аюрведический травяной сад</strong> — Целебные растения</li>
                <li><strong>Скала Пидурангала</strong> — Лучший вид на Сигирию</li>
            </ul>`
                },
                '6': {
                    title: 'Галле — прибрежное наследие',
                    duration: '1 день',
                    category: 'История и природа',
                    description: 'Прогулка по колониальной крепости, сафари по мангровым рекам и спасение морских черепах.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Храм Канде Вихарая</strong> — Гигантская статуя Будды</li>
                <li><strong>Черепаший питомник</strong> — Выпуск малышей в океан</li>
                <li><strong>Лодочное сафари</strong> — Мангровые заросли реки Маду</li>
                <li><strong>Шахта лунного камня</strong> — Добыча драгоценных камней</li>
                <li><strong>Голландская крепость Галле</strong> — Колониальный город ЮНЕСКО</li>
                <li><strong>Аюрведический травяной сад</strong> — Природные лекарства</li>
            </ul>`
                },
                '7': {
                    title: 'Открытие Коломбо',
                    duration: '1 день',
                    category: 'Город и культура',
                    description: 'Современные достопримечательности, священные места и шопинг в шумной столице Шри-Ланки.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Башня Лотоса</strong> — Панорама города на 360°</li>
                <li><strong>Красная мечеть</strong> — Величественная исламская архитектура</li>
                <li><strong>Шопинг</strong> — Местные рынки и моллы</li>
                <li><strong>Аюрведический травяной сад</strong> — Остановка для здоровья</li>
                <li><strong>Храм Гангарамая</strong> — Священный оазис в городе</li>
            </ul>`
                },
                '8': {
                    title: 'Дикое сафари в Яле',
                    duration: '1 день',
                    category: 'Дикая природа',
                    description: 'В поисках леопардов, слонов и редких птиц в одном из лучших национальных парков Азии.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Джип-сафари в Яле</strong> — 3-часовое приключение</li>
                <li>Встреча с леопардами, слонами, губачами и более 200 видами птиц</li>
            </ul>`
                },
                '9': {
                    title: 'Одиссея китов в Мириссе',
                    duration: '1 день',
                    category: 'Морские приключения',
                    description: 'Наблюдение за синими китами на комфортабельных катерах — самые крупные существа планеты вблизи.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Наблюдение за синими китами</strong> — 4-часовое морское сафари</li>
                <li><strong>Пляж Мирисса</strong> — Отдых на золотом песке</li>
                <li><strong>Рыбаки на ходулях</strong> — Иконический кадр</li>
                <li><strong>Аюрведический травяной сад</strong> — Прибрежное здоровье</li>
            </ul>`
                },
                '10': {
                    title: 'День со слонами в Удавалаве',
                    duration: '1 день',
                    category: 'Дикая природа и забота',
                    description: 'Кормление слонят молоком и наблюдение за дикими стадами в естественной среде.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Национальный парк Удавалаве</strong> — Джип-сафари</li>
                <li><strong>Кормление слонят молоком</strong> — Посещение приюта</li>
            </ul>`
                },
                '11': {
                    title: 'Экспресс Элла — Галле',
                    duration: '1 день',
                    category: 'Пейзажи и наследие',
                    description: 'От горных поездов до колониальных крепостей — насыщенное путешествие красотой и историей.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> — Быстрое купание</li>
                <li><strong>Мост Девяти Арок</strong> — Проезд поезда</li>
                <li><strong>Поездка на поезде</strong> — Элла → Галле</li>
                <li><strong>Малый пик Адама</strong> — Восхождение на рассвете</li>
                <li><strong>Голландская крепость Галле</strong> — Прогулка на закате</li>
                <li><strong>Чайные плантации</strong> — Виды с холмов</li>
                <li><strong>Аюрведический травяной сад</strong> — Остановка для здоровья</li>
            </ul>`
                },
                '12': {
                    title: 'Сафари в Яле и Галле',
                    duration: '1 день',
                    category: 'Дикая природа и колониальная эпоха',
                    description: 'Утреннее сафари и послеобеденная прогулка по наследию — идеальное комбо южного побережья.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Сафари в национальном парке Яла</strong> — Утренний джип-тур</li>
                <li><strong>Голландская крепость Галле</strong> — Послеобеденная прогулка</li>
            </ul>`
                },
                '13': {
                    title: 'Канди, Элла и Яла — Экспресс',
                    duration: '2 дня',
                    category: 'Культура и пейзажи',
                    description: 'От священных храмов до туманных холмов и диких сафари — вихрь главных достопримечательностей Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Сафари в Яле</strong> — Утренний джип-тур</li>
                <li><strong>Водопад Равана</strong> — Быстрое купание</li>
                <li><strong>Мост Девяти Арок</strong> — Проезд поезда</li>
                <li><strong>Поездка на поезде</strong> — Люксовый поезд</li>
                <li><strong>Чайные плантации</strong> — Виды с холмов</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Амбулувава</strong> — Небольшой поход</li>
                <li><strong>Ботанический сад</strong> — Тропический рай</li>
                <li><strong>Храм Зуба Будды</strong> — Священное посещение</li>
                <li><strong>Катание на слоне</strong> — Этическое общение</li>
                <li><strong>Чайная фабрика</strong> — Знакомство с цейлонским чаем</li>
            </ul>
            <h3 class="mt-4">Ночёвка в Канди (люксовый отель)</h3>`
                },
                '14': {
                    title: 'Культура Канди',
                    duration: '2 дня',
                    category: 'Культура',
                    description: 'Погружение в священные храмы, пышные сады и местные традиции в сердце Шри-Ланки.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>Город Канди</strong> — Яркий культурный центр</li>
                <li><strong>Королевский ботанический сад</strong> — Тропический рай</li>
                <li><strong>Чайная фабрика и плантация</strong> — Знакомство с цейлонским чаем</li>
                <li><strong>Кормление, купание и катание на слонах</strong> — Этическое общение</li>
                <li><strong>Аюрведический травяной сад</strong> — Тур по целебным растениям</li>
                <li><strong>Башня Амбулувава</strong> — Панорама 360°</li>
                <li><strong>Фабрика ювелирных изделий</strong> — Блеск ремесла</li>
                <li><strong>Шёлковая фабрика</strong> — Традиционное ткачество</li>
                <li><strong>Неллигала</strong> — Традиционный храм</li>
            </ul>
            <h3 class="mt-4">Ночёвка в Канди (люксовый отель)</h3>`
                },
                '15': {
                    title: 'Элла / Нувара-Элия / Канди — Культура',
                    duration: '2 дня',
                    category: 'Культура и пейзажи',
                    description: 'От туманных гор до священных храмов — душевное путешествие по сердцу Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> — Быстрое купание</li>
                <li><strong>Мост Девяти Арок</strong> — Проезд поезда</li>
                <li><strong>Малый пик Адама</strong> — Живописный поход</li>
                <li><strong>Поездка на поезде</strong> — Люксовый поезд</li>
                <li><strong>Чайные плантации</strong> — Виды с холмов</li>
                <li><strong>Розовая почта</strong> — Культурная красота</li>
                <li><strong>Амбулувава</strong> — Спокойные прогулки</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Индуистский храм</strong> — Культурное посещение</li>
                <li><strong>Ботанический сад</strong> — Тропический рай</li>
                <li><strong>Неллигала</strong> — Священное посещение</li>
                <li><strong>Водопад Рамбода</strong></li>
                <li><strong>Чайная фабрика</strong> — Знакомство с цейлонским чаем</li>
                <li><strong>Катание на слоне</strong> — Этическое общение</li>
                <li><strong>Травяной сад</strong> — Тропический рай</li>
            </ul>
            <h3 class="mt-4">Ночёвка в Канди (люксовый отель)</h3>`
                },
                '16': {
                    title: 'Яла / Элла / Нувара-Элия / Канди — Культура',
                    duration: '3 дня',
                    category: 'Культура и пейзажи',
                    description: 'От туманных гор до священных храмов — насыщенное трёхдневное путешествие по сердцу Шри-Ланки.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> — Быстрое купание</li>
                <li><strong>Мост Девяти Арок</strong> — Проезд поезда</li>
                <li><strong>Малый пик Адама</strong> — Живописный поход</li>
                <li><strong>Поездка на поезде</strong> — Люксовый поезд</li>
                <li><strong>Чайные плантации</strong> — Виды с холмов</li>
                <li><strong>Индуистский храм</strong> — Культурное посещение</li>
                <li><strong>Сафари в национальном парке Яла</strong> — Утренний джип-тур</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Амбулувава</strong> — Спокойные прогулки</li>
                <li><strong>Розовая почта</strong> — Культурная красота</li>
                <li><strong>Королевский ботанический сад</strong> — Тропический рай</li>
                <li><strong>Храм Зуба Будды</strong> — Священное посещение</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Неллигала</strong> — Священное посещение</li>
                <li><strong>Чайная фабрика</strong> — Знакомство с цейлонским чаем</li>
                <li><strong>Ювелирная и геммологическая фабрика</strong> — Блеск ремесла</li>
                <li><strong>Резьба по дереву</strong> — Традиционное искусство</li>
                <li><strong>Катание на слоне</strong> — Этическое общение</li>
            </ul>`
                },
                '17': {
                    title: 'Элла / Нувара-Элия / Канди / Сигирия — Культура',
                    duration: '3 дня',
                    category: 'Культура и пейзажи',
                    description: 'Горные пейзажи, чайные плантации и древние крепости — идеальный трёхдневный маршрут.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> — Быстрое купание</li>
                <li><strong>Мост Девяти Арок</strong> — Проезд поезда</li>
                <li><strong>Малый пик Адама</strong> — Живописный поход</li>
                <li><strong>Поездка на поезде</strong> — Люксовый поезд</li>
                <li><strong>Чайные плантации</strong> — Виды с холмов</li>
                <li><strong>Индуистский храм</strong> — Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Амбулувава</strong> — Спокойные прогулки</li>
                <li><strong>Королевский ботанический сад</strong> — Тропический рай</li>
                <li><strong>Скала Пидурангала</strong> — Лучший вид на Сигирию</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Золотой пещерный храм</strong> — Священное посещение</li>
                <li><strong>Львиная скала Сигирия</strong> — Древняя крепость ЮНЕСКО</li>
                <li><strong>Деревенский тур с катамараном и традиционным обедом</strong> — Погружение в культуру</li>
            </ul>`
                },
                '18': {
                    title: 'Элла / Нувара-Элия / Канди / Сигирия / Полоннарува',
                    duration: '3 дня',
                    category: 'Культура и пейзажи',
                    description: 'Горы, храмы и две древние столицы — насыщенная трёхдневная программа.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Водопад Равана</strong> — Быстрое купание</li>
                <li><strong>Мост Девяти Арок</strong> — Проезд поезда</li>
                <li><strong>Малый пик Адама</strong> — Живописный поход</li>
                <li><strong>Поездка на поезде</strong> — Люксовый поезд</li>
                <li><strong>Чайные плантации</strong> — Виды с холмов</li>
                <li><strong>Индуистский храм</strong> — Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Амбулувава</strong> — Спокойные прогулки</li>
                <li><strong>Королевский ботанический сад</strong> — Тропический рай</li>
                <li><strong>Чайная фабрика</strong> — Знакомство с цейлонским чаем</li>
                <li><strong>Катание на слоне</strong> — Этическое общение</li>
                <li><strong>Золотой пещерный храм</strong> — Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Львиная скала Сигирия</strong> — Объект ЮНЕСКО</li>
                <li><strong>Древний город Полоннарува</strong> — Экскурсия по руинам</li>
            </ul>`
                },
                '19': {
                    title: 'Яла / Элла / Нувара-Элия / Канди / Полоннарува',
                    duration: '4 дня',
                    category: 'Культура и пейзажи',
                    description: 'Сафари + горы + древние столицы — полноценное четырёхдневное путешествие.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Сафари в Яле</strong> — Утренний джип-тур</li>
                <li><strong>Водопад Равана</strong> — Быстрое купание</li>
                <li><strong>Мост Девяти Арок</strong> — Проезд поезда</li>
                <li><strong>Малый пик Адама</strong> — Живописный поход</li>
                <li><strong>Поездка на поезде</strong> — Люксовый поезд</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Чайные плантации</strong> — Виды с холмов</li>
                <li><strong>Индуистский храм</strong> — Культурное посещение</li>
                <li><strong>Амбулувава</strong> — Спокойные прогулки</li>
                <li><strong>Королевский ботанический сад</strong> — Тропический рай</li>
                <li><strong>Чайная фабрика</strong> — Знакомство с чаем</li>
                <li><strong>Золотой пещерный храм</strong> — Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Неллигала</strong> — Священное посещение</li>
                <li><strong>Ювелирная фабрика</strong> — Блеск ремесла</li>
                <li><strong>Катание на слоне</strong> — Этическое общение</li>
                <li><strong>Золотой пещерный храм</strong> — Культурное посещение</li>
            </ul>
            <h3 class="mt-4">День 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Львиная скала Сигирия</strong> — Объект ЮНЕСКО</li>
                <li><strong>Древний город Полоннарува</strong> — Экскурсия</li>
            </ul>`
                },
                '20': {
                    title: 'Яла / Элла / Нувара-Элия / Канди / Сигирия / Полоннарува / Анурадхапура',
                    duration: '5 дней',
                    category: 'Культура и пейзажи',
                    description: 'Полный маршрут по главным достопримечательностям Шри-Ланки: сафари, горы, три древние столицы и священное дерево Бодхи.',
                    itinerary: `<h3>День 1:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Сафари в национальном парке Яла</strong> — Утренний джип-тур (леопарды, слоны)</li>
                <li><strong>Водопад Равана</strong> — Быстрое купание</li>
                <li><strong>Мост Девяти Арок</strong> — Фото с поездом</li>
                <li><strong>Малый пик Адама</strong> — Панорамный поход</li>
                <li><strong>Поездка на поезде</strong> — Живописный маршрут в горы</li>
            </ul>
            <h3 class="mt-4">День 2:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Чайные плантации и фабрика</strong> — Прогулка и дегустация</li>
                <li><strong>Индуистский храм</strong> — Культурное посещение</li>
                <li><strong>Водопад Рамбода</strong></li>
                <li><strong>Амбулувава</strong> — Уникальная спиральная башня</li>
                <li><strong>Розовая почта</strong> — Фото-стоп</li>
            </ul>
            <h3 class="mt-4">День 3:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Королевский ботанический сад</strong> — Перадения</li>
                <li><strong>Храм Зуба Будды</strong> — Священное место</li>
                <li><strong>Неллигала</strong> — Традиционный храм</li>
                <li><strong>Катание на слоне</strong> — Этическое общение</li>
                <li><strong>Ювелирная и геммологическая фабрика</strong></li>
            </ul>
            <h3 class="mt-4">День 4:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Львиная скала Сигирия</strong> — Подъём на древнюю крепость</li>
                <li><strong>Скала Пидурангала</strong> — Лучший вид на Сигирию</li>
                <li><strong>Древний город Полоннарува</strong> — Руины второй столицы</li>
            </ul>
            <h3 class="mt-4">День 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Анурадхапура</strong> — Первая древняя столица</li>
                <li>Священное дерево Бодхи, гигантские ступы, музей</li>
                <li>Трансфер в отель / аэропорт</li>
            </ul>`
                },
                '21': {
                    title: 'Яла / Элла / Нувара-Элия / Канди / Сигирия / Полоннарува / Коломбо',
                    duration: '5 дней',
                    category: 'Культура и пейзажи',
                    description: 'Классический большой круг с завершением в современной столице Коломбо.',
                    itinerary: `<h3>День 1–4:</h3> идентично туру №20 (Яла → Элла → Нувара-Элия → Канди → Сигирия → Полоннарува)<br/>
            <h3 class="mt-4">День 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Обзорная экскурсия по Коломбо</strong></li>
                <li><strong>Башня Лотоса</strong> — Панорама города</li>
                <li><strong>Храм Гангарамая</strong> — Священный оазис</li>
                <li><strong>Красная мечеть</strong> — Яркая архитектура</li>
                <li><strong>Шопинг</strong> — Рынки и торговые центры</li>
                <li>Трансфер в аэропорт / отель</li>
            </ul>`
                },
                '22': {
                    title: 'Яла / Элла / Нувара-Элия / Канди / Сигирия / Полоннарува / Галле',
                    duration: '5 дней',
                    category: 'Культура и пейзажи',
                    description: 'Большой круг с романтическим завершением на южном побережье и прогулкой по крепости Галле.',
                    itinerary: `<h3>День 1–4:</h3> идентично туру №20<br/>
            <h3 class="mt-4">День 5:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Голландская крепость Галле</strong> — Объект ЮНЕСКО</li>
                <li>Прогулка по старинным улочкам, маяк, бастионы</li>
                <li>Свободное время на океане (по желанию — пляж Унаватуна)</li>
                <li>Трансфер в отель на южном побережье</li>
            </ul>`
                },
                '23': {
                    title: 'Элла / Нувара-Элия / Канди / Сигирия / Полоннарува / Анурадхапура / Коломбо',
                    duration: '6 дней',
                    category: 'Культура и пейзажи',
                    description: 'Самый полный шестидневный тур без сафари в Яле — идеален для любителей культуры и истории.',
                    itinerary: `<h3>День 1–5:</h3> как в туре №20, но без Ялы (Элла → Нувара-Элия → Канди → Сигирия → Полоннарува → Анурадхапура)<br/>
            <h3 class="mt-4">День 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Коломбо</strong> — Финальная обзорная экскурсия</li>
                <li><strong>Башня Лотоса, Гангарамая, шопинг</strong></li>
                <li>Трансфер в аэропорт или отель</li>
            </ul>`
                },
                '24': {
                    title: 'Элла / Нувара-Элия / Канди / Сигирия / Полоннарува / Анурадхапура / Коломбо',
                    duration: '6 дней',
                    category: 'Культура и пейзажи',
                    description: 'Полноценный шестидневный маршрут по всем ключевым точкам с завершением в Коломбо.',
                    itinerary: `<h3>День 1:</h3> Элла (водопад Равана, Мост Девяти Арок, Малый пик Адама, поезд)<br/>
            <h3 class="mt-4">День 2:</h3> Нувара-Элия (чайные плантации, Амбулувава, водопады)<br/>
            <h3 class="mt-4">День 3:</h3> Канди (Храм Зуба Будды, ботанический сад, Неллигала)<br/>
            <h3 class="mt-4">День 4:</h3> Сигирия + Пидурангала + Полоннарува<br/>
            <h3 class="mt-4">День 5:</h3> Анурадхапура (древняя столица, священное дерево Бодхи)<br/>
            <h3 class="mt-4">День 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Коломбо</strong> — Обзорная экскурсия по столице</li>
                <li>Шопинг, Башня Лотоса, трансфер в аэропорт</li>
            </ul>`
                },
                '25': {
                    title: 'Элла / Нувара-Элия / Канди / Сигирия / Полоннарува / Анурадхапура / Галле',
                    duration: '6 дней',
                    category: 'Культура и пейзажи',
                    description: 'Гранд-тур по всей Шри-Ланке с идеальным завершением — закат в колониальной крепости Галле.',
                    itinerary: `<h3>День 1–5:</h3> как в туре №24<br/>
            <h3 class="mt-4">День 6:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>Галле</strong> — Голландская крепость (ЮНЕСКО)</li>
                <li>Прогулка по бастионам, маяк, старинные улочки</li>
                <li>Закат на крепостной стене с видом на океан</li>
                <li>Трансфер в отель на южном побережье</li>
            </ul>`
                },
            },
        },
    },

    ar: {
        translation: {
            home: 'الرئيسية',
            aboutUs: 'من نحن',
            sriLankanav: 'سريلانكا',
            gallerynav: 'معرض الصور',
            bookATour: 'احجز جولة',
            thingsToDo: 'أنشطة يمكن ممارستها',
            contactUs: 'تواصل معنا',
        },
        contactus: {
            heroTitle: 'تواصل معنا',
            heroSubtitle: 'Aamy Tours Sri Lanka - بوابتك إلى مغامرات سريلانكية لا تُنسى',
            feelFree: 'لا تتردد في التواصل معنا',
            planDream: 'خطط لمغامرتك السريلانكية الحلم',
            reachOutDesc: 'تواصل مع Aamy Tours Sri Lanka للحصول على باقات سياحية مخصصة، إرشادات خبيرة، وتجارب سفر لا تُنسى في جميع أنحاء سريلانكا.',

            callCenter: 'مركز الاتصال',
            phone: '+94 77 048 3364',
            emailTitle: 'البريد الإلكتروني',
            email: 'aamytourssl@gmail.com',
            locationTitle: 'موقعنا',
            location: '81/31h H.K Edmond Mawatha, Milidduwa, Galle, سريلانكا.',
            socialTitle: 'شبكات التواصل',

            getInTouch: 'تواصل معنا',
            getInTouchDesc: 'اكتشف سريلانكا مع Aamy Tours — نحن هنا على مدار الساعة لنجعل رحلتك لا تُنسى.',

            nameLabel: 'الاسم',
            namePlaceholder: 'اسمك الكامل',
            emailLabel: 'البريد الإلكتروني',
            emailPlaceholder: 'you@example.com',
            phoneLabel: 'رقم التواصل',
            phonePlaceholder: '+94 7X XXX XXXX',
            messageLabel: 'الرسالة',
            messagePlaceholder: 'أخبرنا عن رحلتك الحلم...',

            sendButton: 'إرسال الرسالة',
            sendingButton: 'جاري الإرسال...',
            successMsg: 'تم إرسال استفسارك عبر واتساب!',
            errorMsg: 'فشل فتح واتساب. يرجى المحاولة مرة أخرى.',
            findUsTitle: 'ابحث عننا في غالي',
        },
        thingstodo: {
            heroTitle: 'أنشطة يمكن ممارستها في سريلانكا',
            heroSubtitle: 'مغامرة، ثقافة وصحة',
            sectionTitle: 'أنشطة في سريلانكا',
            ayurveda: 'الأيورفيدا - علم الحياة القديم',
            diving: 'الغوص في سريلانكا',
            elephantRide: 'ركوب الفيل',
            fishing: 'صيد الأسماك في سريلانكا',
            ballooning: 'رحلات البالون الهوائي',
            jeepSafari: 'سفاري الجيب',
            whiteWaterRafting: 'التجديف في المياه البيضاء',
            riverSafari: 'سفاري الأنهار',
            snorkeling: 'الغوص السطحي في سريلانكا',
            teaTasting: 'جولة تذوق الشاي',
            templeVisit: 'زيارة المعابد',
            wildlifeSafari: 'سفاري الحياة البرية',
            viewMore: 'عرض المزيد',
        },
        gallery: {
            heroTitle: 'معرض الصور',
            heroSubtitle: 'لحظات مُلتقطة، ذكريات مُعتز بها — يعرض معرضنا المغامرات، الابتسامات، والمناظر الخلابة التي تجعل كل رحلة في سريلانكا لا تُنسى',
            tabPlaces: 'الأماكن',
            tabEvents: 'الفعاليات',
            nuwaraEliya: 'نوارا إليا',
            sigiriya: 'سيجيريا',
            anuradhapura: 'أنورادهابورا',
            rambodaFalls: 'شلالات رامبودا',
            ella: 'إيلا',
            yala: 'حديقة يالا الوطنية',
            kandy: 'كاندي',
            bodhiViharaya: 'بودي فيهارايا',
            knuckles: 'سلسلة جبال ناكلز',
            udawalawe: 'حديقة أوداوالاوي الوطنية',
            bentota: 'سفاري القوارب في بنتوتا',
            colombo: 'كولومبو',
            galle: 'قلعة غالي',
            mirissa: 'شاطئ ميريسا',
            jaffna: 'يافنا',
            ambuluwawaTower: 'برج أمبولواوا',
            turtle: 'مزرعة السلاحف',
            polonnaruwa: 'مدينة بولوناروا القديمة',
            polgampala: 'بركة ماء بولجامبالا',
            beach: 'شواطئ سريلانكا',
        },
        events: {
            heroTitle: 'الفعاليات',
            heroSubtitle: 'احتفل بروح سريلانكا من خلال مهرجاناتها — من الطقوس البوذية المقدسة إلى المواكب الثقافية الملونة، كل حدث فرصة لتجربة نبض الجزيرة.',
            tabPlaces: 'الأماكن',
            tabEvents: 'الفعاليات',
            kandyPerahera: 'مهرجان كاندي إسالا بيراهيرا (مهرجان سن بوذا)',
            vesak: 'مهرجان فيساك',
            sinhalaNewYear: 'رأس السنة السنهالية والتاميلية',
            christmas: 'عيد الميلاد',
            thaiPongal: 'تاي بونغال',
            deepavali: 'ديبالي',
            holi: 'هولي',
            poson: 'مهرجان بوسون',
        },
        // Inside resources → ar → srilanka
        srilanka: {
            heroTitle: 'اكتشف سريلانكا',
            heroSubtitle: 'لؤلؤة المحيط الهندي',

            sectionPlaces: 'أجمل الأماكن في سريلانكا',
            sectionFamous: 'أشهر ما تُعرف به سريلانكا',
            viewMore: 'عرض المزيد',

            // Intro paragraphs
            intro1: 'سريلانكا، المعروفة بـ «الجزيرة الزمردية»، جوهرة استوائية تشتهر بمناظرها الطبيعية الخلابة، تراثها القديم، وضيافتها الصادقة.',
            intro2: 'تاريخها يمتد لأكثر من ألفي عام، وتضم مواقع مدرجة في قائمة اليونسكو مثل قلعة سيجيريا الصخرية ومدينة أنورادهابورا المقدسة. ثراؤها الثقافي يمزج بين التأثيرات البوذية والهندوسية والاستعمارية، ويظهر في مهرجاناتها النابضة وعمارتها الرائعة.',
            intro3: 'تتنوّع تضاريس الجزيرة بشكل ساحر — من مزارع الشاي المتدرجة في إيلا إلى المياه الفيروزية في ترينكومالي. المحميات الوطنية مثل ويلباتو موطن للنمور، التماسيح، والطيور النادرة، مما يسعد عشاق الطبيعة.',
            intro4: 'للباحثين عن الإثارة تقدم سريلانكا التجديف في المياه البيضاء، ركوب الأمواج في أروغام باي، والترحال عبر الغابات الكثيفة. مطبخها الغني بالتوابل العطرية، الأسماك الطازجة، والجاك فروت يروي قصة التقاليد والنكهة.',
            intro5: 'من الحج المقدس إلى الاسترخاء على الشواطئ الهادئة، تعد سريلانكا بتجربة ساحرة غنية بالجمال والثقافة.',

            // Places
            sigiriya: 'قلعة سيجيريا الصخرية',
            sigiriyaDesc: 'موقع يونسكو يضم حدائق قديمة، لوحات جدارية، وإطلالات خلابة من القمة.',

            templeOfTooth: 'معبد سن بوذا',
            templeOfToothDesc: 'موقع بوذي مقدس يحتوي على رفات سن بوذا.',

            ella: 'إيلا',
            ellaDesc: 'مدينة تلال محاطة بمزارع الشاي، مشهورة بجسر الأقواس التسعة.',

            yala: 'حديقة يالا الوطنية',
            yalaDesc: 'تشتهر بالفيلة، النمور، وسفاري الحياة البرية.',

            galleFort: 'قلعة غالي',
            galleFortDesc: 'قلعة استعمارية بأزقة مرصوفة وعمارة هولندية.',

            nuwaraEliya: 'نوارا إليا',
            nuwaraEliyaDesc: 'تُعرف بـ «إنجلترا الصغيرة» بمناخها البارد ومزارع الشاي.',

            adamsPeak: 'قمة آدم (سري پادا)',
            adamsPeakDesc: 'جبل مقدس يحمل بصمة قدم فريدة، وجهة حج.',

            hortonPlains: 'هورتون بلينز',
            hortonPlainsDesc: 'تلال متدحرجة، شلالات، ونقطة مشاهدة «نهاية العالم».',

            bentota: 'شاطئ بنتوتا',
            bentotaDesc: 'ساحل نقي برمال ذهبية ورياضات مائية.',

            jaffna: 'يافنا',
            jaffnaDesc: 'غنية بالثقافة التاميلية، التاريخ، والمطبخ.',

            anuradhapura: 'أنورادهابورا',
            anuradhapuraDesc: 'مدينة قديمة تضم مواقع بوذية مقدسة وآثار.',

            polonnaruwa: 'بولوناروا',
            polonnaruwaDesc: 'موقع يونسكو بمعابد وتماثيل محفوظة جيدًا.',

            unawatuna: 'شاطئ أوناواتونا',
            unawatunaDesc: 'شاطئ نابض بالحياة مع الغوص السطحي والحياة الليلية.',

            colombo: 'كولومبو',
            colomboDesc: 'العاصمة الصاخبة بالعمارة الحديثة والاستعمارية.',

            udawalawe: 'حديقة أوداوالاوي الوطنية',
            udawalaweDesc: 'تشتهر بقطعان الفيلة الكبيرة والمناظر الخلابة.',

            dambulla: 'معبد كهوف دامبولا',
            dambullaDesc: 'موقع يونسكو بجداريات وتماثيل بوذية قديمة.',

            // Famous Things
            ceylonTea: 'شاي سيلاني',
            ceylonTeaDesc: 'مشهور عالميًا بنكهته، خصوصًا من نوارا إليا وأوفا.',

            spices: 'التوابل',
            spicesDesc: 'القرفة، الهال، القرنفل — القرفة السريلانكية الأفضل في العالم.',

            gems: 'الأحجار الكريمة',
            gemsDesc: 'الياقوت، الزمرد، أحجار القمر — جزيرة الأحجار النادرة.',

            ayurveda: 'الأيورفيدا',
            ayurvedaDesc: 'علاجات صحية بالتدليك والأعشاب.',

            handicrafts: 'الحرف اليدوية',
            handicraftsDesc: 'الأقنعة، الباتيك، النحت الخشبي، الأواني المطلية.',

            elephants: 'الفيلة',
            elephantsDesc: 'رمز ثقافي، تشارك في المواكب الاحتفالية الكبرى.',

            food: 'الطعام التقليدي',
            foodDesc: 'الأرز بالكاري، الهوبرز، الكوتو روتي، الواتالابام.',

            festivals: 'المهرجانات',
            festivalsDesc: 'إسالا بيراهيرا، فيساك، رأس السنة السنهالية-التاميلية.',

            coconut: 'منتجات جوز الهند',
            coconutDesc: 'الزيت، الحليب، الألياف للحبال والحصير.',

            sarees: 'ساري كاندي',
            sareesDesc: 'زي تقليدي أنيق للمناسبات الرسمية.',

            dances: 'الرقصات التقليدية',
            dancesDesc: 'رقصات كاندي، رقصات الشيطان، ورقصات السهول.',

            stiltFishing: 'صيد الأسماك على الأعمدة',
            stiltFishingDesc: 'أسلوب صيد أيقوني على الساحل الجنوبي.',

            moonstones: 'أحجار القمر',
            moonstonesDesc: 'أحجار شبه كريمة، مناجم ميتياغودا الشهيرة.',

            cricket: 'الكريكيت',
            cricketDesc: 'الشغف الوطني — أبطال كأس العالم 1996.',

            herbs: 'أعشاب الأيورفيدا',
            herbsDesc: 'غوتو كولا، القرفة، النيم للعلاجات الطبيعية.',

            masks: 'الأقنعة',
            masksDesc: 'أقنعة أمبالانغودا تُستخدم في العروض الطقوسية.',
        },
        ayurveda: {
            title: "الأيورفيدا - علم الحياة القديم",

            introParagraph1: "كلمة «الأيورفيدا» موجودة منذ أكثر من ثلاثة آلاف سنة. وتعني باللغة السنسكريتية «علم الحياة». تعتمد الطريقة على الرؤية العلاجية الأيورفيدية للمرض بدلاً من نتائجه، وهو ما يتعارض عادة مع الطب الأوروبي. وتنص على المبادئ التالية:",

            corePrinciplesTitle: "المبادئ الأساسية",
            principle1: "يجب أن يكون الجسم خاليًا من انسداد الطاقة ويحافظ على التوازن للنشاط الاستقلابي والقلبي الطبيعي.",
            principle2: "يجب أن يكون للجسم تقلص عضلي طبيعي مع نشاط هرموني منتظم.",
            principle3: "يحتاج الجسم إلى جهاز مناعي صحي ليعمل بشكل صحيح.",

            sriLankaDoctors: "وفقًا لأحدث البيانات، يوجد في سريلانكا أكثر من 6000 خريج مدرب في الأيورفيدا. يخضعون لسبع سنوات من الدراسة وسنتين من التدريب في المستشفيات العامة. تشمل برامج الأيورفيدا:",

            benefit1: "إزالة التوتر والإرهاق والقلق",
            benefit2: "تشبع الأكسجين",
            benefit3: "تحفيز الجهاز العضلي وإزالة السموم",
            benefit4: "استعادة توازن الجهاز العصبي",
            benefit5: "استعادة تدفق الدم إلى الأعضاء الداخلية",
            benefit6: "إفراز الإندورفين",

            mainImageAlt: "الأيورفيدا والعافية",

            faceTreatmentAlt: "علاج الوجه بالأيورفيدا",
            faceTreatmentCaption: "علاج الوجه بالأيورفيدا",

            massageTreatmentAlt: "تدليك الأيورفيدا",
            massageTreatmentCaption: "تدليك الأيورفيدا",

            treatmentDescription: "تشمل العلاجات القياسية تدليك الجسم وفروة الرأس بزيوت خاصة، والساونا العشبية، والحمامات المملوءة بالأعشاب. أشهر تقنية هي «شيروذارا»، حيث يُسكب زيت عشبي دافئ بشكل إيقاعي على الجبهة. يساعد ذلك في استعادة توازن الجهاز العصبي وتحقيق الاسترخاء العميق.",

            tipsTitle: "نصائح للعلاج الأيورفيدي",
            tip1: "انسَ المشاكل. استرخِ وصفِّ ذهنك للحصول على أفضل النتائج.",
            tip2: "اختر المكان المناسب. اختر بيئة تتناسب مع راحتك وتفضيلاتك للشفاء الأمثل.",
            tip3: "اختر البرنامج الصحيح. ناقش مخاوفك مع الطبيب وجرب علاجات مختلفة.",
            tip4: "خذ حمامًا دافئًا قبل العلاج لإرخاء عضلاتك وتحضير جسمك.",
            tip5: "تناول وجبة خفيفة قبل الإجراء. تجنب الوجبات الثقيلة للسماح بتدفق الدم السليم.",
            tip6: "الراحة بعد الإجراءات ضرورية. الاسترخاء السليم يعزز فعالية العلاجات الأيورفيدية."
        },
        ballooning: {
            title: "رحلات البالون الهوائي في سريلانكا",

            introParagraph1: "رحلات البالون الهوائي في سريلانكا تقدّم تجربة لا تُنسى من الطيران الهادئ فوق المناظر الطبيعية الخلابة. تبدأ الرحلات عند شروق الشمس وتوفر إطلالات جوية مذهلة على التلال المتدحرجة، الغابات الكثيفة، الآثار القديمة، والقرى الهادئة.",
            introParagraph2: "أشهر وجهة للبالون هي دامبولا في قلب المثلث الثقافي. غالبًا ما تمر الرحلات فوق قلعة سيجيريا الصخرية الشهيرة، مما يمنحك منظورًا فريدًا لا مثيل له. تستمر الرحلة عادة 60-90 دقيقة، مما يتيح لك الوقت الكافي للاستمتاع بجمال سريلانكا من الأعلى.",

            mainImageAlt: "رحلات البالون الهوائي في سريلانكا",
            mainImageCaption: "رحلات البالون الهوائي في سريلانكا",

            highlightsTitle: "لماذا تجرب رحلة البالون الهوائي في سريلانكا؟",
            highlightsIntro: "تجمع رحلة البالون بين المغامرة والهدوء، وتتيح لك تجربة جمال سريلانكا بطريقة فريدة. من أبرز مميزاتها:",

            highlight1: "إطلالات بانورامية غير منقطعة على المناظر الخلابة.",
            highlight2: "الطيران فوق معالم شهيرة مثل قلعة سيجيريا والبحيرات المجاورة.",
            highlight3: "رحلة هادئة وسط الخضرة الكثيفة والقرى الساحرة.",
            highlight4: "مشاهدة شروق الشمس الرائع من السماء.",
            highlight5: "مثالية لعشاق التصوير لالتقاط جمال الطبيعة من الأعلى.",

            sunriseImageAlt: "استمتع بإطلالات خلابة على شروق الشمس وأنت تطفو في البالون.",
            sunriseImageCaption: "استمتع بإطلالات خلابة على شروق الشمس وأنت تطفو في البالون.",

            landscapeImageAlt: "شاهد مناظر سريلانكا الخلابة من الأعلى — التلال، الغابات، البحيرات.",
            landscapeImageCaption: "شاهد مناظر سريلانكا الخلابة من الأعلى — التلال، الغابات، البحيرات.",

            tipsTitle: "نصائح لرحلة بالون لا تُنسى",
            tip1: "احجز مبكرًا — الرحلات تعتمد على الطقس وتُحجز بسرعة.",
            tip2: "ارتدِ ملابس مريحة واحمل جاكيت خفيف — الصباح الباكر بارد.",
            tip3: "احمل كاميرا أو هاتفًا لالتقاط المناظر الرائعة.",
            tip4: "استمع جيدًا لتعليمات السلامة من الطيار.",
            tip5: "احضر في الوقت المحدد لتشاهد عملية تحضير ونفخ البالون — تجربة ممتعة بحد ذاتها."
        },
        diving: {
            title: "الغوص في سريلانكا",

            introParagraph1: "تحيط بشواطئ سريلانكا شعاب مرجانية واسعة على أعماق تتراوح بين 2 و40 مترًا. مياه المحيط الهندي الدافئة (27-30 درجة مئوية) وشفافية المياه العالية (15-35 مترًا) توفر ظروفًا مثالية للغوص والسنوركلينغ. يمكنك استكشاف الشعاب المرجانية البكر، حطام السفن القديمة، والكهوف الساحرة تحت الماء.",
            introParagraph2: "في شمال شرق الجزيرة، أكثر من 130 نوعًا من المرجان الملوّن، موطن للسلاحف البحرية، أسماك المهرج، أسماك الأسد، وخيول البحر. زيارة حطام السفن بالقرب من الصخور والشعاب تجربة لا تُنسى. وأنت تطفو في المياه الصافية، تغوص في تاريخ سيلان الغامض.",

            mainImageAlt: "الغوص في سريلانكا",
            mainImageCaption: "الغوص في سريلانكا",

            facilitiesTitle: "المرافق وأفضل مواقع الغوص",
            facilitiesParagraph1: "مراكز الغوص في الجزيرة مجهزة بأحدث المعدات من الشركات العالمية. مدربون معتمدون من PADI وCMAS يضمنون السلامة والمتعة. تعمل المراكز على الساحل الجنوبي الغربي من منتصف أكتوبر إلى نهاية أبريل، وعلى الساحل الشمالي الشرقي (نيلاڤيلي وترينكومالي) من مارس إلى أكتوبر.",
            facilitiesParagraph2: "شعاب كالبيتيا في الغرب وحطام السفن في هيكادوا من أشهر المواقع بين الغواصين.",

            coralImageAlt: "اكتشف الشعاب المرجانية النابضة بالحياة موطنًا لتنوع بحري مذهل.",
            coralImageCaption: "اكتشف الشعاب المرجانية النابضة بالحياة موطنًا لتنوع بحري مذهل.",

            shipwreckImageAlt: "اكتشف حطام السفن التاريخية التي تروي قصة ماضي سريلانكا البحري.",
            shipwreckImageCaption: "اكتشف حطام السفن التاريخية التي تروي قصة ماضي سريلانكا البحري.",

            tipsTitle: "نصائح للغواصين",
            tip1: "اختر الموسم المناسب: الساحل الجنوبي الغربي (أكتوبر–أبريل) أو الشمالي الشرقي (مارس–أكتوبر).",
            tip2: "تأكد من أن مركز الغوص معتمد ومجهز بمعدات حديثة.",
            tip3: "استمع جيدًا لنصائح المدرب — خاصة إذا كنت مبتدئًا.",
            tip4: "احترم الحياة البحرية: لا تلمس المرجان ولا تزعج البيئة تحت الماء.",
            tip5: "احمل كاميرا مقاومة للماء لتوثيق جمال العالم تحت الماء في سريلانكا."
        },
        elephantRide: {
            title: "ركوب الفيل",

            introParagraph1: "ركوب الفيل نشاط ممتع ومثير وتجربة فريدة في سريلانكا. إذا كنت تقيم بالقرب من المثلث الثقافي في مناطق مثل هابارانا أو سيجيريا أو دامبولا، يمكنك المشاركة في سفاري على ظهر فيل. تبدأ الأسعار من حوالي 30 دولارًا لساعة من المغامرة التي لا تُنسى.",
            introParagraph2: "قبل الركوب، يُجهَّز الفيل بسرج خاص يتسع لـ 4-6 أشخاص. هذه العمالقة اللطيفة تأخذك عبر مسارات الغابة الخلابة، تعبر المناطق المغمورة بالماء، وتمشي بين الغطاء النباتي الكثيف. عادة ما يسير الفيل ببطء، مما يتيح لك الاستمتاع الكامل بجمال الطبيعة المحيطة، رغم قدرته على الجري بسرعة تصل إلى 40 كم/ساعة.",

            mainImageAlt: "ركوب الفيل",
            mainImageCaption: "ركوب الفيل",

            highlightsTitle: "أبرز مميزات ركوب الفيل",
            highlightsIntro: "ركوب الفيل في سريلانكا يوفر طريقة فريدة للتواصل مع الطبيعة واستكشاف الريف. من أبرز النقاط:",
            highlight1: "السير عبر غابات كثيفة مليئة بالنباتات الغريبة والحياة البرية.",
            highlight2: "عبور الأنهار والمناطق المغمورة مع إطلالات خلابة.",
            highlight3: "التعرف على العلاقة الوثيقة بين الفيلة والثقافة السريلانكية.",
            highlight4: "الاسترخاء على سرج مريح بينما يحملك الفيل بلطف عبر تضاريس متنوعة.",

            jungleImageAlt: "استكشف الغابات الكثيفة والمسارات الخلابة على ظهر فيل.",
            jungleImageCaption: "استكشف الغابات الكثيفة والمسارات الخلابة على ظهر فيل.",

            waterImageAlt: "عبور الأنهار والاستمتاع بجمال الماء والهدوء النباتي.",
            waterImageCaption: "عبور الأنهار والاستمتاع بجمال الماء والهدوء النباتي.",

            tipsTitle: "نصائح لركوب فيل آمن وممتع",
            tip1: "ارتدِ ملابس وأحذية مريحة مناسبة للنشاطات الخارجية.",
            tip2: "اتبع تعليمات المرشد بدقة لضمان سلامتك.",
            tip3: "تأكد من أن الفيلة تُعامل معاملة حسنة وأن المزود يتبع ممارسات أخلاقية.",
            tip4: "احمل كاميرا لتوثيق المناظر الخلابة واللحظات.",
            tip5: "احترم الفيلة وتجنب أي تصرف قد يسبب لها التوتر أو الأذى."
        },
        fishing: {
            title: "الصيد في سريلانكا",

            introParagraph1: "سريلانكا بامتداد ساحلها الطويل وبحيراتها وأنهارها العذبة تقدّم تجربة صيد استثنائية. سواء كنت صيادًا محترفًا أو هاويًا، ستجد ما يناسبك. من رحلات الصيد في أعماق البحر إلى الصيد التقليدي على الأعمدة الذي يمارسه الصيادون المحليون، ستعيش مغامرة لا تُنسى.",
            introParagraph2: "أشهر الوجهات: الساحل الجنوبي حول غالي وميريسا، لاغون نيغومبو، والمياه الهادئة في ترينكومالي. يمكنك تجربة تقنيات مختلفة مثل الصيد بالجر، الصيد من القاع، أو الصيد بالذبابة.",

            mainImageAlt: "الصيد في سريلانكا",
            mainImageCaption: "الصيد في سريلانكا",

            experiencesTitle: "تجارب الصيد في سريلانكا",
            experiencesIntro: "الصيد في سريلانكا ليس مجرد اصطياد الأسماك، بل فرصة للغوص في ثقافة وتقاليد الجزيرة. من أبرز التجارب الفريدة:",

            expStiltTitle: "الصيد على الأعمدة (Stilt Fishing)",
            expStiltDesc: "طريقة تقليدية يجلس فيها الصيادون على أعمدة مرتفعة قرب الشاطئ، وهي ممارسة فريدة من نوعها في سريلانكا.",

            expDeepSeaTitle: "الصيد في أعماق البحر",
            expDeepSeaDesc: "الخروج إلى المحيط الهندي لصيد المارلين، التونة، الباراكودا وغيرها من الأسماك الكبيرة.",

            expLagoonTitle: "الصيد في اللاغونات والأنهار",
            expLagoonDesc: "استمتع بالهدوء الصيد في اللاغونات والأنهار الغنية بأسماك مثل التيلابيا والسلور.",

            expNightTitle: "الصيد الليلي",
            expNightDesc: "تجربة مثيرة للصيد تحت النجوم، شائعة في القرى الساحلية.",

            stiltImageAlt: "الصيد على الأعمدة — طريقة تقليدية ورمز أيقوني لتراث الصيد في سريلانكا.",
            stiltImageCaption: "الصيد على الأعمدة — طريقة تقليدية ورمز أيقوني لتراث الصيد في سريلانكا.",

            deepSeaImageAlt: "الصيد في أعماق البحر — مغامرة مثيرة مع الأسماك الكبيرة في المحيط الهندي.",
            deepSeaImageCaption: "الصيد في أعماق البحر — مغامرة مثيرة مع الأسماك الكبيرة في المحيط الهندي.",

            tipsTitle: "نصائح لرحلة صيد ممتعة",
            tip1: "اختر الموسم المناسب: الساحل الجنوبي (أكتوبر–أبريل)، الساحل الشرقي (مارس–أكتوبر).",
            tip2: "احمل واقي شمس، قبعة، وملابس مريحة.",
            tip3: "احجز مرشدًا أو قاربًا خاصًا لتحقيق أقصى استفادة من تجربتك.",
            tip4: "احترم البيئة: لا ترمِ النفايات واتبع ممارسات الصيد المستدام.",
            tip5: "حافظ على رطوبة جسمك واحمل وجبات خفيفة للرحلات الطويلة."
        },
        jeepSafari: {
            title: "سفاري الجيب في سريلانكا",

            introParagraph1: "تقدّم الحدائق الوطنية في سريلانكا تجربة سفاري جيب مثيرة تتيح لك استكشاف التنوّع البيولوجي الغني ومشاهدة الحياة البرية في بيئتها الطبيعية. من أشهر الوجهات: حديقة يالا، ويلباتو، وأوداوالاوي.",
            introParagraph2: "توفر هذه الرحلات فرصة رؤية الفيلة، النمور، الدببة الكسلانة، الجاموس المائي، التماسيح، وأنواع عديدة من الطيور. يرافقكم خبراء طبيعيون ومرشدون محترفون — مثالية لعشاق الحياة البرية والمصورين.",

            mainImageAlt: "سفاري الجيب في سريلانكا",
            mainImageCaption: "سفاري الجيب في سريلانكا",

            whyChooseTitle: "لماذا تختار سفاري الجيب؟",
            whyChooseIntro: "سفاري الجيب من أفضل الطرق لاستكشاف الحياة البرية المتنوعة في سريلانكا. إليك أبرز المميزات:",

            highlight1: "لقاءات قريبة مع أنواع أيقونية مثل الفيلة والنمور.",
            highlight2: "الوصول إلى مناطق نائية وخلابة داخل الحدائق الوطنية.",
            highlight3: "فرص رائعة لتصوير الحياة البرية في بيئتها الطبيعية.",
            highlight4: "إرشاد من خبراء طبيعيين وحراس الحدائق المتمرسين.",
            highlight5: "مغامرة تناسب جميع الأعمار — تجمع بين الإثارة والتعليم.",

            wildlifeImageAlt: "شاهد الحياة البرية الأيقونية مثل النمور والفيلة والتماسيح أثناء السفاري.",
            wildlifeImageCaption: "شاهد الحياة البرية الأيقونية مثل النمور والفيلة والتماسيح أثناء السفاري.",

            landscapeImageAlt: "استكشف مناظر سريلانكا الخلابة في الحدائق الوطنية — من الغابات الكثيفة إلى السهول المفتوحة.",
            landscapeImageCaption: "استكشف مناظر سريلانكا الخلابة في الحدائق الوطنية — من الغابات الكثيفة إلى السهول المفتوحة.",

            tipsTitle: "نصائح لسفاري جيب ممتع",
            tip1: "ارتدِ ملابس مريحة بلون محايد للاندماج مع البيئة.",
            tip2: "احمل واقي شمس، قبعة، وطارد للحشرات.",
            tip3: "احمل منظارًا وكاميرا لتحسين التجربة والتقاط الصور.",
            tip4: "اتبع تعليمات المرشد لضمان السلامة واحترام الحيوانات.",
            tip5: "احجز السفاري مبكرًا، خاصة في مواسم الذروة."
        },
        riverSafari: {
            title: "سفاري الأنهار في سريلانكا",

            introParagraph1: "سفاري الأنهار في سريلانكا يقدّم طريقة فريدة لاستكشاف التنوّع البيولوجي الغني وجمال الطبيعة. انزلق بهدوء على الممرات المائية المحاطة بغابات المانغروف الكثيفة، راقب الحياة البرية الغريبة، واستمتع بغروب الشمس الخلّاب.",
            introParagraph2: "أشهر الوجهات: نهر مادو غانغا ونهر بينتوتا. تتيح هذه الرحلات مشاهدة أنواع عديدة من الطيور، السحالي العملاقة، التماسيح، وحتى القرود في بيئتها الطبيعية. جو هادئ مثالي لعشاق الطبيعة والمصورين.",

            mainImageAlt: "سفاري الأنهار في سريلانكا",
            mainImageCaption: "سفاري الأنهار في سريلانكا",

            whyChooseTitle: "لماذا تختار سفاري الأنهار؟",
            whyChooseIntro: "سفاري النهر تجربة مريحة وغامرة تجمع بين الطبيعة، الحياة البرية، والاستكشاف الثقافي. أبرز المميزات:",

            highlight1: "استكشاف غابات المانغروف الكثيفة المليئة بالحياة.",
            highlight2: "رصد الطيور الغريبة، التماسيح، والحيوانات الأخرى.",
            highlight3: "زيارة جزر صغيرة وقرى محلية على ضفاف النهر.",
            highlight4: "الاستمتاع بالهدوء والجمال الخلاب للممرات المائية في سريلانكا.",
            highlight5: "مثالي للعائلات، الأزواج، والمسافرين المنفردين الباحثين عن الهدوء.",

            mangrovesImageAlt: "اكتشف غابات المانغروف الكثيفة التي تصطف على الممرات المائية الخلابة في سريلانكا.",
            mangrovesImageCaption: "اكتشف غابات المانغروف الكثيفة التي تصطف على الممرات المائية الخلابة في سريلانكا.",

            wildlifeImageAlt: "راقب الحياة البرية الغريبة مثل التماسيح، السحالي العملاقة، والطيور الملونة أثناء السفاري.",
            wildlifeImageCaption: "راقب الحياة البرية الغريبة مثل التماسيح، السحالي العملاقة، والطيور الملونة أثناء السفاري.",

            tipsTitle: "نصائح لسفاري نهر ممتع",
            tip1: "ارتدِ ملابس مريحة وأحضر قبعة وواقي شمس.",
            tip2: "احمل منظارًا لرؤية الحيوانات والطيور البعيدة.",
            tip3: "احمل كاميرا أو هاتفًا لتوثيق المناظر والحياة البرية.",
            tip4: "اتبع تعليمات المرشد لضمان السلامة والمتعة.",
            tip5: "احترم البيئة الطبيعية بعدم رمي النفايات أو إزعاج الحيوانات."
        },
        snorkeling: {
            title: "الغوص السطحي (السنوركلينغ) في سريلانكا",

            introParagraph1: "السنوركلينغ في سريلانكا يقدّم تجربة تحت الماء لا تُنسى، حيث تستكشف الشعاب المرجانية النابضة بالحياة والحياة البحرية المتنوعة. بمياهها الصافية والنظم البيئية البحرية الغنية، سريلانكا جنة للغواصين السطحيين من جميع المستويات.",
            introParagraph2: "أشهر الأماكن: هيكادوا بأحواضها المرجانية الملوّنة والسلاحف، جزيرة الحمام في ترينكومالي بسبب شعابها البكر، وميريسا حيث قد ترى حوتًا أو اثنين خلال موسم السنوركلينغ.",

            mainImageAlt: "السنوركلينغ في سريلانكا",
            mainImageCaption: "السنوركلينغ في سريلانكا",

            whyChooseTitle: "لماذا تختار السنوركلينغ في سريلانكا؟",
            whyChooseIntro: "السنوركلينغ في سريلانكا تجربة ساحرة تجمع بين المغامرة والجمال الطبيعي. إليك أبرز المميزات:",

            highlight1: "استكشاف الشعاب المرجانية النابضة بالحياة.",
            highlight2: "السباحة بجانب الأسماك الاستوائية، السلاحف، وحتى أسماك القرش الشعابية.",
            highlight3: "اكتشاف مناظر تحت الماء نقية في مياه دافئة وصافية.",
            highlight4: "مناسب للمبتدئين والمحترفين على حد سواء.",
            highlight5: "يمكن الوصول إليها من أفضل وجهات الشواطئ في سريلانكا.",

            coralImageAlt: "اكتشف الشعاب المرجانية المذهلة ونُظُمها البيئية النابضة.",
            coralImageCaption: "اكتشف الشعاب المرجانية المذهلة ونُظُمها البيئية النابضة.",

            marineLifeImageAlt: "التقِ بالحياة البحرية المتنوعة — السلاحف، الأسماك الاستوائية، وأكثر.",
            marineLifeImageCaption: "التقِ بالحياة البحرية المتنوعة — السلاحف، الأسماك الاستوائية، وأكثر.",

            tipsTitle: "نصائح لتجربة سنوركلينغ لا تُنسى",
            tip1: "ارتدِ قناعًا وأنبوبًا مريحين لضمان رؤية واضحة تحت الماء.",
            tip2: "استخدم واقي شمس آمن للشعاب لحماية بشرتك والبيئة البحرية.",
            tip3: "اسبح بهدوء لتجنب إزعاج الشعاب والكائنات البحرية.",
            tip4: "حافظ على رطوبة جسمك وخذ استراحات بين الجلسات.",
            tip5: "انضم إلى جولة بمرافقة مرشد لأفضل الأماكن ونصائح السلامة."
        },
        teaTasting: {
            title: "جولة تذوّق الشاي في سريلانكا",

            introParagraph1: "سريلانكا، التي تُلقّب غالبًا بـ«لؤلؤة المحيط الهندي»، مشهورة بإنتاجها العالمي للشاي. انطلق في جولة تذوّق الشاي واكتشف مزارع الشاي الخضراء في مناطق مثل نوارا إليا، إيلا، وكاندي. تعرّف على فن زراعة الشاي، العملية الدقيقة للإنتاج، وتذوّق النكهات الغنية لشاي سيلان الأصيل.",
            introParagraph2: "سواء كنت محبًا للشاي أو مجرد فضولي، فإن جولة تذوّق الشاي تقدّم فرصة فريدة للغوص في تراث الشاي السريلانكي واستكشاف جمال المرتفعات الهادئ.",

            mainImageAlt: "جولة تذوّق الشاي في سريلانكا",
            mainImageCaption: "جولة تذوّق الشاي في سريلانكا",

            whyChooseTitle: "لماذا تختار جولة تذوّق الشاي؟",
            whyChooseIntro: "جولة تذوّق الشاي في سريلانكا ليست مجرد تذوّق — إنها تجربة ثقافية غامرة. إليك أبرز المميزات:",

            highlight1: "زيارة مزارع الشاي الخلابة في المرتفعات الباردة.",
            highlight2: "التعرّف على تاريخ شاي سيلان وأهميته.",
            highlight3: "المشاركة في قطف أوراق الشاي ومشاهدة عملية الإنتاج في المصانع.",
            highlight4: "تذوّق أنواع مختلفة من الشاي — من الأسود إلى الأخضر والمنكّه.",
            highlight5: "الاستمتاع بمناظر الجبال المغطاة بالضباب والشلالات المتدفقة.",

            plantationImageAlt: "استكشف مزارع الشاي الخضراء وتعرّف على زراعة الشاي.",
            plantationImageCaption: "استكشف مزارع الشاي الخضراء وتعرّف على زراعة الشاي.",

            preparationImageAlt: "اكتشف فن تحضير الشاي وتذوّق شاي سيلان الأصيل.",
            preparationImageCaption: "اكتشف فن تحضير الشاي وتذوّق شاي سيلان الأصيل.",

            tipsTitle: "نصائح لجولة تذوّق شاي ممتعة",
            tip1: "ارتدِ ملابس وأحذية مريحة للمشي في المزارع.",
            tip2: "احمل جاكيت خفيف — المناطق المرتفعة باردة وضبابية.",
            tip3: "جرّب أنواعًا مختلفة واشترِ المفضّلة كهدايا تذكارية.",
            tip4: "اسأل أسئلة كثيرة — المرشدون يحبون مشاركة المعرفة.",
            tip5: "اجمع بين الجولة وزيارة الشلالات والمناظر القريبة."
        },
        templeVisit: {
            title: "زيارة المعابد في سريلانكا",

            introParagraph1: "سريلانكا، المعروفة بأرض بوذا، تحتضن معابد قديمة تعكس تراثها الروحي والثقافي الغني. انطلق في رحلة لاكتشاف معابد أيقونية مثل معبد سنّ بوذا في كاندي، ومعبد كهوف دامبولا، ورووانويليسيا في أنورادهابورا.",
            introParagraph2: "هذه المواقع المقدسة مزيّنة بنقوش معقدة وجداريات وتماثيل، تقدّم لمحة عن التقاليد الروحية والبراعة المعمارية للجزيرة. زيارة المعبد ليست مجرد تجربة ثقافية، بل فرصة للعثور على السلام والهدوء.",

            mainImageAlt: "زيارة المعابد في سريلانكا",
            mainImageCaption: "زيارة المعابد في سريلانكا",

            whyVisitTitle: "لماذا تزور المعابد في سريلانكا؟",
            whyVisitIntro: "زيارة المعابد في سريلانكا فرصة فريدة للتواصل مع تاريخ الجزيرة وثقافتها وروحانياتها. إليك أبرز المميزات:",

            highlight1: "التأمل في العمارة الدقيقة والتماثيل التي تعود لقرون.",
            highlight2: "تعلم تقاليد البوذية والطقوس من مرشدين على دراية.",
            highlight3: "استكشاف مواقع التراث العالمي لليونسكو مثل معبد دامبولا الذهبي.",
            highlight4: "عيش الهدوء والأجواء الروحية في الأماكن المقدسة.",
            highlight5: "مشاهدة المهرجانات النابضة مثل إيسала بيراهيرا في معبد سنّ بوذا.",

            interiorImageAlt: "استمتع بالديكورات الداخلية المذهلة المزينة بنقوش وجداريات معقدة.",
            interiorImageCaption: "استمتع بالديكورات الداخلية المذهلة المزينة بنقوش وجداريات معقدة.",

            sacredImageAlt: "زُر المعابد المقدسة مثل رووانويليسيا وغُص في التقاليد الروحية.",
            sacredImageCaption: "زُر المعابد المقدسة مثل رووانويليسيا وغُص في التقاليد الروحية.",

            tipsTitle: "نصائح لزيارة المعابد في سريلانكا",
            tip1: "ارتدِ ملابس محتشمة تغطي الكتفين والركبتين احترامًا للمكان.",
            tip2: "اخلع حذاءك قبل دخول ساحة المعبد.",
            tip3: "امتنع عن لمس التماثيل أو الأشياء المقدسة.",
            tip4: "يمكنك ترك تبرع بسيط للمعبد إذا أردت.",
            tip5: "احترم الصمت والأجواء الروحية أثناء الزيارة."
        },
        whiteWaterRafting: {
            title: "التجديف في المياه البيضاء في سريلانكا",

            introParagraph1: "التجديف في المياه البيضاء في سريلانكا تجربة مثيرة جدًا، خاصة في كيتولغالا عاصمة المغامرات في الجزيرة. نهر كيلاني بتياراته المتسارعة ومحيطه الخلاب يقدّم بيئة مثالية للمبتدئين والمحترفين على حد سواء.",
            introParagraph2: "عادةً ما تغطي الرحلات مسافة 5 كم بتيارات من الدرجة 2 إلى 4. يستمتع المشاركون بإثارة اجتياز التيارات الصعبة مع الاستمتاع بالخضرة الكثيفة والمناظر الخلابة على ضفاف النهر.",

            mainImageAlt: "التجديف في المياه البيضاء في سريلانكا",
            mainImageCaption: "التجديف في المياه البيضاء في سريلانكا",

            whyChooseTitle: "لماذا تختار التجديف في المياه البيضاء في سريلانكا؟",
            whyChooseIntro: "التجديف في المياه البيضاء في سريلانكا يجمع بين المغامرة والجمال الطبيعي بطريقة فريدة. إليك أبرز المميزات:",

            highlight1: "اجتياز التيارات المثيرة بمساعدة مدربين محترفين.",
            highlight2: "الاستمتاع بمناظر مذهلة للغابات المطيرة والتضاريس الجبلية.",
            highlight3: "إمكانية دمج النشاط مع المشي لمسافات طويلة، مراقبة الطيور، والكانيونينغ في كيتولغالا.",
            highlight4: "مثالي للمجموعات، العائلات، أو المسافرين المنفردين الباحثين عن جرعة أدرينالين.",

            actionImageAlt: "اشعر بالأدرينالين وأنت تتغلب على التيارات الصعبة في نهر كيلاني.",
            actionImageCaption: "اشعر بالأدرينالين وأنت تتغلب على التيارات الصعبة في نهر كيلاني.",

            scenicImageAlt: "استمتع بجمال الطبيعة الهادئ والخضرة الكثيفة أثناء مغامرتك.",
            scenicImageCaption: "استمتع بجمال الطبيعة الهادئ والخضرة الكثيفة أثناء مغامرتك.",

            tipsTitle: "نصائح لرحلة تجديف آمنة وممتعة",
            tip1: "ارتدِ سترة النجاة والخوذة التي يوفّرها المرشد دائمًا.",
            tip2: "استمع جيدًا لتعليمات السلامة قبل البدء.",
            tip3: "ارتدِ ملابس سريعة الجفاف وأحذية مائية ثابتة.",
            tip4: "احمل معك ملابس للتغيير ومنشفة بعد الرحلة.",
            tip5: "احجز مع شركة موثوقة لضمان تجربة آمنة وممتعة."
        },
        wildlifeSafari: {
            title: "سفاري الحياة البرية في سريلانكا",

            introParagraph1: "سريلانكا، المعروفة بتنوّعها البيولوجي الغني، تقدّم رحلات سفاري رائعة في حدائق وطنية مثل يالا، ويلباتو، مينيريا، وأوداوالاوي. تمنحك فرصة مشاهدة الأفيال، النمور، الدببة الكسلانة، وأنواع عديدة من الطيور في بيئتها الطبيعية.",
            introParagraph2: "استكشف مناظر متنوعة من الغابات الكثيفة إلى السهول المفتوحة، والتقط لحظات لا تُنسى من الحياة البرية. مع مرشدين خبراء وجيبات سفاري ممتازة، فإن سفاري الحياة البرية في سريلانكا تجربة لا بد منها لعشاق الطبيعة.",

            mainImageAlt: "سفاري الحياة البرية في سريلانكا",
            mainImageCaption: "سفاري الحياة البرية في سريلانكا",

            whyChooseTitle: "لماذا تختار سفاري الحياة البرية؟",
            whyChooseIntro: "سفاري الحياة البرية في سريلانكا فرصة فريدة للتواصل مع الطبيعة واكتشاف التنوع البيولوجي المذهل للجزيرة. أبرز المميزات:",

            highlight1: "مشاهدة الأنواع الأيقونية مثل الأفيال، النمور، والتماسيح.",
            highlight2: "استكشاف الغابات الكثيفة، الأراضي الرطبة، والسهول المفتوحة المليئة بالحياة البرية.",
            highlight3: "التقاط صور مذهلة للحياة البرية في بيئتها الطبيعية.",
            highlight4: "إثارة رؤية النمر السريلانكي المتواري عن الأنظار.",
            highlight5: "التعرّف على جهود الحفاظ على البيئة من مرشدين وخبراء طبيعة.",

            elephantsImageAlt: "شاهد الأفيال المهيبة تتجول بحرية في الحدائق الوطنية السريلانكية.",
            elephantsImageCaption: "شاهد الأفيال المهيبة تتجول بحرية في الحدائق الوطنية السريلانكية.",

            leopardImageAlt: "رصد النمر السريلانكي المتواري — أبرز ما في أي سفاري.",
            leopardImageCaption: "رصد النمر السريلانكي المتواري — أبرز ما في أي سفاري.",

            tipsTitle: "نصائح لسفاري ممتع وناجح",
            tip1: "ارتدِ ملابس بألوان محايدة للتماهي مع البيئة.",
            tip2: "احمل واقي شمس، قبعة، وطارد حشرات.",
            tip3: "أحضر منظارًا وكاميرا للرصد والتصوير.",
            tip4: "اتبع تعليمات المرشد بدقة للأمان والمتعة.",
            tip5: "احجز مبكرًا، خاصة في المواسم العالية — الأماكن في يالا تنفد بسرعة."
        },
        about: {
            hero: {
                discover: "اكتشف",
                aamyTours: "AAMY TOURS",
                tagline1: "من القلاع القديمة إلى تلال الشاي الزمردية ورحلات السفاري المثيرة — سريلانكا تنبض بالحياة. هذه الجزيرة ليست مجرد وجهة — إنها مغامرة تلامس الروح.",
                tagline2: "شواطئ ذهبية دافئة، مرتفعات ضبابية، وعجائب لا نهاية لها في انتظارك. مع Aamy Tours Sri Lanka، كل لحظة تتحول إلى ذكرى عزيزة."
            },
            slider: {
                sigiriya: "قلعة سيجيريا الصخرية",
                yala: "حديقة يالا الوطنية",
                tea: "مناطق زراعة الشاي",
                beaches: "الشواطئ النقية",
                temples: "المعابد المقدسة"
            },
            about: {
                title: "عن Aamy Tours سريلانكا",
                signature: "رحلات سريلانكا المميزة"
            },
            tours: {
                days4: "4 أيام",
                classic: "الأوديسا الكلاسيكية",
                days5: "5 أيام",
                safari: "رحلات السفاري",
                days6: "6 أيام",
                retreat: "ملاذ الوعي",
                desc1: "مع Aamy Tours سريلانكا، سافر عبر كل ركن من أركان هذه الجزيرة الخلابة — من المدن الصاخبة إلى المرتفعات الضبابية والشواطئ الجنوبية النقية.",
                desc2: "اختبر أفضل ما في سريلانكا — من قلب كاندي المقدس إلى كولومبو النابض بالحياة وجمال الساحل الجنوبي الهادئ.",
                desc3: "سواء كنت تتوق إلى المغامرة، الثقافة، الحياة البرية أو الهدوء، فإن Aamy Tours سريلانكا تصمم رحلات لا تُنسى — في أي موسم من السنة."
            },
            whoWeAre: {
                title: "من نحن",
                description: "مرحبًا بكم في Aamy Tours سريلانكا — دليلكم الموثوق في كل محافظة من هذه الجزيرة الساحرة. بأكثر من <strong>14 عامًا من الخبرة</strong>، يصمم فريقنا المحلي المتحمس رحلات غامرة تتجاوز السياحة العادية — يكشفون عن روح الجزيرة، تراثها الغني، وروعة طبيعتها الخلابة.",
                imageAlt: "فريق Aamy Tours",
                item1: { title: "مغامرات تغطي الجزيرة بأكملها", text: "نعمل في جميع المحافظات — من الشمال إلى أقصى الجنوب، نقدم تجارب محلية أصيلة في كل مكان." },
                item2: { title: "رحلات مصممة خصيصًا", text: "كل برنامج يُصمم حسب شغفك — مغامرة، ثقافة، طبيعة أو استرخاء." },
                item3: { title: "مرشدون محليون خبراء", text: "مرشدونا المرخصون، بأكثر من 14 عامًا من الخبرة، يكشفون عن الجواهر المخفية، القصص القديمة، ونبض سريلانكا الحقيقي." },
                item4: { title: "دعم على مدار الساعة", text: "مع Aamy Tours، أنت دائمًا في أمان — فريقنا متاح 24/7 طوال رحلتك." }
            },
            offers: {
                title: "ما نقدمه",
                cultural: { title: "الانغماس الثقافي", text: "غوص في التقاليد، المهرجانات، والحياة المحلية.", alt: "الانغماس الثقافي" },
                adventure: { title: "رحلات المغامرة", text: "التجول، السفاري، ركوب الأمواج، والإثارة في الهواء الطلق.", alt: "المغامرة" },
                luxury: { title: "الفخامة والراحة", text: "إقامات فاخرة، نقل خاص، وخدمة VIP.", alt: "الفخامة" },
                wellness: { title: "الصحة والتجديد", text: "اليوغا، الأيورفيدا، والسلام في أماكن هادئة.", alt: "الصحة" }
            },
            guides: {
                title: "مرشدونا",
                text: "مرشدونا المرخصون والمتحمسون هم روح كل رحلة. لا يقتصر الأمر على إظهار سريلانكا — بل يحيونها بالقصص، التقاليد، والأسرار الداخلية.",
                imageAlt: "مرشد Aamy Tours"
            },
            expert: {
                name: "عظيم محمد",
                role: "(خبير الجولات الرئيسي)",
                bio: "بأكثر من <strong>14 عامًا من الخبرة المرخصة</strong>، يعشق عظيم محمد كشف كنوز سريلانكا المخفية. من الشواطئ الذهبية إلى قمم الجبال الضبابية، من مغامرات الحياة البرية إلى العجائب القديمة — يحول كل رحلة إلى تجربة لا تُنسى على طريقة Aamy Tours.",
                imageAlt: "عظيم محمد"
            },
            vehicles: {
                title: "أسطولنا الفاخر",
                text: "في Aamy Tours سريلانكا، سلامتكم وراحتكم هي الأولوية القصوى. بأكثر من <strong>14 عامًا من الخبرة</strong>، نستخدم مركبات حديثة مكيفة ومُصانة بإتقان لرحلة سلسة عبر الجزيرة.",
                bookButton: "احجز رحلتك",
                car: { title: "سيارة", text: "مثالية للأزواج أو المسافرين بمفردهم (حتى 3 أشخاص). أنيقة، موفرة للوقود، ومثالية للرحلات الحميمية." },
                van: { title: "فان", text: "مثالية للعائلات أو المجموعات الصغيرة (حتى 6 أشخاص). واسعة ومريحة ومثالية للرحلات الطويلة." },
                minibus: { title: "ميني باص", text: "رائعة للمجموعات الكبيرة (8-12 شخصًا). مقاعد مريحة ومساحة كبيرة للأمتعة." },
                luxury: { title: "فاخرة", text: "مركبات فاخرة بمقاعد جلدية، واي فاي، وسائق خاص لراحة VIP." }
            },
            accommodations: {
                intro: "استمتع بالاسترخاء في منتجعات 3-5 نجوم حصرية وملاذات بوتيكية، تم اختيار كل منها للهدوء والرقي والراحة السلسة طوال رحلتك.",
                item1: "فيلات خاصة مع مسابح إنفينيتي وتجارب صحية شاملة في بيئة ساحلية هادئة.",
                item2: "فخامة مستوحاة من التراث تطل على المحيط، مع مطاعم راقية وأناقة استعمارية خالدة.",
                item3: "ملاذ بري فاخر بيئي يجمع بين الراحة الحديثة والانغماس في الطبيعة والحياة البرية.",
                item4: "جوهرة معمارية متناغمة مع الطبيعة، تقدم إطلالات بانورامية وتصميم فاخر مستدام."
            },
            notices: {
                title: "إشعارات مهمة",
                intro: "في Aamy Tours سريلانكا، نبذل قصارى جهدنا لجعل رحلتك لا تُنسى. استمتع بهذه المزايا المجانية في كل جولة:",
                bike: { title: "دراجة مجانية للضيوف", text: "استكشف الجزيرة بوتيرتك الخاصة — نوفر دراجة مجانية لكل ضيف خلال الجولة." },
                fruits: { title: "سلة فواكه هدية في نهاية الجولة", text: "اختم مغامرتك بلمسة حلوة — احصل على سلة فواكه طازجة مختارة يدويًا كهدية وداعية." },
                meals: { title: "وجبات مجانية في المناسبات الدينية", text: "شارك في التقاليد المحلية — نوفر وجبات مجانية للضيوف خلال مراسم تقديم النقود." }
            },
        },
        home: {
            common: { viewAll: "عرض الكل" },

            sections: {
                recommendations: { title: "وجهات مختارة بعناية", subtitle: "غير متأكد من أين تبدأ؟ دعنا نلهمك." },
                excursions: { title: "برامج رحلاتنا", desc: "رحلات متعددة الأيام مصممة بدقة — مزيج من التراث والطبيعة واللحظات المؤثرة للروح." },
                packages: { title: "باقات حصرية" },
                reviews: { title: "آراء الضيوف", subtitle: "أصوات حقيقية من المسافرين الذين عاشوا التجربة" },
                gallery: { title: "معرضنا", subtitle: "رحلة بصرية في روح سريلانكا — لحظات من العجب والفرح والجمال الخالد." }
            },

            recommendations: {
                sigiriya: { label: "سيجيريا", name: "قلعة صخرية قديمة تتربع بشموخ فوق السهول." },
                udawalawa: { label: "أوداوالاوي", name: "قطعان الفيلة تتجول بحرية في السافانا الذهبية الشاسعة." },
                ella: { label: "إيلا", name: "تلال ضبابية، رحلات قطار ملحمية، وإطلالات بانورامية." },
                mirissa: { label: "ميريسا", name: "رمال ذهبية، أمواج فيروزية، وجنة مشاهدة الحيتان." },
                nuwaraeliya: { label: "نوارا إيليا", name: "مزارع الشاي المتدحرجة وهواء الجبال النقي." },
                kandy: { label: "كاندي", name: "المدينة المقدسة لمعبد سن الفيل (ضرس بوذا)." },
                galle: { label: "غالي", name: "جدران القلعة الاستعمارية تلتقي بالمحيط الهندي." },
                yala: { label: "يالا", name: "محمية حياة برية تضم النمور، الفيلة، والحيوانات المتنوعة." },
                anuradhapura: { label: "أنورادهابورا", name: "مهد البوذية مع الستوبا القديمة." },
                polonnaruwa: { label: "بولوناروا", name: "أطلال عاصمة ملكية من العصور الوسطى." }
            },

            excursions: {
                oneDay: { title: "يوم واحد — جوهر الجزيرة", des: "يوم واحد، ذكريات مدى الحياة — من الستوبا القديمة إلى الشواطئ الذهبية، سحر خالص." },
                twoDays: { title: "يومان — همس البرية", des: "يومان من الجمال الجامح: سفاري تحت سماء مليئة بالنجوم، تلال عطرة بالشاي، ونبض الغابة." },
                threeDays: { title: "ثلاثة أيام — الروح والشاطئ", des: "ثلاثة أيام لإيقاظ روحك — معابد مقدسة عند الفجر، أمواج المحيط عند الغروب، والثقافة في كل نفس." },
                fourDays: { title: "أربعة أيام — التراث والانسجام", des: "أربعة أيام من العجب الخالد: تسلق القلاع القديمة، تجول في الشوارع الاستعمارية، وتذوق التقاليد." },
                fiveDays: { title: "خمسة أيام — رحلة إلى القلب", des: "خمسة أيام لتقع في الحب — مرتفعات ضبابية، بحيرات فيروزية، وكل لحظة شعر متحرك." },
                sixDays: { title: "ستة أيام — الرحلة المميزة", des: "ستة أيام من الأناقة المنسقة — آثار مقدسة، سفاري برية، وغروب هادئ، منسوجة في قصة لا تُنسى." }
            },

            packages: {
                one: { title: "يوم واحد / 0 ليالٍ: جوهر الجزيرة", duration: "يوم واحد", desc: "يوم واحد، ذكريات مدى الحياة — ستوبا قديمة، شواطئ ذهبية، وروح سريلانكا في سحر خالص.", category: "لقطة مميزة" },
                two: { title: "يومان / ليلة واحدة: همس البرية", duration: "يومان", desc: "يومان من الجمال الجامح — سفاري تحت النجوم، تلال الشاي، ونبض الغابة.", category: "هروب بري" },
                three: { title: "3 أيام / ليلتان: الروح والشاطئ", duration: "3 أيام", desc: "ثلاثة أيام لإيقاظ الروح — معابد عند الفجر، أمواج عند الغروب، والثقافة في كل نفس.", category: "روحاني ساحلي" },
                four: { title: "4 أيام / 3 ليالٍ: التراث والانسجام", duration: "4 أيام", desc: "أربعة أيام من العجب الخالد — قلعة قديمة، شوارع استعمارية، وطعم التقاليد.", category: "غوص ثقافي عميق" },
                five: { title: "5 أيام / 4 ليالٍ: رحلة إلى القلب", duration: "5 أيام", desc: "خمسة أيام لتقع في الحب — مرتفعات ضبابية، بحيرات فيروزية، وكل لحظة شعر.", category: "مستكشف رومانسي" },
                six: { title: "6 أيام / 5 ليالٍ: الرحلة المميزة", duration: "6 أيام", desc: "ستة أيام من الأناقة المنسقة — آثار مقدسة، سفاري، وغروب هادئ في قصة لا تُنسى.", category: "كلاسيكية مميزة" }
            },

            featured: {
                perahera: {
                    h2: "شاهد العرض الرائع",
                    h3: "كاندي إيسالا بيراهيرا",
                    h4: "(مهرجان السن المقدس)",
                    paragraph: `أحد أعظم العروض البوذية في آسيا، يُقام سنويًا في كاندي لتكريم سن بوذا المقدس. أفيال بزينة ملكية، طبول إيقاعية، راقصو النار وحاملو المشاعل يضيئون الليل في عرض ساحر للإيمان والتقاليد. كن جزءًا من هذا التراث الحي مع <strong style="color: #166880;">Aamy Tours Sri Lanka</strong> — حيث تتنفس الثقافة وترقص التاريخ.`,
                    button: "اكتشف المزيد"
                },
                safari: {
                    h2: "إلى قلب البرية",
                    h3: "رحلات السفاري",
                    paragraph: `تُعد سريلانكا من أفضل وجهات الحياة البرية في آسيا. اجتاز سافانا <span style="color: #D5A44F; font-weight: 600;">يالا</span> و<span style="color: #D5A44F; font-weight: 600;">أوداوالاوي</span>، أو انزلق عبر الأراضي الرطبة الضبابية في <span style="color: #D5A44F; font-weight: 600;">ويلپاتو</span>. قابل الفيلة المهيبة، النمور الماكرة، والطيور النادرة في بيئتها الطبيعية. انطلق مع <strong style="color: #166880;">Aamy Tours Sri Lanka</strong> — كل سفاري قصة مكتوبة بالغبار والفجر.`,
                    button: "استكشف السفاري"
                }
            },

            gallery: {
                title: "معرضنا",
                subtitle: "رحلة بصرية في روح سريلانكا — لحظات من العجب والفرح والجمال الخالد.",
                alt1: "شروق الشمس فوق قلعة سيجيريا الصخرية",
                alt2: "سفاري الفيلة في حديقة يالا الوطنية",
                alt3: "قطافة الشاي في ضباب نوارا إيليا",
                alt4: "الساعة الذهبية على شاطئ ميريسا",
                alt5: "احتفال معبد سن بوذا في كاندي",
                alt6: "أطلال بولوناروا القديمة",
                alt7: "مشاهدة الحيتان قبالة الساحل الجنوبي",
                alt8: "رحلة القطار عبر تلال إيلا",
                alt9: "غروب الشمس في قلعة غالي",
                alt10: "صياد محلي في نيغومبو",
                alt11: "عرض رقص كاندي التقليدي",
                alt12: "رحلة بالمنطاد فوق دامبولا"
            },

            cta: {
                title: "Aamy Tours Sri Lanka — نصنع رحلات خالدة",
                desc: "كل رحلة تحفة فنية — منسوجة من الثقافة والمغامرة والهدوء. دعنا نصمم قصتك في لؤلؤة المحيط الهندي.",
                button: "ابدأ رحلتك",
                alt: "صمم رحلتك"
            },
        },
        hero: {
            title: {
                line1: "اكتشف الجنة مع",
                line2: "Aamy Tours",
                line3: "سريلانكا"
            },
            subtitle: "اغمر نفسك في غابات مطيرة زمردية، شواطئ ذهبية، ممالك قديمة، ولقاءات مثيرة مع الحياة البرية —",
            subtitle2: "مصممة خصيصًا لك.",
            cta: "ابدأ رحلتك",
            trust: "يثق بنا المستكشفون من أكثر من 50 دولة • ظهرنا في Lonely Planet وCNN Travel"
        },
        footer: {
            brand: "Aamy Tours<br />سريلانكا",
            nav: { home: "الرئيسية", about: "من نحن", explore: "استكشف سريلانكا", tours: "الباقات السياحية", gallery: "المعرض", events: "الفعاليات الخاصة", things: "أنشطة يجب تجربتها", contact: "تواصل معنا" },
            contact: { title: "لنصنع ذكريات معاً", address: "81/31h، شارع إتش كيه إدموند مواثا ميليدوا،<br />غالي، سريلانكا", email: "aamytourssl@gmail.com", phone: "+94 77 048 3364" },
            newsletter: { title: "انضم إلى رحلتنا", desc: "كن أول من يعرف بالعروض الحصرية والجواهر المخفية والمغامرات الخلابة.", placeholder: "بريدك الإلكتروني", subscribe: "اشترك" },
            tagline: "\"ليس كل من يتيه ضائعًا...<br /><span class='text-cyan-300 font-semibold'>بعضهم فقط مع Aamy Tours</span>\"",
            copyright: "مصنوع بحب. جميع الحقوق محفوظة.",
            developedBy: "صُمم وطُور بحب بواسطة"
        },
        tourpackages: {
            heroTitle: 'باقات الرحلات السياحية لدينا',
            heroSubtitle: 'اكتشف سريلانكا في يوم واحد — مغامرات مصممة بعناية من قبل <span class="text-[#D5A44F] font-bold">أمي تورز سريلانكا</span>',
            heroAlt: 'أمي تورز سريلانكا - مغامرات يوم واحد',
            chooseAdventure: 'اختر مغامرتك',
            packagesSubtitle: '25 تجربة مختارة بعناية — من رحلات السفاري البرية إلى التجارب الثقافية العميقة.',
            viewDetails: 'عرض التفاصيل',
            itineraryTitle: 'البرنامج اليومي',
            bookViaWhatsApp: 'احجز عبر واتساب',
            whatsappMessage: 'مرحبًا أمي تورز! أرغب بحجز: *{{title}}* ({{duration}})\n\nأخبرني بالتوافر والأسعار!',

            packages: {
                '1': {
                    title: 'مغامرة إيلا',
                    duration: 'يوم واحد',
                    category: 'طبيعة ومغامرة',
                    description: 'رحلة عبر التلال الضبابية، الشلالات المتدفقة، والجسور الأيقونية — مزيج مثالي من الإثارة والهدوء.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>شلال رافانا</strong> – السباحة في برك المياه الصافية</li>
                <li><strong>جسر الأقواس التسعة</strong> – محطة تصوير القطار الشهيرة</li>
                <li><strong>مزارع الشاي</strong> – المشي بين التلال الزمردية</li>
                <li><strong>رحلة القطار</strong> – من إيلا إلى ديمودارا بمناظر خلابة</li>
                <li><strong>قمة ليتل آدمز</strong> – إطلالات بانورامية على الشروق/الغروب</li>
                <li><strong>إطعام أفيال أوداوالاوي</strong> – لحظة مؤثرة مع الحياة البرية</li>
                <li><strong>حديقة الأعشاب الأيورفيدية</strong> – تعرف على أسرار العلاج القديمة</li>
            </ul>`
                },
                '2': {
                    title: 'إيلا ورحلة سفاري يالا',
                    duration: 'يوم واحد',
                    category: 'حياة برية ومناظر طبيعية',
                    description: 'من المرتفعات الضبابية إلى السافانا البرية — تجربة أجمل ما في الطبيعة في يوم لا يُنسى.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>شلال رافانا</strong> – بركة مائية منعشة</li>
                <li><strong>جسر الأقواس التسعة</strong> – عجيبة معمارية</li>
                <li><strong>مزارع الشاي</strong> – المشي في التلال الخضراء</li>
                <li><strong>قمة ليتل آدمز</strong> – مناظر خلابة من القمة</li>
                <li><strong>سفاري يالا</strong> – رحلة جيب مع النمور والفيلة</li>
            </ul>`
                },
                '3': {
                    title: 'يوم ثقافي في كاندي',
                    duration: 'يوم واحد',
                    category: 'تراث وطبيعة',
                    description: 'انغمس في المعابد المقدسة، الحدائق الغنّاء، والتقاليد المحلية في قلب سريلانكا.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>مدينة كاندي</strong> – مركز ثقافي نابض بالحياة</li>
                <li><strong>حديقة النباتات الملكية</strong> – جنة استوائية</li>
                <li><strong>مصنع الشاي ومزارعه</strong> – تجربة شاي سيلان</li>
                <li><strong>إطعام واستحمام وركوب الفيلة</strong> – تفاعل أخلاقي</li>
                <li><strong>حديقة الأعشاب الأيورفيدية</strong> – جولة علاجية طبيعية</li>
                <li><strong>برج أمبولوواوا</strong> – إطلالات بانورامية 360 درجة</li>
                <li><strong>مصنع المجوهرات والأحجار الكريمة</strong> – بريق الصناعة التقليدية</li>
                <li><strong>مصنع الحرير</strong> – نسج تقليدي</li>
            </ul>`
                },
                '4': {
                    title: 'رحلة كاندي المقدسة',
                    duration: 'يوم واحد',
                    category: 'روحانية وثقافة',
                    description: 'يوم مليء بالتأمل والتراث والجمال الطبيعي في مدينة كاندي المقدسة.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>معبد سن الفيل</strong> – الموقع البوذي المقدس</li>
                <li><strong>مصنع الشاي ومزارعه</strong> – تذوق الشاي الطازج</li>
                <li><strong>إطعام واستحمام وركوب الفيلة</strong> – الفيلة اللطيفة</li>
                <li><strong>حديقة الأعشاب الأيورفيدية</strong> – حكمة العلاج</li>
                <li><strong>برج أمبولوواوا</strong> – تسلق حلزوني إلى السماء</li>
                <li><strong>مصنع المجوهرات والأحجار</strong> – الأحجار المحلية</li>
                <li><strong>مصنع الحرير</strong> – فن الحرير</li>
            </ul>`
                },
                '5': {
                    title: 'يوم تراث سيجيريا',
                    duration: 'يوم واحد',
                    category: 'تاريخ ومغامرة',
                    description: 'اصعد قلعة الصخر الأثرية، استكشف الكهوف الذهبية، وتذوق الحياة القروية الأصيلة.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>صخرة الأسد سيجيريا</strong> – موقع تراث عالمي لليونسكو</li>
                <li><strong>معبد دامبولا الذهبي</strong> – فن الكهوف القديم</li>
                <li><strong>جولة قروية</strong> – عربة ثيران، قارب تقليدي، غداء تقليدي</li>
                <li><strong>حديقة الأعشاب الأيورفيدية</strong> – نباتات الشفاء</li>
                <li><strong>صخرة بيدوراجالا</strong> – أجمل إطلالة على سيجيريا</li>
            </ul>`
                },
                '6': {
                    title: 'تراث ساحل غالي',
                    duration: 'يوم واحد',
                    category: 'تاريخ وطبيعة',
                    description: 'تجول في الحصن الاستعماري، اركب قاربًا في أنهار المانجروف، وشاهد حفاظ السلاحف البحرية.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>معبد كاندي فيهارايا</strong> – تمثال بوذا العملاق</li>
                <li><strong>محمية السلاحف</strong> – إطلاق صغار السلاحف</li>
                <li><strong>سفاري نهر مادو</strong> – غابات المانجروف</li>
                <li><strong>منجم حجر القمر</strong> – تجربة استخراج الأحجار</li>
                <li><strong>حصن غالي الهولندي</strong> – مدينة استعمارية مدرجة في اليونسكو</li>
                <li><strong>حديقة الأعشاب الأيورفيدية</strong> – علاجات طبيعية</li>
            </ul>`
                },
                '7': {
                    title: 'اكتشاف مدينة كولومبو',
                    duration: 'يوم واحد',
                    category: 'حضرية وثقافة',
                    description: 'استكشف المعالم الحديثة، المواقع المقدسة، والتسوق النابض في عاصمة سريلانكا.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>برج اللوتس</strong> – إطلالة 360 درجة على المدينة</li>
                <li><strong>المسجد الأحمر</strong> – عمارة إسلامية مذهلة</li>
                <li><strong>التسوق</strong> – أسواق محلية ومولات</li>
                <li><strong>حديقة الأعشاب الأيورفيدية</strong> – محطة صحية</li>
                <li><strong>معبد جانجارمايا</strong> – واحة مقدسة في المدينة</li>
            </ul>`
                },
                '8': {
                    title: 'سفاري يالا البرية',
                    duration: 'يوم واحد',
                    category: 'حياة برية',
                    description: 'تتبع النمور والفيلة والطيور النادرة في واحدة من أفضل المنتزهات الوطنية في آسيا.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>سفاري جيب يالا</strong> – مغامرة 3 ساعات في البرية</li>
                <li>رصد النمور، الفيلة، الدببة الكسلى، وأكثر من 200 نوع طائر</li>
            </ul>`
                },
                '9': {
                    title: 'رحلة الحيتان في ميريسا',
                    duration: 'يوم واحد',
                    category: 'مغامرة بحرية',
                    description: 'أبحر مع الحيتان الزرقاء في قوارب مريحة — أكبر الكائنات في العالم عن قرب.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>مشاهدة الحيتان الزرقاء</strong> – رحلة بحرية 4 ساعات</li>
                <li><strong>شاطئ ميريسا</strong> – استرخِ على الرمال الذهبية</li>
                <li><strong>صيد الأسماك على الأعمدة</strong> – لحظة تصوير أيقونية</li>
                <li><strong>حديقة الأعشاب الأيورفيدية</strong> – صحة ساحلية</li>
            </ul>`
                },
                '10': {
                    title: 'يوم الفيلة في أوداوالاوي',
                    duration: 'يوم واحد',
                    category: 'حياة برية ورحمة',
                    description: 'شاهد صغار الفيلة تُطعم وتجول مع القطعان البرية في بيئتها الطبيعية.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>منتزه أوداوالاوي الوطني</strong> – سفاري جيب</li>
                <li><strong>إطعام الفيلة بالحليب</strong> – زيارة دار الأيتام</li>
            </ul>`
                },
                '11': {
                    title: 'إيلا وغالي إكسبريس',
                    duration: 'يوم واحد',
                    category: 'مناظر طبيعية وتراث',
                    description: 'من قطارات الجبال إلى الحصون الاستعمارية — رحلة سريعة تجمع بين الجمال والتاريخ.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>شلال رافانا</strong> – غطسة سريعة</li>
                <li><strong>جسر الأقواس التسعة</strong> – عبور القطار</li>
                <li><strong>رحلة قطار</strong> – من إيلا إلى غالي</li>
                <li><strong>قمة ليتل آدمز</strong> – تسلق عند الشروق</li>
                <li><strong>حصن غالي الهولندي</strong> – نزهة عند الغروب</li>
                <li><strong>مزارع الشاي</strong> – إطلالات من القمة</li>
                <li><strong>حديقة الأعشاب الأيورفيدية</strong> – محطة صحية</li>
            </ul>`
                },
                '12': {
                    title: 'سفاري يالا وغالي',
                    duration: 'يوم واحد',
                    category: 'برية واستعمارية',
                    description: 'سفاري صباحية في البرية، نزهة تراثية بعد الظهر — أفضل ما في الساحل الجنوبي.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>سفاري منتزه يالا الوطني</strong> – جولة جيب صباحية</li>
                <li><strong>حصن غالي الهولندي</strong> – نزهة استعمارية بعد الظهر</li>
            </ul>`
                },
                '13': {
                    title: 'كاندي وإيلا ويالا إكسبريس',
                    duration: 'يومان',
                    category: 'ثقافية ومناظر طبيعية',
                    description: 'من المعابد المقدسة إلى التلال الضبابية ورحلات السفاري البرية — جولة سريعة على أبرز معالم سريلانكا.',
                    itinerary: `<h3>اليوم الأول:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>سفاري منتزه يالا الوطني</strong> – جولة جيب صباحية</li>
                <li><strong>شلال رافانا</strong> – غطسة سريعة</li>
                <li><strong>جسر الأقواس التسعة</strong> – عبور القطار</li>
                <li><strong>رحلة قطار فاخرة</strong></li>
                <li><strong>مزارع الشاي</strong> – إطلالات من القمة</li>
            </ul>
            <h3 class="mt-4">اليوم الثاني:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>أمبولوواوا</strong> – تسلق سريع</li>
                <li><strong>حدائق النباتات</strong> – جنة استوائية</li>
                <li><strong>معبد سن الفيل</strong> – زيارة مقدسة</li>
                <li><strong>ركوب الفيلة</strong> – تفاعل أخلاقي</li>
                <li><strong>مصنع الشاي</strong> – تجربة شاي سيلان</li>
            </ul>
            <h3 class="mt-4">الإقامة ليلة في كاندي (فندق فاخر)</h3>`
                },
                '14': {
                    title: 'رحلة كاندي الثقافية',
                    duration: 'يومان',
                    category: 'ثقافية',
                    description: 'انغمس في المعابد المقدسة، الحدائق الغنّاء، والتقاليد المحلية في قلب سريلانكا.',
                    itinerary: `<ul class="space-y-2 text-sm md:text-base">
                <li><strong>مدينة كاندي</strong> – مركز ثقافي نابض بالحياة</li>
                <li><strong>حديقة النباتات الملكية</strong> – جنة استوائية</li>
                <li><strong>مصنع الشاي ومزارعه</strong> – تجربة شاي سيلان</li>
                <li><strong>إطعام واستحمام وركوب الفيلة</strong> – تفاعل أخلاقي</li>
                <li><strong>حديقة الأعشاب الأيورفيدية</strong> – جولة علاجية طبيعية</li>
                <li><strong>برج أمبولوواوا</strong> – إطلالات بانورامية 360 درجة</li>
                <li><strong>مصنع المجوهرات والأحجار الكريمة</strong> – بريق الصناعة التقليدية</li>
                <li><strong>مصنع الحرير</strong> – نسج تقليدي</li>
                <li><strong>نيليغالا</strong> – معبد تقليدي</li>
            </ul>`
                },
                '15': {
                    title: 'إيلا / نوارا إليا / كاندي الثقافية',
                    duration: 'يومان',
                    category: 'ثقافية ومناظر طبيعية',
                    description: 'من المرتفعات الضبابية إلى المعابد المقدسة — رحلة روحية في قلب سريلانكا.',
                    itinerary: `<h3>اليوم الأول:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>شلال رافانا</strong> – غطسة سريعة</li>
                <li><strong>جسر الأقواس التسعة</strong> – عبور القطار</li>
                <li><strong>قمة ليتل آدمز</strong> – تسلق خلاب</li>
                <li><strong>رحلة قطار فاخرة</strong></li>
                <li><strong>مزارع الشاي</strong> – إطلالات من القمة</li>
                <li><strong>مكتب بريد وردي</strong> – جمال ثقافي</li>
                <li><strong>أمبولوواوا</strong> – نزهة هادئة</li>
            </ul>
            <h3 class="mt-4">اليوم الثاني:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>معبد هندوسي</strong> – زيارة ثقافية</li>
                <li><strong>حدائق النباتات</strong> – جنة استوائية</li>
                <li><strong>نيليغالا</strong> – زيارة مقدسة</li>
                <li><strong>شلال رامبودا</strong></li>
                <li><strong>مصنع الشاي</strong> – تجربة شاي سيلان</li>
                <li><strong>ركوب الفيلة</strong> – تفاعل أخلاقي</li>
                <li><strong>حديقة الأعشاب</strong> – جنة استوائية</li>
            </ul>`
                },
                '16': {
                    title: 'يالا / إيلا / نوارا إليا / كاندي الثقافية',
                    duration: '3 أيام',
                    category: 'ثقافية ومناظر طبيعية',
                    description: 'من التلال الضبابية إلى المعابد المقدسة — رحلة روحية في قلب سريلانكا.',
                    itinerary: `<h3>اليوم الأول:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>شلال رافانا</strong> – غطسة سريعة</li>
                <li><strong>جسر الأقواس التسعة</strong> – عبور القطار</li>
                <li><strong>قمة ليتل آدمز</strong> – تسلق خلاب</li>
                <li><strong>رحلة قطار فاخرة</strong></li>
                <li><strong>مزارع الشاي</strong> – إطلالات من القمة</li>
                <li><strong>معبد هندوسي</strong> – زيارة ثقافية</li>
                <li><strong>سفاري منتزه يالا الوطني</strong> – جولة جيب صباحية</li>
            </ul>
            <h3 class="mt-4">اليوم الثاني:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>أمبولوواوا</strong> – نزهة هادئة</li>
                <li><strong>مكتب بريد وردي</strong> – جمال ثقافي</li>
                <li><strong>حدائق النباتات</strong> – جنة استوائية</li>
                <li><strong>معبد سن الفيل</strong> – زيارة مقدسة</li>
            </ul>
            <h3 class="mt-4">اليوم الثالث:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>نيليغالا</strong> – زيارة مقدسة</li>
                <li><strong>مصنع الشاي</strong> – تجربة شاي سيلان</li>
                <li><strong>المجوهرات والأحجار الكريمة</strong> – تجربة الأحجار السيلانية</li>
                <li><strong>نحت الخشب</strong> – نحت تقليدي</li>
                <li><strong>ركوب الفيلة</strong> – تفاعل أخلاقي</li>
            </ul>`
                },
                '17': {
                    title: 'إيلا / نوارا إليا / كاندي / سيجيريا الثقافية',
                    duration: '3 أيام',
                    category: 'ثقافية ومناظر طبيعية',
                    description: 'من التلال الضبابية إلى المعابد المقدسة — رحلة روحية في قلب سريلانكا.',
                    itinerary: `<h3>اليوم الأول:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>شلال رافانا</strong> – غطسة سريعة</li>
                <li><strong>جسر الأقواس التسعة</strong> – عبور القطار</li>
                <li><strong>قمة ليتل آدمز</strong> – تسلق خلاب</li>
                <li><strong>رحلة قطار فاخرة</strong></li>
                <li><strong>مزارع الشاي</strong> – إطلالات من القمة</li>
                <li><strong>معبد هندوسي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الثاني:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>أمبولوواوا</strong> – نزهة هادئة</li>
                <li><strong>حدائق النباتات</strong> – جنة استوائية</li>
                <li><strong>صخرة بيدوراجالا</strong> – تسلق خلاب</li>
            </ul>
            <h3 class="mt-4">اليوم الثالث:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>المعبد الذهبي</strong> – زيارة مقدسة</li>
                <li><strong>صخرة الأسد سيجيريا</strong> – قلعة أثرية</li>
                <li><strong>جولة قروية مع رحلة قارب وغداء تقليدي</strong> – تجربة ثقافية</li>
            </ul>`
                },
                '18': {
                    title: 'إيلا / نوارا إليا / كاندي / سيجيريا / بولوناروا الثقافية',
                    duration: '3 أيام',
                    category: 'ثقافية ومناظر طبيعية',
                    description: 'من التلال الضبابية إلى المعابد المقدسة — رحلة روحية في قلب سريلانكا.',
                    itinerary: `<h3>اليوم الأول:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>شلال رافانا</strong> – غطسة سريعة</li>
                <li><strong>جسر الأقواس التسعة</strong> – عبور القطار</li>
                <li><strong>قمة ليتل آدمز</strong> – تسلق خلاب</li>
                <li><strong>رحلة قطار فاخرة</strong></li>
                <li><strong>مزارع الشاي</strong> – إطلالات من القمة</li>
                <li><strong>معبد هندوسي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الثاني:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>أمبولوواوا</strong> – نزهة هادئة</li>
                <li><strong>حدائق النباتات</strong> – جنة استوائية</li>
                <li><strong>مصنع الشاي</strong> – تجربة شاي سيلان</li>
                <li><strong>ركوب الفيلة</strong> – تفاعل أخلاقي</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الثالث:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>صخرة الأسد سيجيريا</strong> – موقع تراث عالمي لليونسكو</li>
                <li><strong>جولة مدينة بولوناروا الأثرية</strong> – مدينة ثقافية</li>
            </ul>`
                },
                '19': {
                    title: 'يالا / إيلا / نوارا إليا / كاندي / بولوناروا الثقافية',
                    duration: '4 أيام',
                    category: 'ثقافية ومناظر طبيعية',
                    description: 'من التلال الضبابية إلى المعابد المقدسة — رحلة روحية في قلب سريلانكا.',
                    itinerary: `<h3>اليوم الأول:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>سفاري منتزه يالا الوطني</strong> – جولة جيب صباحية</li>
                <li><strong>شلال رافانا</strong> – غطسة سريعة</li>
                <li><strong>جسر الأقواس التسعة</strong> – عبور القطار</li>
                <li><strong>قمة ليتل آدمز</strong> – تسلق خلاب</li>
                <li><strong>رحلة قطار فاخرة</strong></li>
            </ul>
            <h3 class="mt-4">اليوم الثاني:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>مزارع الشاي</strong> – إطلالات من القمة</li>
                <li><strong>معبد هندوسي</strong> – زيارة ثقافية</li>
                <li><strong>أمبولوواوا</strong> – نزهة هادئة</li>
                <li><strong>حدائق النباتات الملكية</strong> – جنة استوائية</li>
                <li><strong>مصنع الشاي</strong> – تجربة شاي سيلان</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الثالث:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>نيليغالا</strong> – زيارة مقدسة</li>
                <li><strong>مصنع المجوهرات والأحجار</strong> – بريق الصناعة التقليدية</li>
                <li><strong>ركوب الفيلة</strong> – تفاعل أخلاقي</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الرابع:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>صخرة الأسد سيجيريا</strong> – موقع تراث عالمي لليونسكو</li>
                <li><strong>جولة مدينة بولوناروا الأثرية</strong> – مدينة ثقافية</li>
            </ul>`
                },
                '20': {
                    title: 'يالا / إيلا / نوارا إليا / كاندي / سيجيريا / بولوناروا / أنورادابورا الثقافية',
                    duration: '5 أيام',
                    category: 'ثقافية ومناظر طبيعية',
                    description: 'من التلال الضبابية إلى المعابد المقدسة — رحلة روحية في قلب سريلانكا.',
                    itinerary: `<h3>اليوم الأول:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>سفاري منتزه يالا الوطني</strong> – جولة جيب صباحية</li>
                <li><strong>شلال رافانا</strong> – غطسة سريعة</li>
                <li><strong>جسر الأقواس التسعة</strong> – عبور القطار</li>
                <li><strong>قمة ليتل آدمز</strong> – تسلق خلاب</li>
                <li><strong>رحلة قطار فاخرة</strong></li>
            </ul>
            <h3 class="mt-4">اليوم الثاني:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>مزارع الشاي</strong> – إطلالات من القمة</li>
                <li><strong>معبد هندوسي</strong> – زيارة ثقافية</li>
                <li><strong>أمبولوواوا</strong> – نزهة هادئة</li>
                <li><strong>حدائق النباتات الملكية</strong> – جنة استوائية</li>
                <li><strong>مصنع الشاي</strong> – تجربة شاي سيلان</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الثالث:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>نيليغالا</strong> – زيارة مقدسة</li>
                <li><strong>مصنع المجوهرات والأحجار</strong> – بريق الصناعة التقليدية</li>
                <li><strong>ركوب الفيلة</strong> – تفاعل أخلاقي</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الرابع:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>صخرة الأسد سيجيريا</strong> – موقع تراث عالمي لليونسكو</li>
                <li><strong>جولة مدينة بولوناروا الأثرية</strong> – مدينة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الخامس:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>جولة مدينة أنورادابورا الأثرية</strong> – استكشاف تاريخي</li>
            </ul>`
                },
                '21': {
                    title: 'يالا / إيلا / نوارا إليا / كاندي / سيجيريا / بولوناروا / كولومبو الثقافية',
                    duration: '5 أيام',
                    category: 'ثقافية ومناظر طبيعية',
                    description: 'من التلال الضبابية إلى المعابد المقدسة — رحلة روحية في قلب سريلانكا.',
                    itinerary: `<h3>اليوم الأول:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>سفاري منتزه يالا الوطني</strong> – جولة جيب صباحية</li>
                <li><strong>شلال رافانا</strong> – غطسة سريعة</li>
                <li><strong>جسر الأقواس التسعة</strong> – عبور القطار</li>
                <li><strong>قمة ليتل آدمز</strong> – تسلق خلاب</li>
                <li><strong>رحلة قطار فاخرة</strong></li>
            </ul>
            <h3 class="mt-4">اليوم الثاني:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>مزارع الشاي</strong> – إطلالات من القمة</li>
                <li><strong>معبد هندوسي</strong> – زيارة ثقافية</li>
                <li><strong>أمبولوواوا</strong> – نزهة هادئة</li>
                <li><strong>حدائق النباتات الملكية</strong> – جنة استوائية</li>
                <li><strong>مصنع الشاي</strong> – تجربة شاي سيلان</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الثالث:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>نيليغالا</strong> – زيارة مقدسة</li>
                <li><strong>مصنع المجوهرات والأحجار</strong> – بريق الصناعة التقليدية</li>
                <li><strong>ركوب الفيلة</strong> – تفاعل أخلاقي</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الرابع:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>صخرة الأسد سيجيريا</strong> – موقع تراث عالمي لليونسكو</li>
                <li><strong>جولة مدينة بولوناروا الأثرية</strong> – مدينة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الخامس:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>جولة مدينة كولومبو</strong> – استكشاف حضري</li>
            </ul>`
                },
                '22': {
                    title: 'يالا / إيلا / نوارا إليا / كاندي / سيجيريا / بولوناروا / غالي الثقافية',
                    duration: '5 أيام',
                    category: 'ثقافية ومناظر طبيعية',
                    description: 'من التلال الضبابية إلى المعابد المقدسة — رحلة روحية في قلب سريلانكا.',
                    itinerary: `<h3>اليوم الأول:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>سفاري منتزه يالا الوطني</strong> – جولة جيب صباحية</li>
                <li><strong>شلال رافانا</strong> – غطسة سريعة</li>
                <li><strong>جسر الأقواس التسعة</strong> – عبور القطار</li>
                <li><strong>قمة ليتل آدمز</strong> – تسلق خلاب</li>
                <li><strong>رحلة قطار فاخرة</strong></li>
            </ul>
            <h3 class="mt-4">اليوم الثاني:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>مزارع الشاي</strong> – إطلالات من القمة</li>
                <li><strong>معبد هندوسي</strong> – زيارة ثقافية</li>
                <li><strong>أمبولوواوا</strong> – نزهة هادئة</li>
                <li><strong>حدائق النباتات الملكية</strong> – جنة استوائية</li>
                <li><strong>مصنع الشاي</strong> – تجربة شاي سيلان</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الثالث:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>نيليغالا</strong> – زيارة مقدسة</li>
                <li><strong>مصنع المجوهرات والأحجار</strong> – بريق الصناعة التقليدية</li>
                <li><strong>ركوب الفيلة</strong> – تفاعل أخلاقي</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الرابع:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>صخرة الأسد سيجيريا</strong> – موقع تراث عالمي لليونسكو</li>
                <li><strong>جولة مدينة بولوناروا الأثرية</strong> – مدينة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الخامس:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>مدينة غالي</strong> – استكشاف استعماري</li>
            </ul>`
                },
                '23': {
                    title: 'إيلا / نوارا إليا / كاندي / سيجيريا / بولوناروا / أنورادابورا / كولومبو',
                    duration: '6 أيام',
                    category: 'ثقافية ومناظر طبيعية',
                    description: 'من التلال الضبابية إلى المعابد المقدسة — رحلة روحية في قلب سريلانكا.',
                    itinerary: `<h3>اليوم الأول:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>شلال رافانا</strong> – غطسة سريعة</li>
                <li><strong>جسر الأقواس التسعة</strong> – عبور القطار</li>
                <li><strong>قمة ليتل آدمز</strong> – تسلق خلاب</li>
                <li><strong>رحلة قطار فاخرة</strong></li>
            </ul>
            <h3 class="mt-4">اليوم الثاني:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>مزارع الشاي</strong> – إطلالات من القمة</li>
                <li><strong>معبد هندوسي</strong> – زيارة ثقافية</li>
                <li><strong>أمبولوواوا</strong> – نزهة هادئة</li>
                <li><strong>حدائق النباتات الملكية</strong> – جنة استوائية</li>
                <li><strong>مصنع الشاي</strong> – تجربة شاي سيلان</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الثالث:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>نيليغالا</strong> – زيارة مقدسة</li>
                <li><strong>مصنع المجوهرات والأحجار</strong> – بريق الصناعة التقليدية</li>
                <li><strong>ركوب الفيلة</strong> – تفاعل أخلاقي</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الرابع:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>صخرة الأسد سيجيريا</strong> – موقع تراث عالمي لليونسكو</li>
                <li><strong>جولة مدينة بولوناروا الأثرية</strong> – مدينة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الخامس:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>جولة مدينة أنورادابورا الأثرية</strong> – استكشاف تاريخي</li>
            </ul>
            <h3 class="mt-4">اليوم السادس:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>جولة مدينة كولومبو</strong> – استكشاف حضري</li>
                <li><strong>مدينة غالي</strong> – استكشاف استعماري</li>
            </ul>`
                },
                '24': {
                    title: 'إيلا / نوارا إليا / كاندي / سيجيريا / بولوناروا / أنورادابورا / كولومبو',
                    duration: '6 أيام',
                    category: 'ثقافية ومناظر طبيعية',
                    description: 'من التلال الضبابية إلى المعابد المقدسة — رحلة روحية في قلب سريلانكا.',
                    itinerary: `<h3>اليوم الأول:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>شلال رافانا</strong> – غطسة سريعة</li>
                <li><strong>جسر الأقواس التسعة</strong> – عبور القطار</li>
                <li><strong>قمة ليتل آدمز</strong> – تسلق خلاب</li>
                <li><strong>رحلة قطار فاخرة</strong></li>
            </ul>
            <h3 class="mt-4">اليوم الثاني:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>مزارع الشاي</strong> – إطلالات من القمة</li>
                <li><strong>معبد هندوسي</strong> – زيارة ثقافية</li>
                <li><strong>أمبولوواوا</strong> – نزهة هادئة</li>
                <li><strong>حدائق النباتات الملكية</strong> – جنة استوائية</li>
                <li><strong>مصنع الشاي</strong> – تجربة شاي سيلان</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الثالث:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>نيليغالا</strong> – زيارة مقدسة</li>
                <li><strong>مصنع المجوهرات والأحجار</strong> – بريق الصناعة التقليدية</li>
                <li><strong>ركوب الفيلة</strong> – تفاعل أخلاقي</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الرابع:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>صخرة الأسد سيجيريا</strong> – موقع تراث عالمي لليونسكو</li>
                <li><strong>جولة مدينة بولوناروا الأثرية</strong> – مدينة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الخامس:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>جولة مدينة أنورادابورا الأثرية</strong> – استكشاف تاريخي</li>
            </ul>
            <h3 class="mt-4">اليوم السادس:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>جولة مدينة كولومبو</strong> – استكشاف حضري</li>
            </ul>`
                },
                '25': {
                    title: 'إيلا / نوارا إليا / كاندي / سيجيريا / بولوناروا / أنورادابورا / غالي',
                    duration: '6 أيام',
                    category: 'ثقافية ومناظر طبيعية',
                    description: 'من التلال الضبابية إلى المعابد المقدسة — رحلة روحية في قلب سريلانكا.',
                    itinerary: `<h3>اليوم الأول:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>شلال رافانا</strong> – غطسة سريعة</li>
                <li><strong>جسر الأقواس التسعة</strong> – عبور القطار</li>
                <li><strong>قمة ليتل آدمز</strong> – تسلق خلاب</li>
                <li><strong>رحلة قطار فاخرة</strong></li>
            </ul>
            <h3 class="mt-4">اليوم الثاني:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>مزارع الشاي</strong> – إطلالات من القمة</li>
                <li><strong>معبد هندوسي</strong> – زيارة ثقافية</li>
                <li><strong>أمبولوواوا</strong> – نزهة هادئة</li>
                <li><strong>حدائق النباتات الملكية</strong> – جنة استوائية</li>
                <li><strong>مصنع الشاي</strong> – تجربة شاي سيلان</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الثالث:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>نيليغالا</strong> – زيارة مقدسة</li>
                <li><strong>مصنع المجوهرات والأحجار</strong> – بريق الصناعة التقليدية</li>
                <li><strong>ركوب الفيلة</strong> – تفاعل أخلاقي</li>
                <li><strong>المعبد الذهبي</strong> – زيارة ثقافية</li>
            </ul12>
            <h3 class="mt-4">اليوم الرابع:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>صخرة الأسد سيجيريا</strong> – موقع تراث عالمي لليونسكو</li>
                <li><strong>جولة مدينة بولوناروا الأثرية</strong> – مدينة ثقافية</li>
            </ul>
            <h3 class="mt-4">اليوم الخامس:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>جولة مدينة أنورادابورا الأثرية</strong> – استكشاف تاريخي</li>
            </ul>
            <h3 class="mt-4">اليوم السادس:</h3>
            <ul class="space-y-2 text-sm md:text-base">
                <li><strong>مدينة غالي</strong> – استكشاف استعماري</li>
            </ul>`
                },
            },
        },
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
    });

export default i18n;